export const data = [
  //1
  {
    key: "c6-01",
    title: "나는 세균맨이 싫어요",
    grade: "1권",
    cover: require("@data/assets/navy/book1/images/cover.jpg"),
    background: require("@data/assets/navy/book1/pages/page05.jpg"),
    song: {
      url: require("@data/assets/navy/book1/sounds/page23.mp3"),
      title: "Kuài xǐ shǒu ba!",
      caption: [
        "kuài xǐ shǒu ba bù bù wǒ bù xǐ shǒu",
        "kuài shuā yá ba bù bù wǒ bù shuā yá",
        "kuài xǐ zǎo  ba bù bù wǒ bù xǐ zǎo",
        "kuài chī yào ba bù bù wǒ bù chī yào",
        "wū wū wū wǒ shēng bìng le wǒ shēng bìng le",
        "kuài xǐ shǒu ba ng ng wǒ xǐ shǒu",
        "kuài shuā yá ba ng ng wǒ shuā yá",
        "kuài xǐ zǎo ba ng ng  wǒ xǐ zǎo",
        "kuài chī yào ba ng ng wǒ chī yào",
        "hā hā hā wǒ hěn jiànkāng wǒ hěn jiànkāng",
      ],
    },
    mov: {
      cn: "1ebce7f3c824b97cd7800a8cb4429d04_01",
      en: "1490054cee4eb25a560e87e4f1821d3f_01",
    },
    game: {
      resources: [
        {
          img: require("@data/assets/navy/book1/images/img_N1-02.png"),
          sound: require("@data/assets/navy/book1/sounds/KF01_W_01.mp3"),
          word: "洗手|xǐ shǒu",
        },
        {
          img: require("@data/assets/navy/book1/images/img_N1-01.png"),
          sound: require("@data/assets/navy/book1/sounds/KF01_W_02.mp3"),
          word: "刷牙|shuā yá",
        },
        {
          img: require("@data/assets/navy/book1/images/img_N1-04.png"),
          sound: require("@data/assets/navy/book1/sounds/KF01_W_03.mp3"),
          word: "洗澡|xǐ zǎo",
        },
        {
          img: require("@data/assets/navy/book1/images/img_N1-03.png"),
          sound: require("@data/assets/navy/book1/sounds/KF01_W_04.mp3"),
          word: "吃药|chī yào",
        },
        {
          img: require("@data/assets/navy/book1/images/img_N1-06.png"),
          sound: require("@data/assets/navy/book1/sounds/KF01_W_05.mp3"),
          word: "快洗手吧!|Kuài xǐ shǒu ba!",
        },
        {
          img: require("@data/assets/navy/book1/images/img_N1-05.png"),
          sound: require("@data/assets/navy/book1/sounds/KF01_W_06.mp3"),
          word: "快刷牙吧!|Kuài shuā yá ba!",
        },
        {
          img: require("@data/assets/navy/book1/images/img_N1-08.png"),
          sound: require("@data/assets/navy/book1/sounds/KF01_W_07.mp3"),
          word: "快洗澡吧!|Kuài xǐ zǎo ba!",
        },
        {
          img: require("@data/assets/navy/book1/images/img_N1-07.png"),
          sound: require("@data/assets/navy/book1/sounds/KF01_W_08.mp3"),
          word: "快吃药吧!|Kuài chī yào ba!",
        },
        {
          img: require("@data/assets/navy/book1/images/img_N1-10.png"),
          sound: require("@data/assets/navy/book1/sounds/KF01_W_09.mp3"),
          word: "我(不)洗手!|Wǒ (bù) xǐ shǒu!",
        },
        {
          img: require("@data/assets/navy/book1/images/img_N1-09.png"),
          sound: require("@data/assets/navy/book1/sounds/KF01_W_10.mp3"),
          word: "我(不)刷牙!|Wǒ (bù) shuā yá!",
        },
        {
          img: require("@data/assets/navy/book1/images/img_N1-12.png"),
          sound: require("@data/assets/navy/book1/sounds/KF01_W_11.mp3"),
          word: "我(不)洗澡!|Wǒ (bù) xǐ zǎo!",
        },
        {
          img: require("@data/assets/navy/book1/images/img_N1-11.png"),
          sound: require("@data/assets/navy/book1/sounds/KF01_W_12.mp3"),
          word: "我(不)吃药!|Wǒ (bù) chī yào!",
        },
        {
          img: require("@data/assets/navy/book1/images/img_N1-14.png"),
          sound: require("@data/assets/navy/book1/sounds/KF01_W_13.mp3"),
          word: "你好!|Nǐ hǎo!",
        },
        {
          img: require("@data/assets/navy/book1/images/img_N1-13.png"),
          sound: require("@data/assets/navy/book1/sounds/KF01_W_14.mp3"),
          word: "真好玩儿!|Zhēn hǎowánr!",
        },
        {
          img: require("@data/assets/navy/book1/images/img_N1-16.png"),
          sound: require("@data/assets/navy/book1/sounds/KF01_W_15.mp3"),
          word: "我肚子疼。|Wǒ dùzi téng.",
        },
        {
          img: require("@data/assets/navy/book1/images/img_N1-15.png"),
          sound: require("@data/assets/navy/book1/sounds/KF01_W_16.mp3"),
          word: "我牙疼。|Wǒ yá téng.",
        },
        {
          img: require("@data/assets/navy/book1/images/img_N1-18.png"),
          sound: require("@data/assets/navy/book1/sounds/KF01_W_17.mp3"),
          word: "我生病了。|Wǒ shēng bìng le.",
        },
        {
          img: require("@data/assets/navy/book1/images/img_N1-17.png"),
          sound: require("@data/assets/navy/book1/sounds/KF01_W_18.mp3"),
          word: "我很健康!|Wǒ hěn jiànkāng!",
        },
      ],
    },
    word: [
      {
        img: require("@data/assets/navy/book1/images/img_N1-02.png"),
        sound: require("@data/assets/navy/book1/sounds/KF01_W_01.mp3"),
        buttons: [{ ch2: "xǐ shǒu" }, { ch: "洗手" }, { ko: "손을 씻다" }],
      },
      {
        img: require("@data/assets/navy/book1/images/img_N1-01.png"),
        sound: require("@data/assets/navy/book1/sounds/KF01_W_02.mp3"),
        buttons: [{ ch2: "shuā yá" }, { ch: "刷牙" }, { ko: "이를 닦다" }],
      },
      {
        img: require("@data/assets/navy/book1/images/img_N1-04.png"),
        sound: require("@data/assets/navy/book1/sounds/KF01_W_03.mp3"),
        buttons: [{ ch2: "xǐ zǎo" }, { ch: "洗澡" }, { ko: "목욕을 하다" }],
      },
      {
        img: require("@data/assets/navy/book1/images/img_N1-03.png"),
        sound: require("@data/assets/navy/book1/sounds/KF01_W_04.mp3"),
        buttons: [{ ch2: "chī yào" }, { ch: "吃药" }, { ko: "약을 먹다" }],
      },
    ],
    idiom: [
      {
        img: require("@data/assets/navy/book1/images/img_N1-06.png"),
        sound: require("@data/assets/navy/book1/sounds/KF01_W_05.mp3"),
        buttons: [
          { ch2: "Kuài xǐ shǒu ba!" },
          { ch: "快洗手吧!" },
          { ko: "빨리 손을 씻어라!" },
        ],
      },
      {
        img: require("@data/assets/navy/book1/images/img_N1-05.png"),
        sound: require("@data/assets/navy/book1/sounds/KF01_W_06.mp3"),
        buttons: [
          { ch2: "Kuài shuā yá ba!" },
          { ch: "快刷牙吧!" },
          { ko: "빨리 이를 닦아라!" },
        ],
      },
      {
        img: require("@data/assets/navy/book1/images/img_N1-08.png"),
        sound: require("@data/assets/navy/book1/sounds/KF01_W_07.mp3"),
        buttons: [
          { ch2: "Kuài xǐ zǎo ba!" },
          { ch: "快洗澡吧!" },
          { ko: "빨리 목욕을 해라." },
        ],
      },
      {
        img: require("@data/assets/navy/book1/images/img_N1-07.png"),
        sound: require("@data/assets/navy/book1/sounds/KF01_W_08.mp3"),
        buttons: [
          { ch2: "Kuài chī yào ba!" },
          { ch: "快吃药吧!" },
          { ko: "빨리 약을 먹어라!" },
        ],
      },
      {
        img: require("@data/assets/navy/book1/images/img_N1-10.png"),
        sound: require("@data/assets/navy/book1/sounds/KF01_W_09.mp3"),
        buttons: [
          { ch2: "Wǒ xǐ shǒu!<br>Wǒ bù xǐ shǒu!" },
          { ch: "我洗手!<br>我不洗手!" },
          { ko: "나는 손을 씻어요.<br>나는 손을 안 씻어요." },
        ],
      },
      {
        img: require("@data/assets/navy/book1/images/img_N1-09.png"),
        sound: require("@data/assets/navy/book1/sounds/KF01_W_10.mp3"),
        buttons: [
          { ch2: "Wǒ shuā yá!<br>Wǒ bù shuā yá!" },
          { ch: "我刷牙!<br>我不刷牙!" },
          { ko: "나는 이를 닦아요.<br>나는 이를 안 닦아요." },
        ],
      },
      {
        img: require("@data/assets/navy/book1/images/img_N1-12.png"),
        sound: require("@data/assets/navy/book1/sounds/KF01_W_11.mp3"),
        buttons: [
          { ch2: "Wǒ xǐ zǎo!<br>Wǒ bù xǐ zǎo!" },
          { ch: "我洗澡!<br>我不洗澡!" },
          { ko: "나는 목욕을 해요.<br>나는 목욕을 안 해요." },
        ],
      },
      {
        img: require("@data/assets/navy/book1/images/img_N1-11.png"),
        sound: require("@data/assets/navy/book1/sounds/KF01_W_12.mp3"),
        buttons: [
          { ch2: "Wǒ chī yào!<br>Wǒ bù chī yào!" },
          { ch: "我吃药!<br>我不吃药!" },
          { ko: "나는 약을 먹어요.<br>나는 약을 안 먹어요." },
        ],
      },
      {
        img: require("@data/assets/navy/book1/images/img_N1-14.png"),
        sound: require("@data/assets/navy/book1/sounds/KF01_W_13.mp3"),
        buttons: [{ ch2: "Nǐ hǎo!" }, { ch: "你好!" }, { ko: "안녕!" }],
      },
      {
        img: require("@data/assets/navy/book1/images/img_N1-13.png"),
        sound: require("@data/assets/navy/book1/sounds/KF01_W_14.mp3"),
        buttons: [
          { ch2: "Zhēn hǎowánr!" },
          { ch: "真好玩儿!" },
          { ko: "정말 재미있다!" },
        ],
      },
      {
        img: require("@data/assets/navy/book1/images/img_N1-16.png"),
        sound: require("@data/assets/navy/book1/sounds/KF01_W_15.mp3"),
        buttons: [
          { ch2: "Wǒ dùzi téng." },
          { ch: "我肚子疼。" },
          { ko: "나는 배가 아파." },
        ],
      },
      {
        img: require("@data/assets/navy/book1/images/img_N1-15.png"),
        sound: require("@data/assets/navy/book1/sounds/KF01_W_16.mp3"),
        buttons: [
          { ch2: "Wǒ yá téng." },
          { ch: "我牙疼。" },
          { ko: "나는 이가 아파." },
        ],
      },
      {
        img: require("@data/assets/navy/book1/images/img_N1-18.png"),
        sound: require("@data/assets/navy/book1/sounds/KF01_W_17.mp3"),
        buttons: [
          { ch2: "Wǒ shēng bìng le." },
          { ch: "我生病了。" },
          { ko: "나는 아파." },
        ],
      },
      {
        img: require("@data/assets/navy/book1/images/img_N1-17.png"),
        sound: require("@data/assets/navy/book1/sounds/KF01_W_18.mp3"),
        buttons: [
          { ch2: "Wǒ hěn jiànkāng!" },
          { ch: "我很健康!" },
          { ko: "나는 건강해!" },
        ],
      },
    ],
    activity: {
      questions: [
        {
          type: "ty1",
          sound: require("@data/assets/navy/book1/sounds/KF01_W_02.mp3"),
          img: require("@data/assets/navy/book1/images/img_N1-02.png"),
          answer: {
            O: false,
            X: true,
          },
        },
        {
          type: "ty2",
          sound: require("@data/assets/navy/book1/sounds/KF01_W_07.mp3"),
          answer: [
            [require("@data/assets/navy/book1/images/img_N1-08.png"), true],
            [require("@data/assets/navy/book1/images/img_N1-05.png"), false],
          ],
        },
        {
          type: "ty3",
          sound: require("@data/assets/navy/book1/sounds/KF01_W_01.mp3"),
          answer: [
            ["洗手", true],
            ["吃药", false],
          ],
        },
      ],
    },
    pages: [
      {
        book: require("@data/assets/navy/book1/pages/front.jpg"),
        sound: require("@data/assets/navy/book1/sounds/cover.mp3"),
      },

      {
        book: require("@data/assets/navy/book1/pages/page02.jpg"),
      },
      {
        book: require("@data/assets/navy/book1/pages/page03.jpg"),
      },
      {
        book: require("@data/assets/navy/book1/pages/page04.jpg"),
        sound: require("@data/assets/navy/book1/sounds/page04.mp3"),
      },
      {
        book: require("@data/assets/navy/book1/pages/page05.jpg"),
      },
      {
        book: require("@data/assets/navy/book1/pages/page06.jpg"),
        sound: require("@data/assets/navy/book1/sounds/page06.mp3"),
      },
      {
        book: require("@data/assets/navy/book1/pages/page07.jpg"),
      },
      {
        book: require("@data/assets/navy/book1/pages/page08.jpg"),
        sound: require("@data/assets/navy/book1/sounds/page08.mp3"),
      },
      {
        book: require("@data/assets/navy/book1/pages/page09.jpg"),
      },
      {
        book: require("@data/assets/navy/book1/pages/page10.jpg"),
        sound: require("@data/assets/navy/book1/sounds/page10.mp3"),
      },
      {
        book: require("@data/assets/navy/book1/pages/page11.jpg"),
      },
      {
        book: require("@data/assets/navy/book1/pages/page12.jpg"),
        sound: require("@data/assets/navy/book1/sounds/page12.mp3"),
      },
      {
        book: require("@data/assets/navy/book1/pages/page13.jpg"),
      },
      {
        book: require("@data/assets/navy/book1/pages/page14.jpg"),
        sound: require("@data/assets/navy/book1/sounds/page14.mp3"),
      },
      {
        book: require("@data/assets/navy/book1/pages/page15.jpg"),
      },
      {
        book: require("@data/assets/navy/book1/pages/page16.jpg"),
        sound: require("@data/assets/navy/book1/sounds/page16.mp3"),
      },
      {
        book: require("@data/assets/navy/book1/pages/page17.jpg"),
      },
      {
        book: require("@data/assets/navy/book1/pages/page18.jpg"),
        sound: require("@data/assets/navy/book1/sounds/page18.mp3"),
      },
      {
        book: require("@data/assets/navy/book1/pages/page19.jpg"),
      },
      {
        book: require("@data/assets/navy/book1/pages/page20.jpg"),
        sound: require("@data/assets/navy/book1/sounds/page20.mp3"),
      },
      {
        book: require("@data/assets/navy/book1/pages/page21.jpg"),
      },
      {
        book: require("@data/assets/navy/book1/pages/page22.jpg"),
        sound: require("@data/assets/navy/book1/sounds/page22.mp3"),
      },
      {
        book: require("@data/assets/navy/book1/pages/page23.jpg"),
        sound: require("@data/assets/navy/book1/sounds/page23.mp3"),
      },
      {
        book: require("@data/assets/navy/book1/pages/page24.jpg"),
      },
      {
        book: require("@data/assets/navy/book1/pages/page25.jpg"),
      },
      {
        book: require("@data/assets/navy/book1/pages/page26.jpg"),
      },
      {
        book: require("@data/assets/navy/book1/pages/page27.jpg"),
      },
    ],
    thumbnail: [
      require("@data/assets/navy/book1/thumbnail/front.jpg"),
      require("@data/assets/navy/book1/thumbnail/page02.jpg"),
      require("@data/assets/navy/book1/thumbnail/page03.jpg"),
      require("@data/assets/navy/book1/thumbnail/page04.jpg"),
      require("@data/assets/navy/book1/thumbnail/page05.jpg"),
      require("@data/assets/navy/book1/thumbnail/page06.jpg"),
      require("@data/assets/navy/book1/thumbnail/page07.jpg"),
      require("@data/assets/navy/book1/thumbnail/page08.jpg"),
      require("@data/assets/navy/book1/thumbnail/page09.jpg"),
      require("@data/assets/navy/book1/thumbnail/page10.jpg"),
      require("@data/assets/navy/book1/thumbnail/page11.jpg"),
      require("@data/assets/navy/book1/thumbnail/page12.jpg"),
      require("@data/assets/navy/book1/thumbnail/page13.jpg"),
      require("@data/assets/navy/book1/thumbnail/page14.jpg"),
      require("@data/assets/navy/book1/thumbnail/page15.jpg"),
      require("@data/assets/navy/book1/thumbnail/page16.jpg"),
      require("@data/assets/navy/book1/thumbnail/page17.jpg"),
      require("@data/assets/navy/book1/thumbnail/page18.jpg"),
      require("@data/assets/navy/book1/thumbnail/page19.jpg"),
      require("@data/assets/navy/book1/thumbnail/page20.jpg"),
      require("@data/assets/navy/book1/thumbnail/page21.jpg"),
      require("@data/assets/navy/book1/thumbnail/page22.jpg"),
      require("@data/assets/navy/book1/thumbnail/page23.jpg"),
      require("@data/assets/navy/book1/thumbnail/page24.jpg"),
      require("@data/assets/navy/book1/thumbnail/page25.jpg"),
      require("@data/assets/navy/book1/thumbnail/page26.jpg"),
      require("@data/assets/navy/book1/thumbnail/page27.jpg"),
    ],
  },
  //2
  {
    key: "c6-02",
    title: "초콜릿을 옮기자",
    grade: "2권",
    cover: require("@data/assets/navy/book2/images/cover.jpg"),
    background: require("@data/assets/navy/book2/pages/page05.jpg"),
    song: {
      url: require("@data/assets/navy/book2/sounds/page23.mp3"),
      title: "Wǒmen yìqǐ wánr ba!",
      caption: [
        "wǒmen yìqǐ wánr ba wǒmen yìqǐ wánr ba ",
        "hǎo de hǎo de zhēn hǎo wánr zhēn hǎo wánr",
        "wǒmen yìqǐ ná ba wǒmen yìqǐ ná ba",
        "hǎo de hǎo de xièxie nǐ xièxie nǐ",
        "wǒmen yìqǐ zuò ba wǒmen yìqǐ zuò ba",
        "hǎo de hǎo de hěn yǒu yìsi hěn yǒu yìsi",
        "wǒmen yìqǐ chī ba wǒmen yìqǐ chī ba",
        "hǎo de hǎo de zhēn hǎochī zhēn hǎochī",
      ],
    },
    mov: {
      cn: "dc4e388893a0ab9033fe5735a0635215_02",
      en: "cf294afd8a007e59b3ee8914d62d1215_02",
    },
    game: {
      resources: [
        {
          img: require("@data/assets/navy/book2/images/img_N2-02.png"),
          sound: require("@data/assets/navy/book2/sounds/KF02_W_01.mp3"),
          word: "玩儿|wánr",
        },
        {
          img: require("@data/assets/navy/book2/images/img_N2-01.png"),
          sound: require("@data/assets/navy/book2/sounds/KF02_W_02.mp3"),
          word: "拿|ná",
        },
        {
          img: require("@data/assets/navy/book2/images/img_N2-04.png"),
          sound: require("@data/assets/navy/book2/sounds/KF02_W_03.mp3"),
          word: "做|zuò",
        },
        {
          img: require("@data/assets/navy/book2/images/img_N2-03.png"),
          sound: require("@data/assets/navy/book2/sounds/KF02_W_04.mp3"),
          word: "吃|chī",
        },
        {
          img: require("@data/assets/navy/book2/images/img_N2-06.png"),
          sound: require("@data/assets/navy/book2/sounds/KF02_W_05.mp3"),
          word: "我们一起玩儿吧。|Wǒmen yìqǐ wánr ba.",
        },
        {
          img: require("@data/assets/navy/book2/images/img_N2-05.png"),
          sound: require("@data/assets/navy/book2/sounds/KF02_W_06.mp3"),
          word: "我们一起拿吧。|Wǒmen yìqǐ ná ba.",
        },
        {
          img: require("@data/assets/navy/book2/images/img_N2-08.png"),
          sound: require("@data/assets/navy/book2/sounds/KF02_W_07.mp3"),
          word: "我们一起做吧。|Wǒmen yìqǐ zuò ba.",
        },
        {
          img: require("@data/assets/navy/book2/images/img_N2-07.png"),
          sound: require("@data/assets/navy/book2/sounds/KF02_W_08.mp3"),
          word: "我们一起吃吧。|Wǒmen yìqǐ chī ba.",
        },
        {
          img: require("@data/assets/navy/book2/images/img_N2-10.png"),
          sound: require("@data/assets/navy/book2/sounds/KF02_W_09.mp3"),
          word: "好的。|Hǎo de.",
        },
        {
          img: require("@data/assets/navy/book2/images/img_N2-09.png"),
          sound: require("@data/assets/navy/book2/sounds/KF02_W_10.mp3"),
          word: "这是什么？|Zhè shì shénme?",
        },
        {
          img: require("@data/assets/navy/book2/images/img_N2-12.png"),
          sound: require("@data/assets/navy/book2/sounds/KF02_W_11.mp3"),
          word: "这是巧克力。|Zhè shì qiǎokèlì.",
        },
        {
          img: require("@data/assets/navy/book2/images/img_N2-11.png"),
          sound: require("@data/assets/navy/book2/sounds/KF02_W_12.mp3"),
          word: "这个非常甜。|Zhège fēicháng tián.",
        },
        {
          img: require("@data/assets/navy/book2/images/img_N2-14.png"),
          sound: require("@data/assets/navy/book2/sounds/KF02_W_13.mp3"),
          word: "我来帮助你们。|Wǒ lái bāngzhù nǐmen.",
        },
        {
          img: require("@data/assets/navy/book2/images/img_N2-13.png"),
          sound: require("@data/assets/navy/book2/sounds/KF02_W_14.mp3"),
          word: "谢谢!|Xièxie!",
        },
        {
          img: require("@data/assets/navy/book2/images/img_N2-16.png"),
          sound: require("@data/assets/navy/book2/sounds/KF02_W_15.mp3"),
          word: "小心!|Xiǎoxīn!",
        },
        {
          img: require("@data/assets/navy/book2/images/img_N2-15.png"),
          sound: require("@data/assets/navy/book2/sounds/KF02_W_16.mp3"),
          word: "糟糕!|Zāogāo!",
        },
        {
          img: require("@data/assets/navy/book2/images/img_N2-18.png"),
          sound: require("@data/assets/navy/book2/sounds/KF02_W_17.mp3"),
          word: "好主意!|Hǎo zhǔyi!",
        },
        {
          img: require("@data/assets/navy/book2/images/img_N2-17.png"),
          sound: require("@data/assets/navy/book2/sounds/KF02_W_18.mp3"),
          word: "真好吃!|Zhēn hǎochī!",
        },
      ],
    },
    word: [
      {
        img: require("@data/assets/navy/book2/images/img_N2-02.png"),
        sound: require("@data/assets/navy/book2/sounds/KF02_W_01.mp3"),
        buttons: [{ ch2: "wánr" }, { ch: "玩儿" }, { ko: "놀다" }],
      },
      {
        img: require("@data/assets/navy/book2/images/img_N2-01.png"),
        sound: require("@data/assets/navy/book2/sounds/KF02_W_02.mp3"),
        buttons: [{ ch2: "ná" }, { ch: "拿" }, { ko: "들다" }],
      },
      {
        img: require("@data/assets/navy/book2/images/img_N2-04.png"),
        sound: require("@data/assets/navy/book2/sounds/KF02_W_03.mp3"),
        buttons: [{ ch2: "zuò" }, { ch: "做" }, { ko: "만들다, 하다" }],
      },
      {
        img: require("@data/assets/navy/book2/images/img_N2-03.png"),
        sound: require("@data/assets/navy/book2/sounds/KF02_W_04.mp3"),
        buttons: [{ ch2: "chī" }, { ch: "吃" }, { ko: "먹다" }],
      },
    ],
    idiom: [
      {
        img: require("@data/assets/navy/book2/images/img_N2-06.png"),
        sound: require("@data/assets/navy/book2/sounds/KF02_W_05.mp3"),
        buttons: [
          { ch2: "Wǒmen yìqǐ wánr ba." },
          { ch: "我们一起玩儿吧。" },
          { ko: "우리 함께 놀자." },
        ],
      },
      {
        img: require("@data/assets/navy/book2/images/img_N2-05.png"),
        sound: require("@data/assets/navy/book2/sounds/KF02_W_06.mp3"),
        buttons: [
          { ch2: "Wǒmen yìqǐ ná ba." },
          { ch: "我们一起拿吧。" },
          { ko: "우리 함께 들자." },
        ],
      },
      {
        img: require("@data/assets/navy/book2/images/img_N2-08.png"),
        sound: require("@data/assets/navy/book2/sounds/KF02_W_07.mp3"),
        buttons: [
          { ch2: "Wǒmen yìqǐ zuò ba." },
          { ch: "我们一起做吧。" },
          { ko: "우리 함께 하자." },
        ],
      },
      {
        img: require("@data/assets/navy/book2/images/img_N2-07.png"),
        sound: require("@data/assets/navy/book2/sounds/KF02_W_08.mp3"),
        buttons: [
          { ch2: "Wǒmen yìqǐ chī ba." },
          { ch: "我们一起吃吧。" },
          { ko: "우리 함께 먹자." },
        ],
      },
      {
        img: require("@data/assets/navy/book2/images/img_N2-10.png"),
        sound: require("@data/assets/navy/book2/sounds/KF02_W_09.mp3"),
        buttons: [{ ch2: "Hǎo de." }, { ch: "好的。" }, { ko: "좋아." }],
      },
      {
        img: require("@data/assets/navy/book2/images/img_N2-09.png"),
        sound: require("@data/assets/navy/book2/sounds/KF02_W_10.mp3"),
        buttons: [
          { ch2: "Zhè shì shénme?" },
          { ch: "这是什么？" },
          { ko: "이것은 뭐야?" },
        ],
      },
      {
        img: require("@data/assets/navy/book2/images/img_N2-12.png"),
        sound: require("@data/assets/navy/book2/sounds/KF02_W_11.mp3"),
        buttons: [
          { ch2: "Zhè shì qiǎokèlì." },
          { ch: "这是巧克力。" },
          { ko: "이것은 초콜릿이야." },
        ],
      },
      {
        img: require("@data/assets/navy/book2/images/img_N2-11.png"),
        sound: require("@data/assets/navy/book2/sounds/KF02_W_12.mp3"),
        buttons: [
          { ch2: "Zhège fēicháng tián." },
          { ch: "这个非常甜。" },
          { ko: "이것은 매우 달아." },
        ],
      },
      {
        img: require("@data/assets/navy/book2/images/img_N2-14.png"),
        sound: require("@data/assets/navy/book2/sounds/KF02_W_13.mp3"),
        buttons: [
          { ch2: "Wǒ lái bāngzhù nǐmen." },
          { ch: "我来帮助你们。" },
          { ko: "내가 도와줄게!" },
        ],
      },
      {
        img: require("@data/assets/navy/book2/images/img_N2-13.png"),
        sound: require("@data/assets/navy/book2/sounds/KF02_W_14.mp3"),
        buttons: [{ ch2: "Xièxie!" }, { ch: "谢谢!" }, { ko: "고마워!" }],
      },
      {
        img: require("@data/assets/navy/book2/images/img_N2-16.png"),
        sound: require("@data/assets/navy/book2/sounds/KF02_W_15.mp3"),
        buttons: [{ ch2: "Xiǎoxīn!" }, { ch: "小心!" }, { ko: "조심해!" }],
      },
      {
        img: require("@data/assets/navy/book2/images/img_N2-15.png"),
        sound: require("@data/assets/navy/book2/sounds/KF02_W_16.mp3"),
        buttons: [{ ch2: "Zāogāo!" }, { ch: "糟糕!" }, { ko: "아차!" }],
      },
      {
        img: require("@data/assets/navy/book2/images/img_N2-18.png"),
        sound: require("@data/assets/navy/book2/sounds/KF02_W_17.mp3"),
        buttons: [
          { ch2: "Hǎo zhǔyi!" },
          { ch: "好主意!" },
          { ko: "좋은 생각이야!" },
        ],
      },
      {
        img: require("@data/assets/navy/book2/images/img_N2-17.png"),
        sound: require("@data/assets/navy/book2/sounds/KF02_W_18.mp3"),
        buttons: [
          { ch2: "Zhēn hǎochī!" },
          { ch: "真好吃!" },
          { ko: "정말 맛있어!" },
        ],
      },
    ],
    activity: {
      questions: [
        {
          type: "ty1",
          sound: require("@data/assets/navy/book2/sounds/KF02_W_02.mp3"),
          img: require("@data/assets/navy/book2/images/img_N2-01.png"),
          answer: {
            O: true,
            X: false,
          },
        },
        {
          type: "ty2",
          sound: require("@data/assets/navy/book2/sounds/KF02_W_08.mp3"),
          answer: [
            [require("@data/assets/navy/book2/images/img_N2-07.png"), true],
            [require("@data/assets/navy/book2/images/img_N2-08.png"), false],
          ],
        },
        {
          type: "ty3",
          sound: require("@data/assets/navy/book2/sounds/KF02_W_03.mp3"),
          answer: [
            ["玩儿", false],
            ["做", true],
          ],
        },
      ],
    },
    pages: [
      {
        book: require("@data/assets/navy/book2/pages/front.jpg"),
        sound: require("@data/assets/navy/book2/sounds/cover.mp3"),
      },

      {
        book: require("@data/assets/navy/book2/pages/page02.jpg"),
      },
      {
        book: require("@data/assets/navy/book2/pages/page03.jpg"),
      },
      {
        book: require("@data/assets/navy/book2/pages/page04.jpg"),
        sound: require("@data/assets/navy/book2/sounds/page04.mp3"),
      },
      {
        book: require("@data/assets/navy/book2/pages/page05.jpg"),
      },
      {
        book: require("@data/assets/navy/book2/pages/page06.jpg"),
        sound: require("@data/assets/navy/book2/sounds/page06.mp3"),
      },
      {
        book: require("@data/assets/navy/book2/pages/page07.jpg"),
      },
      {
        book: require("@data/assets/navy/book2/pages/page08.jpg"),
        sound: require("@data/assets/navy/book2/sounds/page08.mp3"),
      },
      {
        book: require("@data/assets/navy/book2/pages/page09.jpg"),
      },
      {
        book: require("@data/assets/navy/book2/pages/page10.jpg"),
        sound: require("@data/assets/navy/book2/sounds/page10.mp3"),
      },
      {
        book: require("@data/assets/navy/book2/pages/page11.jpg"),
      },
      {
        book: require("@data/assets/navy/book2/pages/page12.jpg"),
        sound: require("@data/assets/navy/book2/sounds/page12.mp3"),
      },
      {
        book: require("@data/assets/navy/book2/pages/page13.jpg"),
      },
      {
        book: require("@data/assets/navy/book2/pages/page14.jpg"),
        sound: require("@data/assets/navy/book2/sounds/page14.mp3"),
      },
      {
        book: require("@data/assets/navy/book2/pages/page15.jpg"),
      },
      {
        book: require("@data/assets/navy/book2/pages/page16.jpg"),
        sound: require("@data/assets/navy/book2/sounds/page16.mp3"),
      },
      {
        book: require("@data/assets/navy/book2/pages/page17.jpg"),
      },
      {
        book: require("@data/assets/navy/book2/pages/page18.jpg"),
        sound: require("@data/assets/navy/book2/sounds/page18.mp3"),
      },
      {
        book: require("@data/assets/navy/book2/pages/page19.jpg"),
      },
      {
        book: require("@data/assets/navy/book2/pages/page20.jpg"),
        sound: require("@data/assets/navy/book2/sounds/page20.mp3"),
      },
      {
        book: require("@data/assets/navy/book2/pages/page21.jpg"),
      },
      {
        book: require("@data/assets/navy/book2/pages/page22.jpg"),
        sound: require("@data/assets/navy/book2/sounds/page22.mp3"),
      },
      {
        book: require("@data/assets/navy/book2/pages/page23.jpg"),
        sound: require("@data/assets/navy/book2/sounds/page23.mp3"),
      },
      {
        book: require("@data/assets/navy/book2/pages/page24.jpg"),
      },
      {
        book: require("@data/assets/navy/book2/pages/page25.jpg"),
      },
      {
        book: require("@data/assets/navy/book2/pages/page26.jpg"),
      },
      {
        book: require("@data/assets/navy/book2/pages/page27.jpg"),
      },
    ],
    thumbnail: [
      require("@data/assets/navy/book2/thumbnail/front.jpg"),
      require("@data/assets/navy/book2/thumbnail/page02.jpg"),
      require("@data/assets/navy/book2/thumbnail/page03.jpg"),
      require("@data/assets/navy/book2/thumbnail/page04.jpg"),
      require("@data/assets/navy/book2/thumbnail/page05.jpg"),
      require("@data/assets/navy/book2/thumbnail/page06.jpg"),
      require("@data/assets/navy/book2/thumbnail/page07.jpg"),
      require("@data/assets/navy/book2/thumbnail/page08.jpg"),
      require("@data/assets/navy/book2/thumbnail/page09.jpg"),
      require("@data/assets/navy/book2/thumbnail/page10.jpg"),
      require("@data/assets/navy/book2/thumbnail/page11.jpg"),
      require("@data/assets/navy/book2/thumbnail/page12.jpg"),
      require("@data/assets/navy/book2/thumbnail/page13.jpg"),
      require("@data/assets/navy/book2/thumbnail/page14.jpg"),
      require("@data/assets/navy/book2/thumbnail/page15.jpg"),
      require("@data/assets/navy/book2/thumbnail/page16.jpg"),
      require("@data/assets/navy/book2/thumbnail/page17.jpg"),
      require("@data/assets/navy/book2/thumbnail/page18.jpg"),
      require("@data/assets/navy/book2/thumbnail/page19.jpg"),
      require("@data/assets/navy/book2/thumbnail/page20.jpg"),
      require("@data/assets/navy/book2/thumbnail/page21.jpg"),
      require("@data/assets/navy/book2/thumbnail/page22.jpg"),
      require("@data/assets/navy/book2/thumbnail/page23.jpg"),
      require("@data/assets/navy/book2/thumbnail/page24.jpg"),
      require("@data/assets/navy/book2/thumbnail/page25.jpg"),
      require("@data/assets/navy/book2/thumbnail/page26.jpg"),
      require("@data/assets/navy/book2/thumbnail/page27.jpg"),
    ],
  },
  //3
  {
    key: "c6-03",
    title: "미루면 안돼요",
    grade: "3권",
    cover: require("@data/assets/navy/book3/images/cover.jpg"),
    background: require("@data/assets/navy/book3/pages/page05.jpg"),
    song: {
      url: require("@data/assets/navy/book3/sounds/page23.mp3"),
      title: "Nǐ zài zuò shénme ne?",
      caption: [
        "nǐ zài zuò shénme ne  wánr qiú wǒ zài wánr qiú ne",
        "nǐ zài zuò shénme ne  wánr yóuxì  wǒ zài wánr yóuxì ne",
        "wánr qiú wánr yóuxì zhēn hǎo wánr",
        "nǐ zài zuò shénme ne   kàn diànshì wǒ zài kàn diànshì ne",
        "nǐ zài zuò shénme ne  zuò zuòyè  wǒ zài zuò zuòyè ne",
        "kàn diànshì   zuò zuòyè  zhēn kāixīn",
      ],
    },
    mov: {
      cn: "cc3185b2b12e6793531b28749752578e_03",
      en: "8b3372c10c9f27a621cb3e34d47906d8_03",
    },
    game: {
      resources: [
        {
          img: require("@data/assets/navy/book3/images/img_N3-02.png"),
          sound: require("@data/assets/navy/book3/sounds/KF03_W_01.mp3"),
          word: "玩儿球|wánr qiú",
        },
        {
          img: require("@data/assets/navy/book3/images/img_N3-01.png"),
          sound: require("@data/assets/navy/book3/sounds/KF03_W_02.mp3"),
          word: "玩儿游戏|wánr yóuxì",
        },
        {
          img: require("@data/assets/navy/book3/images/img_N3-04.png"),
          sound: require("@data/assets/navy/book3/sounds/KF03_W_03.mp3"),
          word: "看电视|kàn diànshì",
        },
        {
          img: require("@data/assets/navy/book3/images/img_N3-03.png"),
          sound: require("@data/assets/navy/book3/sounds/KF03_W_04.mp3"),
          word: "做作业|zuò zuòyè",
        },
        {
          img: require("@data/assets/navy/book3/images/img_N3-06.png"),
          sound: require("@data/assets/navy/book3/sounds/KF03_W_05.mp3"),
          word: "你在做什么呢？|Nǐ zài zuò shénme ne?",
        },
        {
          img: require("@data/assets/navy/book3/images/img_N3-05.png"),
          sound: require("@data/assets/navy/book3/sounds/KF03_W_06.mp3"),
          word: "我在玩儿球呢。|Wǒ zài wánr qiú ne.",
        },
        {
          img: require("@data/assets/navy/book3/images/img_N3-08.png"),
          sound: require("@data/assets/navy/book3/sounds/KF03_W_07.mp3"),
          word: "我在玩儿游戏呢。|Wǒ zài wánr yóuxì ne.",
        },
        {
          img: require("@data/assets/navy/book3/images/img_N3-07.png"),
          sound: require("@data/assets/navy/book3/sounds/KF03_W_08.mp3"),
          word: "我在看电视呢。|Wǒ zài kàn diànshì ne.",
        },
        {
          img: require("@data/assets/navy/book3/images/img_N3-10.png"),
          sound: require("@data/assets/navy/book3/sounds/KF03_W_09.mp3"),
          word: "我在做作业呢。|Wǒ zài zuò zuòyè ne.",
        },
        {
          img: require("@data/assets/navy/book3/images/img_N3-09.png"),
          sound: require("@data/assets/navy/book3/sounds/KF03_W_10.mp3"),
          word: "我喜欢蝴蝶。|Wǒ xǐhuan húdié.",
        },
        /*
        {
          img: require("@data/assets/navy/book3/images/img_N3-12.png"),
          sound: require("@data/assets/navy/book3/sounds/KF03_W_11.mp3"),
          word: "我喜欢玩儿游戏。|Wǒ xǐhuan wánr yóuxì.",
        },
        */
        {
          img: require("@data/assets/navy/book3/images/img_N3-11.png"),
          sound: require("@data/assets/navy/book3/sounds/KF03_W_12.mp3"),
          word: "很困!|Hěn kùn!",
        },
        {
          img: require("@data/assets/navy/book3/images/img_N3-14.png"),
          sound: require("@data/assets/navy/book3/sounds/KF03_W_13.mp3"),
          word: "很惭愧!|Hěn cánkuì!",
        },
        {
          img: require("@data/assets/navy/book3/images/img_N3-13.png"),
          sound: require("@data/assets/navy/book3/sounds/KF03_W_14.mp3"),
          word: "怎么办？|Zěnme bàn?",
        },
        {
          img: require("@data/assets/navy/book3/images/img_N3-16.png"),
          sound: require("@data/assets/navy/book3/sounds/KF03_W_15.mp3"),
          word: "谢谢!|Xièxie!",
        },
        {
          img: require("@data/assets/navy/book3/images/img_N3-15.png"),
          sound: require("@data/assets/navy/book3/sounds/KF03_W_16.mp3"),
          word: "不客气!|Búkèqi!",
        },
      ],
    },
    word: [
      {
        img: require("@data/assets/navy/book3/images/img_N3-02.png"),
        sound: require("@data/assets/navy/book3/sounds/KF03_W_01.mp3"),
        buttons: [
          { ch2: "wánr qiú" },
          { ch: "玩儿球" },
          { ko: "공놀이를 하다" },
        ],
      },
      {
        img: require("@data/assets/navy/book3/images/img_N3-01.png"),
        sound: require("@data/assets/navy/book3/sounds/KF03_W_02.mp3"),
        buttons: [
          { ch2: "wánr yóuxì" },
          { ch: "玩儿游戏" },
          { ko: "게임을 하다" },
        ],
      },
      {
        img: require("@data/assets/navy/book3/images/img_N3-04.png"),
        sound: require("@data/assets/navy/book3/sounds/KF03_W_03.mp3"),
        buttons: [
          { ch2: "kàn diànshì" },
          { ch: "看电视" },
          { ko: "텔레비전을 보다" },
        ],
      },
      {
        img: require("@data/assets/navy/book3/images/img_N3-03.png"),
        sound: require("@data/assets/navy/book3/sounds/KF03_W_04.mp3"),
        buttons: [
          { ch2: "zuò zuòyè" },
          { ch: "做作业" },
          { ko: "숙제를 하다" },
        ],
      },
    ],
    idiom: [
      {
        img: require("@data/assets/navy/book3/images/img_N3-06.png"),
        sound: require("@data/assets/navy/book3/sounds/KF03_W_05.mp3"),
        buttons: [
          { ch2: "Nǐ zài zuò shénme ne?" },
          { ch: "你在做什么呢？" },
          { ko: "너는 뭐 하고 있니?" },
        ],
      },
      {
        img: require("@data/assets/navy/book3/images/img_N3-05.png"),
        sound: require("@data/assets/navy/book3/sounds/KF03_W_06.mp3"),
        buttons: [
          { ch2: "Wǒ zài wánr qiú ne." },
          { ch: "我在玩儿球呢。" },
          { ko: "나는 공놀이를 하고 있어." },
        ],
      },
      {
        img: require("@data/assets/navy/book3/images/img_N3-08.png"),
        sound: require("@data/assets/navy/book3/sounds/KF03_W_07.mp3"),
        buttons: [
          { ch2: "Wǒ zài wánr yóuxì ne." },
          { ch: "我在玩儿游戏呢。" },
          { ko: "나는 게임을 하고 있어." },
        ],
      },
      {
        img: require("@data/assets/navy/book3/images/img_N3-07.png"),
        sound: require("@data/assets/navy/book3/sounds/KF03_W_08.mp3"),
        buttons: [
          { ch2: "Wǒ zài kàn diànshì ne." },
          { ch: "我在看电视呢。" },
          { ko: "나는 텔레비전을 보고 있어." },
        ],
      },
      {
        img: require("@data/assets/navy/book3/images/img_N3-10.png"),
        sound: require("@data/assets/navy/book3/sounds/KF03_W_09.mp3"),
        buttons: [
          { ch2: "Wǒ zài zuò zuòyè ne." },
          { ch: "我在做作业呢。" },
          { ko: "나는 숙제를 하고 있어." },
        ],
      },
      {
        img: require("@data/assets/navy/book3/images/img_N3-09.png"),
        sound: require("@data/assets/navy/book3/sounds/KF03_W_10.mp3"),
        buttons: [
          { ch2: "Wǒ xǐhuan húdié." },
          { ch: "我喜欢蝴蝶。" },
          { ko: "나는 나비를 좋아해." },
        ],
      },
      {
        img: require("@data/assets/navy/book3/images/img_N3-12.png"),
        sound: require("@data/assets/navy/book3/sounds/KF03_W_11.mp3"),
        buttons: [
          { ch2: "Wǒ xǐhuan wánr yóuxì." },
          { ch: "我喜欢玩儿游戏。" },
          { ko: "나는 게임을 하는 걸 좋아해." },
        ],
      },
      {
        img: require("@data/assets/navy/book3/images/img_N3-11.png"),
        sound: require("@data/assets/navy/book3/sounds/KF03_W_12.mp3"),
        buttons: [{ ch2: "Hěn kùn!" }, { ch: "很困!" }, { ko: "졸려!" }],
      },
      {
        img: require("@data/assets/navy/book3/images/img_N3-14.png"),
        sound: require("@data/assets/navy/book3/sounds/KF03_W_13.mp3"),
        buttons: [{ ch2: "Hěn cánkuì!" }, { ch: "很惭愧!" }, { ko: "창피해!" }],
      },
      {
        img: require("@data/assets/navy/book3/images/img_N3-13.png"),
        sound: require("@data/assets/navy/book3/sounds/KF03_W_14.mp3"),
        buttons: [{ ch2: "Zěnme bàn?" }, { ch: "怎么办？" }, { ko: "어떡해?" }],
      },
      {
        img: require("@data/assets/navy/book3/images/img_N3-16.png"),
        sound: require("@data/assets/navy/book3/sounds/KF03_W_15.mp3"),
        buttons: [{ ch2: "Xièxie!" }, { ch: "谢谢!" }, { ko: "고마워!" }],
      },
      {
        img: require("@data/assets/navy/book3/images/img_N3-15.png"),
        sound: require("@data/assets/navy/book3/sounds/KF03_W_16.mp3"),
        buttons: [{ ch2: "Búkèqi!" }, { ch: "不客气!" }, { ko: "천만에!" }],
      },
    ],
    activity: {
      questions: [
        {
          type: "ty1",
          sound: require("@data/assets/navy/book3/sounds/KF03_W_04.mp3"),
          img: require("@data/assets/navy/book3/images/img_N3-03.png"),
          answer: {
            O: true,
            X: false,
          },
        },
        {
          type: "ty2",
          sound: require("@data/assets/navy/book3/sounds/KF03_W_06.mp3"),
          answer: [
            [require("@data/assets/navy/book3/images/img_N3-05.png"), true],
            [require("@data/assets/navy/book3/images/img_N3-07.png"), false],
          ],
        },
        {
          type: "ty3",
          sound: require("@data/assets/navy/book3/sounds/KF03_W_14.mp3"),
          answer: [
            ["怎么办？", true],
            ["不客气!", false],
          ],
        },
      ],
    },
    pages: [
      {
        book: require("@data/assets/navy/book3/pages/front.jpg"),
        sound: require("@data/assets/navy/book3/sounds/cover.mp3"),
      },

      {
        book: require("@data/assets/navy/book3/pages/page02.jpg"),
      },
      {
        book: require("@data/assets/navy/book3/pages/page03.jpg"),
      },
      {
        book: require("@data/assets/navy/book3/pages/page04.jpg"),
        sound: require("@data/assets/navy/book3/sounds/page04.mp3"),
      },
      {
        book: require("@data/assets/navy/book3/pages/page05.jpg"),
      },
      {
        book: require("@data/assets/navy/book3/pages/page06.jpg"),
        sound: require("@data/assets/navy/book3/sounds/page06.mp3"),
      },
      {
        book: require("@data/assets/navy/book3/pages/page07.jpg"),
      },
      {
        book: require("@data/assets/navy/book3/pages/page08.jpg"),
        sound: require("@data/assets/navy/book3/sounds/page08.mp3"),
      },
      {
        book: require("@data/assets/navy/book3/pages/page09.jpg"),
      },
      {
        book: require("@data/assets/navy/book3/pages/page10.jpg"),
        sound: require("@data/assets/navy/book3/sounds/page10.mp3"),
      },
      {
        book: require("@data/assets/navy/book3/pages/page11.jpg"),
      },
      {
        book: require("@data/assets/navy/book3/pages/page12.jpg"),
        sound: require("@data/assets/navy/book3/sounds/page12.mp3"),
      },
      {
        book: require("@data/assets/navy/book3/pages/page13.jpg"),
      },
      {
        book: require("@data/assets/navy/book3/pages/page14.jpg"),
        sound: require("@data/assets/navy/book3/sounds/page14.mp3"),
      },
      {
        book: require("@data/assets/navy/book3/pages/page15.jpg"),
      },
      {
        book: require("@data/assets/navy/book3/pages/page16.jpg"),
        sound: require("@data/assets/navy/book3/sounds/page16.mp3"),
      },
      {
        book: require("@data/assets/navy/book3/pages/page17.jpg"),
      },
      {
        book: require("@data/assets/navy/book3/pages/page18.jpg"),
        sound: require("@data/assets/navy/book3/sounds/page18.mp3"),
      },
      {
        book: require("@data/assets/navy/book3/pages/page19.jpg"),
      },
      {
        book: require("@data/assets/navy/book3/pages/page20.jpg"),
        sound: require("@data/assets/navy/book3/sounds/page20.mp3"),
      },
      {
        book: require("@data/assets/navy/book3/pages/page21.jpg"),
      },
      {
        book: require("@data/assets/navy/book3/pages/page22.jpg"),
        sound: require("@data/assets/navy/book3/sounds/page22.mp3"),
      },
      {
        book: require("@data/assets/navy/book3/pages/page23.jpg"),
        sound: require("@data/assets/navy/book3/sounds/page23.mp3"),
      },
      {
        book: require("@data/assets/navy/book3/pages/page24.jpg"),
      },
      {
        book: require("@data/assets/navy/book3/pages/page25.jpg"),
      },
      {
        book: require("@data/assets/navy/book3/pages/page26.jpg"),
      },
      {
        book: require("@data/assets/navy/book3/pages/page27.jpg"),
      },
    ],
    thumbnail: [
      require("@data/assets/navy/book3/thumbnail/front.jpg"),
      require("@data/assets/navy/book3/thumbnail/page02.jpg"),
      require("@data/assets/navy/book3/thumbnail/page03.jpg"),
      require("@data/assets/navy/book3/thumbnail/page04.jpg"),
      require("@data/assets/navy/book3/thumbnail/page05.jpg"),
      require("@data/assets/navy/book3/thumbnail/page06.jpg"),
      require("@data/assets/navy/book3/thumbnail/page07.jpg"),
      require("@data/assets/navy/book3/thumbnail/page08.jpg"),
      require("@data/assets/navy/book3/thumbnail/page09.jpg"),
      require("@data/assets/navy/book3/thumbnail/page10.jpg"),
      require("@data/assets/navy/book3/thumbnail/page11.jpg"),
      require("@data/assets/navy/book3/thumbnail/page12.jpg"),
      require("@data/assets/navy/book3/thumbnail/page13.jpg"),
      require("@data/assets/navy/book3/thumbnail/page14.jpg"),
      require("@data/assets/navy/book3/thumbnail/page15.jpg"),
      require("@data/assets/navy/book3/thumbnail/page16.jpg"),
      require("@data/assets/navy/book3/thumbnail/page17.jpg"),
      require("@data/assets/navy/book3/thumbnail/page18.jpg"),
      require("@data/assets/navy/book3/thumbnail/page19.jpg"),
      require("@data/assets/navy/book3/thumbnail/page20.jpg"),
      require("@data/assets/navy/book3/thumbnail/page21.jpg"),
      require("@data/assets/navy/book3/thumbnail/page22.jpg"),
      require("@data/assets/navy/book3/thumbnail/page23.jpg"),
      require("@data/assets/navy/book3/thumbnail/page24.jpg"),
      require("@data/assets/navy/book3/thumbnail/page25.jpg"),
      require("@data/assets/navy/book3/thumbnail/page26.jpg"),
      require("@data/assets/navy/book3/thumbnail/page27.jpg"),
    ],
  },
  //4
  {
    key: "c6-04",
    title: "내 꿈은요…",
    grade: "4권",
    cover: require("@data/assets/navy/book4/images/cover.jpg"),
    background: require("@data/assets/navy/book4/pages/page05.jpg"),
    song: {
      url: require("@data/assets/navy/book4/sounds/page23.mp3"),
      title: "Nǐ xiǎng dāng shénme?",
      caption: [
        "nǐ xiǎng dāng shénme  nǐ xiǎng dāng shénme",
        "gēshǒu gēshǒu wǒ xiǎng dāng gēshǒu  jiāyóu",
        "nǐ xiǎng dāng shénme  nǐ xiǎng dāng shénme",
        "yùndòngyuán yùndòngyuán",
        "wǒ xiǎng dāng yùndòngyuán jiāyóu",
        "nǐ xiǎng dāng shénme  nǐ xiǎng dāng shénme",
        "kēxuéjiā kēxuéjiā wǒ xiǎng dāng kēxuéjiā  jiāyóu",
        "nǐ xiǎng dāng shénme  nǐ xiǎng dāng shénme",
        "chúshī  chúshī wǒ xiǎng dāng chúshī jiāyóu",
      ],
    },
    mov: {
      cn: "3e5e8c45bb4351c715e8dd74ed468fd5_04",
      en: "daa62bddb0444876312d74b7d375214b_04",
    },
    game: {
      resources: [
        {
          img: require("@data/assets/navy/book4/images/img_N4-02.png"),
          sound: require("@data/assets/navy/book4/sounds/KF04_W_01.mp3"),
          word: "歌手|gēshǒu",
        },
        {
          img: require("@data/assets/navy/book4/images/img_N4-01.png"),
          sound: require("@data/assets/navy/book4/sounds/KF04_W_02.mp3"),
          word: "运动员|yùndòngyuán",
        },
        {
          img: require("@data/assets/navy/book4/images/img_N4-04.png"),
          sound: require("@data/assets/navy/book4/sounds/KF04_W_03.mp3"),
          word: "科学家|kēxuéjiā",
        },
        {
          img: require("@data/assets/navy/book4/images/img_N4-03.png"),
          sound: require("@data/assets/navy/book4/sounds/KF04_W_04.mp3"),
          word: "厨师|chúshī",
        },
        //

        {
          img: require("@data/assets/navy/book4/images/img_N4-06.png"),
          sound: require("@data/assets/navy/book4/sounds/KF04_W_05.mp3"),
          word: "你想当什么？|Nǐ xiǎng dāng shénme?",
        },
        {
          img: require("@data/assets/navy/book4/images/img_N4-05.png"),
          sound: require("@data/assets/navy/book4/sounds/KF04_W_06.mp3"),
          word: "我想当歌手。|Wǒ xiǎng dāng gēshǒu.",
        },
        {
          img: require("@data/assets/navy/book4/images/img_N4-08.png"),
          sound: require("@data/assets/navy/book4/sounds/KF04_W_07.mp3"),
          word: "我想当运动员。|Wǒ xiǎng dāng yùndòngyuán.",
        },
        {
          img: require("@data/assets/navy/book4/images/img_N4-07.png"),
          sound: require("@data/assets/navy/book4/sounds/KF04_W_08.mp3"),
          word: "我想当科学家。|Wǒ xiǎng dāng kēxuéjiā.",
        },
        {
          img: require("@data/assets/navy/book4/images/img_N4-10.png"),
          sound: require("@data/assets/navy/book4/sounds/KF04_W_09.mp3"),
          word: "我想当厨师。|Wǒ xiǎng dāng chúshī.",
        },
        {
          img: require("@data/assets/navy/book4/images/img_N4-09.png"),
          sound: require("@data/assets/navy/book4/sounds/KF04_W_10.mp3"),
          word: "我们开始上课。|Wǒmen kāishǐ shàngkè.",
        },
        {
          img: require("@data/assets/navy/book4/images/img_N4-12.png"),
          sound: require("@data/assets/navy/book4/sounds/KF04_W_11.mp3"),
          word: "大家好!|Dàjiā hǎo!",
        },
        {
          img: require("@data/assets/navy/book4/images/img_N4-11.png"),
          sound: require("@data/assets/navy/book4/sounds/KF04_W_12.mp3"),
          word: "我是歌手。|Wǒ shì gēshǒu.",
        },
        {
          img: require("@data/assets/navy/book4/images/img_N4-14.png"),
          sound: require("@data/assets/navy/book4/sounds/KF04_W_13.mp3"),
          word: "我是运动员。|Wǒ shì yùndòngyuán.",
        },
        {
          img: require("@data/assets/navy/book4/images/img_N4-13.png"),
          sound: require("@data/assets/navy/book4/sounds/KF04_W_14.mp3"),
          word: "我是科学家。|Wǒ shì kēxuéjiā.",
        },
        {
          img: require("@data/assets/navy/book4/images/img_N4-16.png"),
          sound: require("@data/assets/navy/book4/sounds/KF04_W_15.mp3"),
          word: "我是厨师。|Wǒ shì chúshī.",
        },
        {
          img: require("@data/assets/navy/book4/images/img_N4-15.png"),
          sound: require("@data/assets/navy/book4/sounds/KF04_W_16.mp3"),
          word: "明白了吗？|Míngbai le ma?",
        },
        {
          img: require("@data/assets/navy/book4/images/img_N4-18.png"),
          sound: require("@data/assets/navy/book4/sounds/KF04_W_17.mp3"),
          word: "明白了。|Míngbai le.",
        },
        {
          img: require("@data/assets/navy/book4/images/img_N4-17.png"),
          sound: require("@data/assets/navy/book4/sounds/KF04_W_18.mp3"),
          word: "加油!|Jiāyóu!",
        },
      ],
    },
    word: [
      {
        img: require("@data/assets/navy/book4/images/img_N4-02.png"),
        sound: require("@data/assets/navy/book4/sounds/KF04_W_01.mp3"),
        buttons: [{ ch2: "gēshǒu" }, { ch: "歌手" }, { ko: "가수" }],
      },
      {
        img: require("@data/assets/navy/book4/images/img_N4-01.png"),
        sound: require("@data/assets/navy/book4/sounds/KF04_W_02.mp3"),
        buttons: [{ ch2: "yùndòngyuán" }, { ch: "运动员" }, { ko: "운동선수" }],
      },
      {
        img: require("@data/assets/navy/book4/images/img_N4-04.png"),
        sound: require("@data/assets/navy/book4/sounds/KF04_W_03.mp3"),
        buttons: [{ ch2: "kēxuéjiā" }, { ch: "科学家" }, { ko: "과학자" }],
      },
      {
        img: require("@data/assets/navy/book4/images/img_N4-03.png"),
        sound: require("@data/assets/navy/book4/sounds/KF04_W_04.mp3"),
        buttons: [{ ch2: "chúshī" }, { ch: "厨师" }, { ko: "요리사" }],
      },
    ],
    idiom: [
      {
        img: require("@data/assets/navy/book4/images/img_N4-06.png"),
        sound: require("@data/assets/navy/book4/sounds/KF04_W_05.mp3"),
        buttons: [
          { ch2: "Nǐ xiǎng dāng shénme?" },
          { ch: "你想当什么？" },
          { ko: "너는 뭐가 되고 싶니?" },
        ],
      },
      {
        img: require("@data/assets/navy/book4/images/img_N4-05.png"),
        sound: require("@data/assets/navy/book4/sounds/KF04_W_06.mp3"),
        buttons: [
          { ch2: "Wǒ xiǎng dāng gēshǒu." },
          { ch: "我想当歌手。" },
          { ko: "나는 가수가 되고 싶어." },
        ],
      },
      {
        img: require("@data/assets/navy/book4/images/img_N4-08.png"),
        sound: require("@data/assets/navy/book4/sounds/KF04_W_07.mp3"),
        buttons: [
          { ch2: "Wǒ xiǎng dāng yùndòngyuán." },
          { ch: "我想当运动员。" },
          { ko: "나는 운동선수가 되고 싶어." },
        ],
      },
      {
        img: require("@data/assets/navy/book4/images/img_N4-07.png"),
        sound: require("@data/assets/navy/book4/sounds/KF04_W_08.mp3"),
        buttons: [
          { ch2: "Wǒ xiǎng dāng kēxuéjiā." },
          { ch: "我想当科学家。" },
          { ko: "나는 과학자가 되고 싶어." },
        ],
      },
      {
        img: require("@data/assets/navy/book4/images/img_N4-10.png"),
        sound: require("@data/assets/navy/book4/sounds/KF04_W_09.mp3"),
        buttons: [
          { ch2: "Wǒ xiǎng dāng chúshī." },
          { ch: "我想当厨师。" },
          { ko: "나는 요리사가 되고 싶어." },
        ],
      },
      {
        img: require("@data/assets/navy/book4/images/img_N4-09.png"),
        sound: require("@data/assets/navy/book4/sounds/KF04_W_10.mp3"),
        buttons: [
          { ch2: "Wǒmen kāishǐ shàngkè." },
          { ch: "我们开始上课。" },
          { ko: "우리 수업을 시작합시다." },
        ],
      },
      {
        img: require("@data/assets/navy/book4/images/img_N4-12.png"),
        sound: require("@data/assets/navy/book4/sounds/KF04_W_11.mp3"),
        buttons: [
          { ch2: "Dàjiā hǎo!" },
          { ch: "大家好!" },
          { ko: "여러분 안녕하세요!" },
        ],
      },
      {
        img: require("@data/assets/navy/book4/images/img_N4-11.png"),
        sound: require("@data/assets/navy/book4/sounds/KF04_W_12.mp3"),
        buttons: [
          { ch2: "Wǒ shì gēshǒu." },
          { ch: "我是歌手。" },
          { ko: "나는 가수입니다." },
        ],
      },
      {
        img: require("@data/assets/navy/book4/images/img_N4-14.png"),
        sound: require("@data/assets/navy/book4/sounds/KF04_W_13.mp3"),
        buttons: [
          { ch2: "Wǒ shì yùndòngyuán." },
          { ch: "我是运动员。" },
          { ko: "나는 운동선수입니다." },
        ],
      },
      {
        img: require("@data/assets/navy/book4/images/img_N4-13.png"),
        sound: require("@data/assets/navy/book4/sounds/KF04_W_14.mp3"),
        buttons: [
          { ch2: "Wǒ shì kēxuéjiā." },
          { ch: "我是科学家。" },
          { ko: "나는 과학자입니다." },
        ],
      },
      {
        img: require("@data/assets/navy/book4/images/img_N4-16.png"),
        sound: require("@data/assets/navy/book4/sounds/KF04_W_15.mp3"),
        buttons: [
          { ch2: "Wǒ shì chúshī." },
          { ch: "我是厨师。" },
          { ko: "나는 요리사입니다." },
        ],
      },
      {
        img: require("@data/assets/navy/book4/images/img_N4-15.png"),
        sound: require("@data/assets/navy/book4/sounds/KF04_W_16.mp3"),
        buttons: [
          { ch2: "Míngbai le ma?" },
          { ch: "明白了吗？" },
          { ko: "알겠어요?" },
        ],
      },
      {
        img: require("@data/assets/navy/book4/images/img_N4-18.png"),
        sound: require("@data/assets/navy/book4/sounds/KF04_W_17.mp3"),
        buttons: [
          { ch2: "Míngbai le." },
          { ch: "明白了。" },
          { ko: "알겠어요." },
        ],
      },
      {
        img: require("@data/assets/navy/book4/images/img_N4-17.png"),
        sound: require("@data/assets/navy/book4/sounds/KF04_W_18.mp3"),
        buttons: [{ ch2: "Jiāyóu!" }, { ch: "加油!" }, { ko: "파이팅!" }],
      },
    ],
    activity: {
      questions: [
        {
          type: "ty1",
          sound: require("@data/assets/navy/book4/sounds/KF04_W_03.mp3"),
          img: require("@data/assets/navy/book4/images/img_N4-03.png"),
          answer: {
            O: false,
            X: true,
          },
        },
        {
          type: "ty2",
          sound: require("@data/assets/navy/book4/sounds/KF04_W_07.mp3"),
          answer: [
            [require("@data/assets/navy/book4/images/img_N4-05.png"), false],
            [require("@data/assets/navy/book4/images/img_N4-08.png"), true],
          ],
        },
        {
          type: "ty3",
          sound: require("@data/assets/navy/book4/sounds/KF04_W_18.mp3"),
          answer: [
            ["大家好!", false],
            ["加油!", true],
          ],
        },
      ],
    },
    pages: [
      {
        book: require("@data/assets/navy/book4/pages/front.jpg"),
        sound: require("@data/assets/navy/book4/sounds/cover.mp3"),
      },

      {
        book: require("@data/assets/navy/book4/pages/page02.jpg"),
      },
      {
        book: require("@data/assets/navy/book4/pages/page03.jpg"),
      },
      {
        book: require("@data/assets/navy/book4/pages/page04.jpg"),
        sound: require("@data/assets/navy/book4/sounds/page04.mp3"),
      },
      {
        book: require("@data/assets/navy/book4/pages/page05.jpg"),
      },
      {
        book: require("@data/assets/navy/book4/pages/page06.jpg"),
        sound: require("@data/assets/navy/book4/sounds/page06.mp3"),
      },
      {
        book: require("@data/assets/navy/book4/pages/page07.jpg"),
      },
      {
        book: require("@data/assets/navy/book4/pages/page08.jpg"),
        sound: require("@data/assets/navy/book4/sounds/page08.mp3"),
      },
      {
        book: require("@data/assets/navy/book4/pages/page09.jpg"),
      },
      {
        book: require("@data/assets/navy/book4/pages/page10.jpg"),
        sound: require("@data/assets/navy/book4/sounds/page10.mp3"),
      },
      {
        book: require("@data/assets/navy/book4/pages/page11.jpg"),
      },
      {
        book: require("@data/assets/navy/book4/pages/page12.jpg"),
        sound: require("@data/assets/navy/book4/sounds/page12.mp3"),
      },
      {
        book: require("@data/assets/navy/book4/pages/page13.jpg"),
      },
      {
        book: require("@data/assets/navy/book4/pages/page14.jpg"),
        sound: require("@data/assets/navy/book4/sounds/page14.mp3"),
      },
      {
        book: require("@data/assets/navy/book4/pages/page15.jpg"),
      },
      {
        book: require("@data/assets/navy/book4/pages/page16.jpg"),
        sound: require("@data/assets/navy/book4/sounds/page16.mp3"),
      },
      {
        book: require("@data/assets/navy/book4/pages/page17.jpg"),
      },
      {
        book: require("@data/assets/navy/book4/pages/page18.jpg"),
        sound: require("@data/assets/navy/book4/sounds/page18.mp3"),
      },
      {
        book: require("@data/assets/navy/book4/pages/page19.jpg"),
      },
      {
        book: require("@data/assets/navy/book4/pages/page20.jpg"),
        sound: require("@data/assets/navy/book4/sounds/page20.mp3"),
      },
      {
        book: require("@data/assets/navy/book4/pages/page21.jpg"),
      },
      {
        book: require("@data/assets/navy/book4/pages/page22.jpg"),
        sound: require("@data/assets/navy/book4/sounds/page22.mp3"),
      },
      {
        book: require("@data/assets/navy/book4/pages/page23.jpg"),
        sound: require("@data/assets/navy/book4/sounds/page23.mp3"),
      },
      {
        book: require("@data/assets/navy/book4/pages/page24.jpg"),
      },
      {
        book: require("@data/assets/navy/book4/pages/page25.jpg"),
      },
      {
        book: require("@data/assets/navy/book4/pages/page26.jpg"),
      },
      {
        book: require("@data/assets/navy/book4/pages/page27.jpg"),
      },
    ],
    thumbnail: [
      require("@data/assets/navy/book4/thumbnail/front.jpg"),
      require("@data/assets/navy/book4/thumbnail/page02.jpg"),
      require("@data/assets/navy/book4/thumbnail/page03.jpg"),
      require("@data/assets/navy/book4/thumbnail/page04.jpg"),
      require("@data/assets/navy/book4/thumbnail/page05.jpg"),
      require("@data/assets/navy/book4/thumbnail/page06.jpg"),
      require("@data/assets/navy/book4/thumbnail/page07.jpg"),
      require("@data/assets/navy/book4/thumbnail/page08.jpg"),
      require("@data/assets/navy/book4/thumbnail/page09.jpg"),
      require("@data/assets/navy/book4/thumbnail/page10.jpg"),
      require("@data/assets/navy/book4/thumbnail/page11.jpg"),
      require("@data/assets/navy/book4/thumbnail/page12.jpg"),
      require("@data/assets/navy/book4/thumbnail/page13.jpg"),
      require("@data/assets/navy/book4/thumbnail/page14.jpg"),
      require("@data/assets/navy/book4/thumbnail/page15.jpg"),
      require("@data/assets/navy/book4/thumbnail/page16.jpg"),
      require("@data/assets/navy/book4/thumbnail/page17.jpg"),
      require("@data/assets/navy/book4/thumbnail/page18.jpg"),
      require("@data/assets/navy/book4/thumbnail/page19.jpg"),
      require("@data/assets/navy/book4/thumbnail/page20.jpg"),
      require("@data/assets/navy/book4/thumbnail/page21.jpg"),
      require("@data/assets/navy/book4/thumbnail/page22.jpg"),
      require("@data/assets/navy/book4/thumbnail/page23.jpg"),
      require("@data/assets/navy/book4/thumbnail/page24.jpg"),
      require("@data/assets/navy/book4/thumbnail/page25.jpg"),
      require("@data/assets/navy/book4/thumbnail/page26.jpg"),
      require("@data/assets/navy/book4/thumbnail/page27.jpg"),
    ],
  },
  //5
  {
    key: "c6-05",
    title: "우산 이야기",
    grade: "5권",
    cover: require("@data/assets/navy/book5/images/cover.jpg"),
    background: require("@data/assets/navy/book5/pages/page05.jpg"),
    song: {
      url: require("@data/assets/navy/book5/sounds/page23.mp3"),
      title: "Jīntiān tiānqì zěnmeyàng?",
      caption: [
        "jīntiān tiānqì zěnmeyàng",
        "hěn hǎo jīntiān tiānqì hěn hǎo",
        "jīntiān tiānqì zěnmeyàng",
        "bù hǎo jīntiān tiānqì bù hǎo",
        "jīntiān tiānqì zěnmeyàng  xià yǔ le",
        "jīntiān tiānqì zěnmeyàng  guā fēng le",
        "jīntiān tiānqì zěnmeyàng  dǎ shǎn le",
        "jīntiān tiānqì zěnmeyàng  xià xuě le",
      ],
    },
    mov: {
      cn: "9a9fcb93576bc3ef12e3bc885ce36edc_05",
      en: "f4516423d4198a195cfa3902a4194d88_05",
    },
    game: {
      resources: [
        {
          img: require("@data/assets/navy/book5/images/img_N5-02.png"),
          sound: require("@data/assets/navy/book5/sounds/KF05_W_01.mp3"),
          word: "下雨|xià yǔ",
        },
        {
          img: require("@data/assets/navy/book5/images/img_N5-01.png"),
          sound: require("@data/assets/navy/book5/sounds/KF05_W_02.mp3"),
          word: "刮风|guā fēng",
        },
        {
          img: require("@data/assets/navy/book5/images/img_N5-04.png"),
          sound: require("@data/assets/navy/book5/sounds/KF05_W_03.mp3"),
          word: "打闪|dǎ shǎn",
        },
        {
          img: require("@data/assets/navy/book5/images/img_N5-03.png"),
          sound: require("@data/assets/navy/book5/sounds/KF05_W_04.mp3"),
          word: "下雪|xià xuě",
        },
        {
          img: require("@data/assets/navy/book5/images/img_N5-06.png"),
          sound: require("@data/assets/navy/book5/sounds/KF05_W_05.mp3"),
          word: "今天天气怎么样？|Jīntiān tiānqì zěnmeyàng?",
        },
        {
          img: require("@data/assets/navy/book5/images/img_N5-05.png"),
          sound: require("@data/assets/navy/book5/sounds/KF05_W_06.mp3"),
          word: "今天天气很好。|Jīntiān tiānqì hěn hǎo.",
        },
        {
          img: require("@data/assets/navy/book5/images/img_N5-08.png"),
          sound: require("@data/assets/navy/book5/sounds/KF05_W_07.mp3"),
          word: "今天天气不好。|Jīntiān tiānqì bù hǎo.",
        },
        {
          img: require("@data/assets/navy/book5/images/img_N5-07.png"),
          sound: require("@data/assets/navy/book5/sounds/KF05_W_08.mp3"),
          word: "下雨了!|Xià yǔ le!",
        },
        {
          img: require("@data/assets/navy/book5/images/img_N5-10.png"),
          sound: require("@data/assets/navy/book5/sounds/KF05_W_09.mp3"),
          word: "刮风了!|Guā fēng le!",
        },
        {
          img: require("@data/assets/navy/book5/images/img_N5-09.png"),
          sound: require("@data/assets/navy/book5/sounds/KF05_W_10.mp3"),
          word: "打闪了!|Dǎ shǎn le!",
        },
        {
          img: require("@data/assets/navy/book5/images/img_N5-12.png"),
          sound: require("@data/assets/navy/book5/sounds/KF05_W_11.mp3"),
          word: "下雪了!|Xià xuě le!",
        },
        {
          img: require("@data/assets/navy/book5/images/img_N5-11.png"),
          sound: require("@data/assets/navy/book5/sounds/KF05_W_12.mp3"),
          word: "见到你很高兴!|Jiàndào nǐ hěn gāoxìng!",
        },
        {
          img: require("@data/assets/navy/book5/images/img_N5-14.png"),
          sound: require("@data/assets/navy/book5/sounds/KF05_W_13.mp3"),
          word: "我很高兴!|Wǒ hěn gāoxìng!",
        },
        {
          img: require("@data/assets/navy/book5/images/img_N5-13.png"),
          sound: require("@data/assets/navy/book5/sounds/KF05_W_14.mp3"),
          word: "好疼!|Hǎo téng!",
        },
        {
          img: require("@data/assets/navy/book5/images/img_N5-16.png"),
          sound: require("@data/assets/navy/book5/sounds/KF05_W_15.mp3"),
          word: "很可怜!|Hěn kělián!",
        },
        {
          img: require("@data/assets/navy/book5/images/img_N5-15.png"),
          sound: require("@data/assets/navy/book5/sounds/KF05_W_16.mp3"),
          word: "你叫什么名字？|Nǐ jiào shénme míngzi?",
        },
        {
          img: require("@data/assets/navy/book5/images/img_N5-18.png"),
          sound: require("@data/assets/navy/book5/sounds/KF05_W_17.mp3"),
          word: "我叫娜娜。|Wǒ jiào Nàna.",
        },
        {
          img: require("@data/assets/navy/book5/images/img_N5-17.png"),
          sound: require("@data/assets/navy/book5/sounds/KF05_W_18.mp3"),
          word: "我很幸福!|Wǒ hěn xìngfú!",
        },
      ],
    },
    word: [
      {
        img: require("@data/assets/navy/book5/images/img_N5-02.png"),
        sound: require("@data/assets/navy/book5/sounds/KF05_W_01.mp3"),
        buttons: [{ ch2: "xià yǔ" }, { ch: "下雨" }, { ko: "비가 내리다" }],
      },
      {
        img: require("@data/assets/navy/book5/images/img_N5-01.png"),
        sound: require("@data/assets/navy/book5/sounds/KF05_W_02.mp3"),
        buttons: [{ ch2: "guā fēng" }, { ch: "刮风" }, { ko: "바람이 불다" }],
      },
      {
        img: require("@data/assets/navy/book5/images/img_N5-04.png"),
        sound: require("@data/assets/navy/book5/sounds/KF05_W_03.mp3"),
        buttons: [{ ch2: "dǎ shǎn" }, { ch: "打闪" }, { ko: "번개가 치다" }],
      },
      {
        img: require("@data/assets/navy/book5/images/img_N5-03.png"),
        sound: require("@data/assets/navy/book5/sounds/KF05_W_04.mp3"),
        buttons: [{ ch2: "xià xuě" }, { ch: "下雪" }, { ko: "눈이 내리다" }],
      },
    ],
    idiom: [
      {
        img: require("@data/assets/navy/book5/images/img_N5-06.png"),
        sound: require("@data/assets/navy/book5/sounds/KF05_W_05.mp3"),
        buttons: [
          { ch2: "Jīntiān tiānqì zěnmeyàng?" },
          { ch: "今天天气怎么样？" },
          { ko: "오늘 날씨 어때요?" },
        ],
      },
      {
        img: require("@data/assets/navy/book5/images/img_N5-05.png"),
        sound: require("@data/assets/navy/book5/sounds/KF05_W_06.mp3"),
        buttons: [
          { ch2: "Jīntiān tiānqì hěn hǎo." },
          { ch: "今天天气很好。" },
          { ko: "오늘 날씨 좋아요." },
        ],
      },
      {
        img: require("@data/assets/navy/book5/images/img_N5-08.png"),
        sound: require("@data/assets/navy/book5/sounds/KF05_W_07.mp3"),
        buttons: [
          { ch2: "Jīntiān tiānqì bù hǎo." },
          { ch: "今天天气不好。" },
          { ko: "오늘 날씨 안좋아요." },
        ],
      },
      {
        img: require("@data/assets/navy/book5/images/img_N5-07.png"),
        sound: require("@data/assets/navy/book5/sounds/KF05_W_08.mp3"),
        buttons: [
          { ch2: "Xià yǔ le!" },
          { ch: "下雨了!" },
          { ko: "비가 내려요!" },
        ],
      },
      {
        img: require("@data/assets/navy/book5/images/img_N5-10.png"),
        sound: require("@data/assets/navy/book5/sounds/KF05_W_09.mp3"),
        buttons: [
          { ch2: "Guā fēng le!" },
          { ch: "刮风了!" },
          { ko: "바람이 불어요!" },
        ],
      },
      {
        img: require("@data/assets/navy/book5/images/img_N5-09.png"),
        sound: require("@data/assets/navy/book5/sounds/KF05_W_10.mp3"),
        buttons: [
          { ch2: "Dǎ shǎn le!" },
          { ch: "打闪了!" },
          { ko: "번개가 쳐요!" },
        ],
      },
      {
        img: require("@data/assets/navy/book5/images/img_N5-12.png"),
        sound: require("@data/assets/navy/book5/sounds/KF05_W_11.mp3"),
        buttons: [
          { ch2: "Xià xuě le!" },
          { ch: "下雪了!" },
          { ko: "눈이 내려요!" },
        ],
      },
      {
        img: require("@data/assets/navy/book5/images/img_N5-11.png"),
        sound: require("@data/assets/navy/book5/sounds/KF05_W_12.mp3"),
        buttons: [
          { ch2: "Jiàndào nǐ hěn gāoxìng!" },
          { ch: "见到你很高兴!" },
          { ko: "만나서 반갑습니다!" },
        ],
      },
      {
        img: require("@data/assets/navy/book5/images/img_N5-14.png"),
        sound: require("@data/assets/navy/book5/sounds/KF05_W_13.mp3"),
        buttons: [
          { ch2: "Wǒ hěn gāoxìng!" },
          { ch: "我很高兴!" },
          { ko: "나는 정말 기뻐요!" },
        ],
      },
      {
        img: require("@data/assets/navy/book5/images/img_N5-13.png"),
        sound: require("@data/assets/navy/book5/sounds/KF05_W_14.mp3"),
        buttons: [{ ch2: "Hǎo téng!" }, { ch: "好疼!" }, { ko: "아파요!" }],
      },
      {
        img: require("@data/assets/navy/book5/images/img_N5-16.png"),
        sound: require("@data/assets/navy/book5/sounds/KF05_W_15.mp3"),
        buttons: [{ ch2: "Hěn kělián!" }, { ch: "很可怜!" }, { ko: "불쌍해!" }],
      },
      {
        img: require("@data/assets/navy/book5/images/img_N5-15.png"),
        sound: require("@data/assets/navy/book5/sounds/KF05_W_16.mp3"),
        buttons: [
          { ch2: "Nǐ jiào shénme míngzi?" },
          { ch: "你叫什么名字？" },
          { ko: "너는 이름이 뭐야?" },
        ],
      },
      {
        img: require("@data/assets/navy/book5/images/img_N5-18.png"),
        sound: require("@data/assets/navy/book5/sounds/KF05_W_17.mp3"),
        buttons: [
          { ch2: "Wǒ jiào Nàna." },
          { ch: "我叫娜娜。" },
          { ko: "나는 나나라고 해." },
        ],
      },
      {
        img: require("@data/assets/navy/book5/images/img_N5-17.png"),
        sound: require("@data/assets/navy/book5/sounds/KF05_W_18.mp3"),
        buttons: [
          { ch2: "Wǒ hěn xìngfú!" },
          { ch: "我很幸福!" },
          { ko: "나는 행복해!" },
        ],
      },
    ],
    activity: {
      questions: [
        {
          type: "ty1",
          sound: require("@data/assets/navy/book5/sounds/KF05_W_01.mp3"),
          img: require("@data/assets/navy/book5/images/img_N5-01.png"),
          answer: {
            O: false,
            X: true,
          },
        },
        {
          type: "ty2",
          sound: require("@data/assets/navy/book5/sounds/KF05_W_06.mp3"),
          answer: [
            [require("@data/assets/navy/book5/images/img_N5-05.png"), true],
            [require("@data/assets/navy/book5/images/img_N5-08.png"), false],
          ],
        },
        {
          type: "ty3",
          sound: require("@data/assets/navy/book5/sounds/KF05_W_09.mp3"),
          answer: [
            ["刮风了!", true],
            ["下雪了!", false],
          ],
        },
      ],
    },
    pages: [
      {
        book: require("@data/assets/navy/book5/pages/front.jpg"),
        sound: require("@data/assets/navy/book5/sounds/cover.mp3"),
      },

      {
        book: require("@data/assets/navy/book5/pages/page02.jpg"),
      },
      {
        book: require("@data/assets/navy/book5/pages/page03.jpg"),
      },
      {
        book: require("@data/assets/navy/book5/pages/page04.jpg"),
        sound: require("@data/assets/navy/book5/sounds/page04.mp3"),
      },
      {
        book: require("@data/assets/navy/book5/pages/page05.jpg"),
      },
      {
        book: require("@data/assets/navy/book5/pages/page06.jpg"),
        sound: require("@data/assets/navy/book5/sounds/page06.mp3"),
      },
      {
        book: require("@data/assets/navy/book5/pages/page07.jpg"),
      },
      {
        book: require("@data/assets/navy/book5/pages/page08.jpg"),
        sound: require("@data/assets/navy/book5/sounds/page08.mp3"),
      },
      {
        book: require("@data/assets/navy/book5/pages/page09.jpg"),
      },
      {
        book: require("@data/assets/navy/book5/pages/page10.jpg"),
        sound: require("@data/assets/navy/book5/sounds/page10.mp3"),
      },
      {
        book: require("@data/assets/navy/book5/pages/page11.jpg"),
      },
      {
        book: require("@data/assets/navy/book5/pages/page12.jpg"),
        sound: require("@data/assets/navy/book5/sounds/page12.mp3"),
      },
      {
        book: require("@data/assets/navy/book5/pages/page13.jpg"),
      },
      {
        book: require("@data/assets/navy/book5/pages/page14.jpg"),
        sound: require("@data/assets/navy/book5/sounds/page14.mp3"),
      },
      {
        book: require("@data/assets/navy/book5/pages/page15.jpg"),
      },
      {
        book: require("@data/assets/navy/book5/pages/page16.jpg"),
        sound: require("@data/assets/navy/book5/sounds/page16.mp3"),
      },
      {
        book: require("@data/assets/navy/book5/pages/page17.jpg"),
      },
      {
        book: require("@data/assets/navy/book5/pages/page18.jpg"),
        sound: require("@data/assets/navy/book5/sounds/page18.mp3"),
      },
      {
        book: require("@data/assets/navy/book5/pages/page19.jpg"),
      },
      {
        book: require("@data/assets/navy/book5/pages/page20.jpg"),
        sound: require("@data/assets/navy/book5/sounds/page20.mp3"),
      },
      {
        book: require("@data/assets/navy/book5/pages/page21.jpg"),
      },
      {
        book: require("@data/assets/navy/book5/pages/page22.jpg"),
        sound: require("@data/assets/navy/book5/sounds/page22.mp3"),
      },
      {
        book: require("@data/assets/navy/book5/pages/page23.jpg"),
        sound: require("@data/assets/navy/book5/sounds/page23.mp3"),
      },
      {
        book: require("@data/assets/navy/book5/pages/page24.jpg"),
      },
      {
        book: require("@data/assets/navy/book5/pages/page25.jpg"),
      },
      {
        book: require("@data/assets/navy/book5/pages/page26.jpg"),
      },
      {
        book: require("@data/assets/navy/book5/pages/page27.jpg"),
      },
    ],
    thumbnail: [
      require("@data/assets/navy/book5/thumbnail/front.jpg"),
      require("@data/assets/navy/book5/thumbnail/page02.jpg"),
      require("@data/assets/navy/book5/thumbnail/page03.jpg"),
      require("@data/assets/navy/book5/thumbnail/page04.jpg"),
      require("@data/assets/navy/book5/thumbnail/page05.jpg"),
      require("@data/assets/navy/book5/thumbnail/page06.jpg"),
      require("@data/assets/navy/book5/thumbnail/page07.jpg"),
      require("@data/assets/navy/book5/thumbnail/page08.jpg"),
      require("@data/assets/navy/book5/thumbnail/page09.jpg"),
      require("@data/assets/navy/book5/thumbnail/page10.jpg"),
      require("@data/assets/navy/book5/thumbnail/page11.jpg"),
      require("@data/assets/navy/book5/thumbnail/page12.jpg"),
      require("@data/assets/navy/book5/thumbnail/page13.jpg"),
      require("@data/assets/navy/book5/thumbnail/page14.jpg"),
      require("@data/assets/navy/book5/thumbnail/page15.jpg"),
      require("@data/assets/navy/book5/thumbnail/page16.jpg"),
      require("@data/assets/navy/book5/thumbnail/page17.jpg"),
      require("@data/assets/navy/book5/thumbnail/page18.jpg"),
      require("@data/assets/navy/book5/thumbnail/page19.jpg"),
      require("@data/assets/navy/book5/thumbnail/page20.jpg"),
      require("@data/assets/navy/book5/thumbnail/page21.jpg"),
      require("@data/assets/navy/book5/thumbnail/page22.jpg"),
      require("@data/assets/navy/book5/thumbnail/page23.jpg"),
      require("@data/assets/navy/book5/thumbnail/page24.jpg"),
      require("@data/assets/navy/book5/thumbnail/page25.jpg"),
      require("@data/assets/navy/book5/thumbnail/page26.jpg"),
      require("@data/assets/navy/book5/thumbnail/page27.jpg"),
    ],
  },
  //6
  {
    key: "c6-06",
    title: "시계 없는 세상",
    grade: "6권",
    cover: require("@data/assets/navy/book6/images/cover.jpg"),
    background: require("@data/assets/navy/book6/pages/page05.jpg"),
    song: {
      url: require("@data/assets/navy/book6/sounds/page23.mp3"),
      title: "Nǐ jǐ diǎn qǐ chuáng?",
      caption: [
        "nǐ jǐ diǎn qǐ chuáng nǐ jǐ diǎn qǐ chuáng",
        "bā diǎn bā diǎn wǒ bā diǎn qǐ chuáng",
        "nǐ jǐ diǎn shuì jiào nǐ jǐ diǎn shuì jiào",
        "shí diǎn shí diǎn wǒ shí diǎn shuì jiào",
        "nǐ jǐ diǎn shàng kè nǐ jǐ diǎn shàng kè",
        "jiǔ diǎn jiǔ diǎn wǒ jiǔ diǎn shàng kè",
        "nǐ jǐ diǎn xià kè nǐ jǐ diǎn xià kè",
        "liǎng diǎn liǎng diǎn wǒ liǎng diǎn xià kè",
      ],
    },
    mov: {
      cn: "a2788762dede35805903ac48783634ee_06",
      en: "eca5f2f1004ccd12cb5c0e82ebdba573_06",
    },
    game: {
      resources: [
        {
          img: require("@data/assets/navy/book6/images/img_N6-02.png"),
          sound: require("@data/assets/navy/book6/sounds/KF06_W_01.mp3"),
          word: "起床|qǐ chuáng",
        },
        {
          img: require("@data/assets/navy/book6/images/img_N6-01.png"),
          sound: require("@data/assets/navy/book6/sounds/KF06_W_02.mp3"),
          word: "睡觉|shuì jiào",
        },
        {
          img: require("@data/assets/navy/book6/images/img_N6-04.png"),
          sound: require("@data/assets/navy/book6/sounds/KF06_W_03.mp3"),
          word: "上课|shàng kè",
        },
        {
          img: require("@data/assets/navy/book6/images/img_N6-03.png"),
          sound: require("@data/assets/navy/book6/sounds/KF06_W_04.mp3"),
          word: "下课|xià kè",
        },
        {
          img: require("@data/assets/navy/book6/images/img_N6-05.png"),
          sound: require("@data/assets/navy/book6/sounds/KF06_W_05.mp3"),
          word: "你几点起床？|Nǐ jǐ diǎn qǐ chuáng?",
        },
        {
          img: require("@data/assets/navy/book6/images/img_N6-06.png"),
          sound: require("@data/assets/navy/book6/sounds/KF06_W_06.mp3"),
          word: "我八点起床。|Wǒ bā diǎn qǐ chuáng.",
        },
        {
          img: require("@data/assets/navy/book6/images/img_N6-07.png"),
          sound: require("@data/assets/navy/book6/sounds/KF06_W_07.mp3"),
          word: "你几点睡觉？|Nǐ jǐ diǎn shuì jiào?",
        },
        {
          img: require("@data/assets/navy/book6/images/img_N6-08.png"),
          sound: require("@data/assets/navy/book6/sounds/KF06_W_08.mp3"),
          word: "我十点睡觉。|Wǒ shí diǎn shuì jiào.",
        },
        {
          img: require("@data/assets/navy/book6/images/img_N6-09.png"),
          sound: require("@data/assets/navy/book6/sounds/KF06_W_09.mp3"),
          word: "你几点上课？|Nǐ jǐ diǎn shàng kè?",
        },
        {
          img: require("@data/assets/navy/book6/images/img_N6-10.png"),
          sound: require("@data/assets/navy/book6/sounds/KF06_W_10.mp3"),
          word: "我九点上课。|Wǒ jiǔ diǎn shàng kè.",
        },
        {
          img: require("@data/assets/navy/book6/images/img_N6-11.png"),
          sound: require("@data/assets/navy/book6/sounds/KF06_W_11.mp3"),
          word: "你几点下课？|Nǐ jǐ diǎn xià kè?",
        },
        {
          img: require("@data/assets/navy/book6/images/img_N6-12.png"),
          sound: require("@data/assets/navy/book6/sounds/KF06_W_12.mp3"),
          word: "我两点下课。|Wǒ liǎng diǎn xià kè.",
        },
        {
          img: require("@data/assets/navy/book6/images/img_N6-14.png"),
          sound: require("@data/assets/navy/book6/sounds/KF06_W_13.mp3"),
          word: "祝你生日快乐!|Zhù nǐ shēngrì kuàilè!",
        },
        {
          img: require("@data/assets/navy/book6/images/img_N6-13.png"),
          sound: require("@data/assets/navy/book6/sounds/KF06_W_14.mp3"),
          word: "谁呀？|Shéi ya?",
        },
        {
          img: require("@data/assets/navy/book6/images/img_N6-16.png"),
          sound: require("@data/assets/navy/book6/sounds/KF06_W_15.mp3"),
          word: "真的吗?|Zhēnde ma?",
        },
        {
          img: require("@data/assets/navy/book6/images/img_N6-15.png"),
          sound: require("@data/assets/navy/book6/sounds/KF06_W_16.mp3"),
          word: "现在几点？|Xiànzài jǐ diǎn?",
        },
        {
          img: require("@data/assets/navy/book6/images/img_N6-18.png"),
          sound: require("@data/assets/navy/book6/sounds/KF06_W_17.mp3"),
          word: "那是什么意思？|Nà shì shénme yìsi?",
        },
        {
          img: require("@data/assets/navy/book6/images/img_N6-17.png"),
          sound: require("@data/assets/navy/book6/sounds/KF06_W_18.mp3"),
          word: "你来了!|Nǐ lái le!",
        },
        {
          img: require("@data/assets/navy/book6/images/img_N6-20.png"),
          sound: require("@data/assets/navy/book6/sounds/KF06_W_19.mp3"),
          word: "一会儿见!|Yíhuìr jiàn!",
        },
        {
          img: require("@data/assets/navy/book6/images/img_N6-19.png"),
          sound: require("@data/assets/navy/book6/sounds/KF06_W_20.mp3"),
          word: "为什么?|Wèishénme?",
        },
      ],
    },
    word: [
      {
        img: require("@data/assets/navy/book6/images/img_N6-02.png"),
        sound: require("@data/assets/navy/book6/sounds/KF06_W_01.mp3"),
        buttons: [{ ch2: "qǐ chuáng" }, { ch: "起床" }, { ko: "일어나다" }],
      },
      {
        img: require("@data/assets/navy/book6/images/img_N6-01.png"),
        sound: require("@data/assets/navy/book6/sounds/KF06_W_02.mp3"),
        buttons: [{ ch2: "shuì jiào" }, { ch: "睡觉" }, { ko: "자다" }],
      },
      {
        img: require("@data/assets/navy/book6/images/img_N6-04.png"),
        sound: require("@data/assets/navy/book6/sounds/KF06_W_03.mp3"),
        buttons: [{ ch2: "shàng kè" }, { ch: "上课" }, { ko: "수업을 하다" }],
      },
      {
        img: require("@data/assets/navy/book6/images/img_N6-03.png"),
        sound: require("@data/assets/navy/book6/sounds/KF06_W_04.mp3"),
        buttons: [{ ch2: "xià kè" }, { ch: "下课" }, { ko: "수업이 끝나다" }],
      },
    ],
    idiom: [
      {
        img: require("@data/assets/navy/book6/images/img_N6-05.png"),
        sound: require("@data/assets/navy/book6/sounds/KF06_W_05.mp3"),
        buttons: [
          { ch2: "Nǐ jǐ diǎn qǐ chuáng?" },
          { ch: "你几点起床？" },
          { ko: "너는 몇 시에 일어나니?" },
        ],
      },
      {
        img: require("@data/assets/navy/book6/images/img_N6-06.png"),
        sound: require("@data/assets/navy/book6/sounds/KF06_W_06.mp3"),
        buttons: [
          { ch2: "Wǒ bā diǎn qǐ chuáng." },
          { ch: "我八点起床。" },
          { ko: "나는 여덟 시에 일어나." },
        ],
      },
      {
        img: require("@data/assets/navy/book6/images/img_N6-07.png"),
        sound: require("@data/assets/navy/book6/sounds/KF06_W_07.mp3"),
        buttons: [
          { ch2: "Nǐ jǐ diǎn shuì jiào?" },
          { ch: "你几点睡觉？" },
          { ko: "너는 몇 시에 자니?" },
        ],
      },
      {
        img: require("@data/assets/navy/book6/images/img_N6-08.png"),
        sound: require("@data/assets/navy/book6/sounds/KF06_W_08.mp3"),
        buttons: [
          { ch2: "Wǒ shí diǎn shuì jiào." },
          { ch: "我十点睡觉。" },
          { ko: "나는 열 시에 자." },
        ],
      },
      {
        img: require("@data/assets/navy/book6/images/img_N6-09.png"),
        sound: require("@data/assets/navy/book6/sounds/KF06_W_09.mp3"),
        buttons: [
          { ch2: "Nǐ jǐ diǎn shàng kè?" },
          { ch: "你几点上课？" },
          { ko: "너는 몇 시에 수업을 하니?" },
        ],
      },
      {
        img: require("@data/assets/navy/book6/images/img_N6-10.png"),
        sound: require("@data/assets/navy/book6/sounds/KF06_W_10.mp3"),
        buttons: [
          { ch2: "Wǒ jiǔ diǎn shàng kè." },
          { ch: "我九点上课。" },
          { ko: "나는 아홉 시에 수업을 해." },
        ],
      },
      {
        img: require("@data/assets/navy/book6/images/img_N6-11.png"),
        sound: require("@data/assets/navy/book6/sounds/KF06_W_11.mp3"),
        buttons: [
          { ch2: "Nǐ jǐ diǎn xià kè?" },
          { ch: "你几点下课？" },
          { ko: "너는 몇 시에 수업을 마치니?" },
        ],
      },
      {
        img: require("@data/assets/navy/book6/images/img_N6-12.png"),
        sound: require("@data/assets/navy/book6/sounds/KF06_W_12.mp3"),
        buttons: [
          { ch2: "Wǒ liǎng diǎn xià kè." },
          { ch: "我两点下课。" },
          { ko: "나는 두 시에 수업을 마쳐." },
        ],
      },
      {
        img: require("@data/assets/navy/book6/images/img_N6-14.png"),
        sound: require("@data/assets/navy/book6/sounds/KF06_W_13.mp3"),
        buttons: [
          { ch2: "Zhù nǐ shēngrì kuàilè!" },
          { ch: "祝你生日快乐!" },
          { ko: "생일 축하해!" },
        ],
      },
      {
        img: require("@data/assets/navy/book6/images/img_N6-13.png"),
        sound: require("@data/assets/navy/book6/sounds/KF06_W_14.mp3"),
        buttons: [{ ch2: "Shéi ya?" }, { ch: "谁呀？" }, { ko: "누구야?" }],
      },
      {
        img: require("@data/assets/navy/book6/images/img_N6-16.png"),
        sound: require("@data/assets/navy/book6/sounds/KF06_W_15.mp3"),
        buttons: [{ ch2: "Zhēnde ma?" }, { ch: "真的吗?" }, { ko: "정말?" }],
      },
      {
        img: require("@data/assets/navy/book6/images/img_N6-15.png"),
        sound: require("@data/assets/navy/book6/sounds/KF06_W_16.mp3"),
        buttons: [
          { ch2: "Xiànzài jǐ diǎn?" },
          { ch: "现在几点？" },
          { ko: "지금 몇 시야?" },
        ],
      },
      {
        img: require("@data/assets/navy/book6/images/img_N6-18.png"),
        sound: require("@data/assets/navy/book6/sounds/KF06_W_17.mp3"),
        buttons: [
          { ch2: "Nà shì shénme yìsi?" },
          { ch: "那是什么意思？" },
          { ko: "그것은 무슨 뜻이야?" },
        ],
      },
      {
        img: require("@data/assets/navy/book6/images/img_N6-17.png"),
        sound: require("@data/assets/navy/book6/sounds/KF06_W_18.mp3"),
        buttons: [{ ch2: "Nǐ lái le!" }, { ch: "你来了!" }, { ko: "너 왔어?" }],
      },
      {
        img: require("@data/assets/navy/book6/images/img_N6-20.png"),
        sound: require("@data/assets/navy/book6/sounds/KF06_W_19.mp3"),
        buttons: [
          { ch2: "Yíhuìr jiàn!" },
          { ch: "一会儿见!" },
          { ko: "이따가 봐!" },
        ],
      },
      {
        img: require("@data/assets/navy/book6/images/img_N6-19.png"),
        sound: require("@data/assets/navy/book6/sounds/KF06_W_20.mp3"),
        buttons: [{ ch2: "Wèishénme?" }, { ch: "为什么?" }, { ko: "왜?" }],
      },
    ],
    activity: {
      questions: [
        {
          type: "ty1",
          sound: require("@data/assets/navy/book6/sounds/KF06_W_01.mp3"),
          img: require("@data/assets/navy/book6/images/img_N6-02.png"),
          answer: {
            O: true,
            X: false,
          },
        },
        {
          type: "ty2",
          sound: require("@data/assets/navy/book6/sounds/KF06_W_09.mp3"),
          answer: [
            [require("@data/assets/navy/book6/images/img_N6-08.png"), false],
            [require("@data/assets/navy/book6/images/img_N6-10.png"), true],
          ],
        },
        {
          type: "ty3",
          sound: require("@data/assets/navy/book6/sounds/KF06_W_19.mp3"),
          answer: [
            ["一会儿见!", true],
            ["为什么?", false],
          ],
        },
      ],
    },
    pages: [
      {
        book: require("@data/assets/navy/book6/pages/front.jpg"),
        sound: require("@data/assets/navy/book6/sounds/cover.mp3"),
      },

      {
        book: require("@data/assets/navy/book6/pages/page02.jpg"),
      },
      {
        book: require("@data/assets/navy/book6/pages/page03.jpg"),
      },
      {
        book: require("@data/assets/navy/book6/pages/page04.jpg"),
        sound: require("@data/assets/navy/book6/sounds/page04.mp3"),
      },
      {
        book: require("@data/assets/navy/book6/pages/page05.jpg"),
      },
      {
        book: require("@data/assets/navy/book6/pages/page06.jpg"),
        sound: require("@data/assets/navy/book6/sounds/page06.mp3"),
      },
      {
        book: require("@data/assets/navy/book6/pages/page07.jpg"),
      },
      {
        book: require("@data/assets/navy/book6/pages/page08.jpg"),
        sound: require("@data/assets/navy/book6/sounds/page08.mp3"),
      },
      {
        book: require("@data/assets/navy/book6/pages/page09.jpg"),
      },
      {
        book: require("@data/assets/navy/book6/pages/page10.jpg"),
        sound: require("@data/assets/navy/book6/sounds/page10.mp3"),
      },
      {
        book: require("@data/assets/navy/book6/pages/page11.jpg"),
      },
      {
        book: require("@data/assets/navy/book6/pages/page12.jpg"),
        sound: require("@data/assets/navy/book6/sounds/page12.mp3"),
      },
      {
        book: require("@data/assets/navy/book6/pages/page13.jpg"),
      },
      {
        book: require("@data/assets/navy/book6/pages/page14.jpg"),
        sound: require("@data/assets/navy/book6/sounds/page14.mp3"),
      },
      {
        book: require("@data/assets/navy/book6/pages/page15.jpg"),
      },
      {
        book: require("@data/assets/navy/book6/pages/page16.jpg"),
        sound: require("@data/assets/navy/book6/sounds/page16.mp3"),
      },
      {
        book: require("@data/assets/navy/book6/pages/page17.jpg"),
      },
      {
        book: require("@data/assets/navy/book6/pages/page18.jpg"),
        sound: require("@data/assets/navy/book6/sounds/page18.mp3"),
      },
      {
        book: require("@data/assets/navy/book6/pages/page19.jpg"),
      },
      {
        book: require("@data/assets/navy/book6/pages/page20.jpg"),
        sound: require("@data/assets/navy/book6/sounds/page20.mp3"),
      },
      {
        book: require("@data/assets/navy/book6/pages/page21.jpg"),
      },
      {
        book: require("@data/assets/navy/book6/pages/page22.jpg"),
        sound: require("@data/assets/navy/book6/sounds/page22.mp3"),
      },
      {
        book: require("@data/assets/navy/book6/pages/page23.jpg"),
        sound: require("@data/assets/navy/book6/sounds/page23.mp3"),
      },
      {
        book: require("@data/assets/navy/book6/pages/page24.jpg"),
      },
      {
        book: require("@data/assets/navy/book6/pages/page25.jpg"),
      },
      {
        book: require("@data/assets/navy/book6/pages/page26.jpg"),
      },
      {
        book: require("@data/assets/navy/book6/pages/page27.jpg"),
      },
    ],
    thumbnail: [
      require("@data/assets/navy/book6/thumbnail/front.jpg"),
      require("@data/assets/navy/book6/thumbnail/page02.jpg"),
      require("@data/assets/navy/book6/thumbnail/page03.jpg"),
      require("@data/assets/navy/book6/thumbnail/page04.jpg"),
      require("@data/assets/navy/book6/thumbnail/page05.jpg"),
      require("@data/assets/navy/book6/thumbnail/page06.jpg"),
      require("@data/assets/navy/book6/thumbnail/page07.jpg"),
      require("@data/assets/navy/book6/thumbnail/page08.jpg"),
      require("@data/assets/navy/book6/thumbnail/page09.jpg"),
      require("@data/assets/navy/book6/thumbnail/page10.jpg"),
      require("@data/assets/navy/book6/thumbnail/page11.jpg"),
      require("@data/assets/navy/book6/thumbnail/page12.jpg"),
      require("@data/assets/navy/book6/thumbnail/page13.jpg"),
      require("@data/assets/navy/book6/thumbnail/page14.jpg"),
      require("@data/assets/navy/book6/thumbnail/page15.jpg"),
      require("@data/assets/navy/book6/thumbnail/page16.jpg"),
      require("@data/assets/navy/book6/thumbnail/page17.jpg"),
      require("@data/assets/navy/book6/thumbnail/page18.jpg"),
      require("@data/assets/navy/book6/thumbnail/page19.jpg"),
      require("@data/assets/navy/book6/thumbnail/page20.jpg"),
      require("@data/assets/navy/book6/thumbnail/page21.jpg"),
      require("@data/assets/navy/book6/thumbnail/page22.jpg"),
      require("@data/assets/navy/book6/thumbnail/page23.jpg"),
      require("@data/assets/navy/book6/thumbnail/page24.jpg"),
      require("@data/assets/navy/book6/thumbnail/page25.jpg"),
      require("@data/assets/navy/book6/thumbnail/page26.jpg"),
      require("@data/assets/navy/book6/thumbnail/page27.jpg"),
    ],
  },
  //7
  {
    key: "c6-07",
    title: "수수께끼를 풀어라!",
    grade: "7권",
    cover: require("@data/assets/navy/book7/images/cover.jpg"),
    background: require("@data/assets/navy/book7/pages/page05.jpg"),
    song: {
      url: require("@data/assets/navy/book7/sounds/page23.mp3"),
      title: "Wǒmen zěnme qù?",
      caption: [
        "wǒmen zěnme qù wǒmen zěnme qù",
        "wǒmen zuò huǒchē qù ba kācā kācā kācā kācā",
        "wǒmen zěnme qù wǒmen zěnme qù",
        "wǒmen zuò fēijī qù ba hōnglōnglōng hōnglōnglōng",
        "wǒmen zěnme qù wǒmen zěnme qù",
        "wǒmen zuò chuán qù ba wūwū wūwū",
        "wǒmen zěnme qù wǒmen zěnme qù",
        "wǒmen qí zìxíngchē qù ba dīnglīnglīng dīnglīnglīng",
      ],
    },
    mov: {
      cn: "683defe738b93c121e6c42294f304cf2_07",
      en: "cab5f3467866f9143dd5d4d3a9f0433c_07",
    },
    game: {
      resources: [
        {
          img: require("@data/assets/navy/book7/images/img_N7-02.png"),
          sound: require("@data/assets/navy/book7/sounds/KF07_W_01.mp3"),
          word: "火车|huǒchē",
        },
        {
          img: require("@data/assets/navy/book7/images/img_N7-01.png"),
          sound: require("@data/assets/navy/book7/sounds/KF07_W_02.mp3"),
          word: "飞机|fēijī",
        },
        {
          img: require("@data/assets/navy/book7/images/img_N7-04.png"),
          sound: require("@data/assets/navy/book7/sounds/KF07_W_03.mp3"),
          word: "船|chuán",
        },
        {
          img: require("@data/assets/navy/book7/images/img_N7-03.png"),
          sound: require("@data/assets/navy/book7/sounds/KF07_W_04.mp3"),
          word: "自行车|zìxíngchē",
        },
        //

        {
          img: require("@data/assets/navy/book7/images/img_N7-06.png"),
          sound: require("@data/assets/navy/book7/sounds/KF07_W_05.mp3"),
          word: "我们怎么去？|Wǒmen zěnme qù?",
        },
        {
          img: require("@data/assets/navy/book7/images/img_N7-05.png"),
          sound: require("@data/assets/navy/book7/sounds/KF07_W_06.mp3"),
          word: "我们坐火车去吧。|Wǒmen zuò huǒchē qù ba.",
        },
        {
          img: require("@data/assets/navy/book7/images/img_N7-08.png"),
          sound: require("@data/assets/navy/book7/sounds/KF07_W_07.mp3"),
          word: "我们坐飞机去吧。|Wǒmen zuò fēijī qù ba.",
        },
        {
          img: require("@data/assets/navy/book7/images/img_N7-07.png"),
          sound: require("@data/assets/navy/book7/sounds/KF07_W_08.mp3"),
          word: "我们坐船去吧。|Wǒmen zuò chuán qù ba.",
        },
        {
          img: require("@data/assets/navy/book7/images/img_N7-10.png"),
          sound: require("@data/assets/navy/book7/sounds/KF07_W_09.mp3"),
          word: "我们骑自行车去吧。|Wǒmen qí zìxíngchē qù ba.",
        },
        {
          img: require("@data/assets/navy/book7/images/img_N7-09.png"),
          sound: require("@data/assets/navy/book7/sounds/KF07_W_10.mp3"),
          word: "没问题!|Méi wèntí!",
        },
        {
          img: require("@data/assets/navy/book7/images/img_N7-12.png"),
          sound: require("@data/assets/navy/book7/sounds/KF07_W_11.mp3"),
          word: "出发!|Chūfā!",
        },
        {
          img: require("@data/assets/navy/book7/images/img_N7-11.png"),
          sound: require("@data/assets/navy/book7/sounds/KF07_W_12.mp3"),
          word: "飞机真快!|Fēijī zhēn kuài!",
        },
        {
          img: require("@data/assets/navy/book7/images/img_N7-14.png"),
          sound: require("@data/assets/navy/book7/sounds/KF07_W_13.mp3"),
          word: "真开心!|Zhēn kāixīn!",
        },
        {
          img: require("@data/assets/navy/book7/images/img_N7-13.png"),
          sound: require("@data/assets/navy/book7/sounds/KF07_W_14.mp3"),
          word: "你看!|Nǐ kàn!",
        },
        {
          img: require("@data/assets/navy/book7/images/img_N7-15.png"),
          sound: require("@data/assets/navy/book7/sounds/KF07_W_15.mp3"),
          word: "你们做得很好!|Nǐmen zuò de hěn hǎo!",
        },
      ],
    },
    word: [
      {
        img: require("@data/assets/navy/book7/images/img_N7-02.png"),
        sound: require("@data/assets/navy/book7/sounds/KF07_W_01.mp3"),
        buttons: [{ ch2: "huǒchē" }, { ch: "火车" }, { ko: "기차" }],
      },
      {
        img: require("@data/assets/navy/book7/images/img_N7-01.png"),
        sound: require("@data/assets/navy/book7/sounds/KF07_W_02.mp3"),
        buttons: [{ ch2: "fēijī" }, { ch: "飞机" }, { ko: "비행기" }],
      },
      {
        img: require("@data/assets/navy/book7/images/img_N7-04.png"),
        sound: require("@data/assets/navy/book7/sounds/KF07_W_03.mp3"),
        buttons: [{ ch2: "chuán" }, { ch: "船" }, { ko: "배" }],
      },
      {
        img: require("@data/assets/navy/book7/images/img_N7-03.png"),
        sound: require("@data/assets/navy/book7/sounds/KF07_W_04.mp3"),
        buttons: [{ ch2: "zìxíngchē" }, { ch: "自行车" }, { ko: "자전거" }],
      },
    ],
    idiom: [
      {
        img: require("@data/assets/navy/book7/images/img_N7-06.png"),
        sound: require("@data/assets/navy/book7/sounds/KF07_W_05.mp3"),
        buttons: [
          { ch2: "Wǒmen zěnme qù?" },
          { ch: "我们怎么去？" },
          { ko: "우리 어떻게 가?" },
        ],
      },
      {
        img: require("@data/assets/navy/book7/images/img_N7-05.png"),
        sound: require("@data/assets/navy/book7/sounds/KF07_W_06.mp3"),
        buttons: [
          { ch2: "Wǒmen zuò huǒchē qù ba." },
          { ch: "我们坐火车去吧。" },
          { ko: "우리 기차를 타고 가자." },
        ],
      },
      {
        img: require("@data/assets/navy/book7/images/img_N7-08.png"),
        sound: require("@data/assets/navy/book7/sounds/KF07_W_07.mp3"),
        buttons: [
          { ch2: "Wǒmen zuò fēijī qù ba." },
          { ch: "我们坐飞机去吧。" },
          { ko: "우리 비행기를 타고 가자." },
        ],
      },
      {
        img: require("@data/assets/navy/book7/images/img_N7-07.png"),
        sound: require("@data/assets/navy/book7/sounds/KF07_W_08.mp3"),
        buttons: [
          { ch2: "Wǒmen zuò chuán qù ba." },
          { ch: "我们坐船去吧。" },
          { ko: "우리 배를 타고 가자." },
        ],
      },
      {
        img: require("@data/assets/navy/book7/images/img_N7-10.png"),
        sound: require("@data/assets/navy/book7/sounds/KF07_W_09.mp3"),
        buttons: [
          { ch2: "Wǒmen qí zìxíngchē qù ba." },
          { ch: "我们骑自行车去吧。" },
          { ko: "우리 자전거를 타고 가자." },
        ],
      },
      {
        img: require("@data/assets/navy/book7/images/img_N7-09.png"),
        sound: require("@data/assets/navy/book7/sounds/KF07_W_10.mp3"),
        buttons: [
          { ch2: "Méi wèntí!" },
          { ch: "没问题!" },
          { ko: "문제 없어!" },
        ],
      },
      {
        img: require("@data/assets/navy/book7/images/img_N7-12.png"),
        sound: require("@data/assets/navy/book7/sounds/KF07_W_11.mp3"),
        buttons: [{ ch2: "Chūfā!" }, { ch: "出发!" }, { ko: "출발!" }],
      },
      {
        img: require("@data/assets/navy/book7/images/img_N7-11.png"),
        sound: require("@data/assets/navy/book7/sounds/KF07_W_12.mp3"),
        buttons: [
          { ch2: "Fēijī zhēn kuài!" },
          { ch: "飞机真快!" },
          { ko: "비행기는 정말 빠르다!" },
        ],
      },
      {
        img: require("@data/assets/navy/book7/images/img_N7-14.png"),
        sound: require("@data/assets/navy/book7/sounds/KF07_W_13.mp3"),
        buttons: [
          { ch2: "Zhēn kāixīn!" },
          { ch: "真开心!" },
          { ko: "정말 기뻐!" },
        ],
      },
      {
        img: require("@data/assets/navy/book7/images/img_N7-13.png"),
        sound: require("@data/assets/navy/book7/sounds/KF07_W_14.mp3"),
        buttons: [{ ch2: "Nǐ kàn!" }, { ch: "你看!" }, { ko: "너 봐봐!" }],
      },
      {
        img: require("@data/assets/navy/book7/images/img_N7-15.png"),
        sound: require("@data/assets/navy/book7/sounds/KF07_W_15.mp3"),
        buttons: [
          { ch2: "Nǐmen zuò de hěn hǎo!" },
          { ch: "你们做得很好!" },
          { ko: "너희들 정말 잘했어!" },
        ],
      },
    ],
    activity: {
      questions: [
        {
          type: "ty1",
          sound: require("@data/assets/navy/book7/sounds/KF07_W_02.mp3"),
          img: require("@data/assets/navy/book7/images/img_N7-01.png"),
          answer: {
            O: true,
            X: false,
          },
        },
        {
          type: "ty2",
          sound: require("@data/assets/navy/book7/sounds/KF07_W_06.mp3"),
          answer: [
            [require("@data/assets/navy/book7/images/img_N7-05.png"), true],
            [require("@data/assets/navy/book7/images/img_N7-10.png"), false],
          ],
        },
        {
          type: "ty3",
          sound: require("@data/assets/navy/book7/sounds/KF07_W_10.mp3"),
          answer: [
            ["没问题!", true],
            ["出发!", false],
          ],
        },
      ],
    },
    pages: [
      {
        book: require("@data/assets/navy/book7/pages/front.jpg"),
        sound: require("@data/assets/navy/book7/sounds/cover.mp3"),
      },

      {
        book: require("@data/assets/navy/book7/pages/page02.jpg"),
      },
      {
        book: require("@data/assets/navy/book7/pages/page03.jpg"),
      },
      {
        book: require("@data/assets/navy/book7/pages/page04.jpg"),
        sound: require("@data/assets/navy/book7/sounds/page04.mp3"),
      },
      {
        book: require("@data/assets/navy/book7/pages/page05.jpg"),
      },
      {
        book: require("@data/assets/navy/book7/pages/page06.jpg"),
        sound: require("@data/assets/navy/book7/sounds/page06.mp3"),
      },
      {
        book: require("@data/assets/navy/book7/pages/page07.jpg"),
      },
      {
        book: require("@data/assets/navy/book7/pages/page08.jpg"),
        sound: require("@data/assets/navy/book7/sounds/page08.mp3"),
      },
      {
        book: require("@data/assets/navy/book7/pages/page09.jpg"),
      },
      {
        book: require("@data/assets/navy/book7/pages/page10.jpg"),
        sound: require("@data/assets/navy/book7/sounds/page10.mp3"),
      },
      {
        book: require("@data/assets/navy/book7/pages/page11.jpg"),
      },
      {
        book: require("@data/assets/navy/book7/pages/page12.jpg"),
        sound: require("@data/assets/navy/book7/sounds/page12.mp3"),
      },
      {
        book: require("@data/assets/navy/book7/pages/page13.jpg"),
      },
      {
        book: require("@data/assets/navy/book7/pages/page14.jpg"),
        sound: require("@data/assets/navy/book7/sounds/page14.mp3"),
      },
      {
        book: require("@data/assets/navy/book7/pages/page15.jpg"),
      },
      {
        book: require("@data/assets/navy/book7/pages/page16.jpg"),
        sound: require("@data/assets/navy/book7/sounds/page16.mp3"),
      },
      {
        book: require("@data/assets/navy/book7/pages/page17.jpg"),
      },
      {
        book: require("@data/assets/navy/book7/pages/page18.jpg"),
        sound: require("@data/assets/navy/book7/sounds/page18.mp3"),
      },
      {
        book: require("@data/assets/navy/book7/pages/page19.jpg"),
      },
      {
        book: require("@data/assets/navy/book7/pages/page20.jpg"),
        sound: require("@data/assets/navy/book7/sounds/page20.mp3"),
      },
      {
        book: require("@data/assets/navy/book7/pages/page21.jpg"),
      },
      {
        book: require("@data/assets/navy/book7/pages/page22.jpg"),
        sound: require("@data/assets/navy/book7/sounds/page22.mp3"),
      },
      {
        book: require("@data/assets/navy/book7/pages/page23.jpg"),
        sound: require("@data/assets/navy/book7/sounds/page23.mp3"),
      },
      {
        book: require("@data/assets/navy/book7/pages/page24.jpg"),
      },
      {
        book: require("@data/assets/navy/book7/pages/page25.jpg"),
      },
      {
        book: require("@data/assets/navy/book7/pages/page26.jpg"),
      },
      {
        book: require("@data/assets/navy/book7/pages/page27.jpg"),
      },
    ],
    thumbnail: [
      require("@data/assets/navy/book7/thumbnail/front.jpg"),
      require("@data/assets/navy/book7/thumbnail/page02.jpg"),
      require("@data/assets/navy/book7/thumbnail/page03.jpg"),
      require("@data/assets/navy/book7/thumbnail/page04.jpg"),
      require("@data/assets/navy/book7/thumbnail/page05.jpg"),
      require("@data/assets/navy/book7/thumbnail/page06.jpg"),
      require("@data/assets/navy/book7/thumbnail/page07.jpg"),
      require("@data/assets/navy/book7/thumbnail/page08.jpg"),
      require("@data/assets/navy/book7/thumbnail/page09.jpg"),
      require("@data/assets/navy/book7/thumbnail/page10.jpg"),
      require("@data/assets/navy/book7/thumbnail/page11.jpg"),
      require("@data/assets/navy/book7/thumbnail/page12.jpg"),
      require("@data/assets/navy/book7/thumbnail/page13.jpg"),
      require("@data/assets/navy/book7/thumbnail/page14.jpg"),
      require("@data/assets/navy/book7/thumbnail/page15.jpg"),
      require("@data/assets/navy/book7/thumbnail/page16.jpg"),
      require("@data/assets/navy/book7/thumbnail/page17.jpg"),
      require("@data/assets/navy/book7/thumbnail/page18.jpg"),
      require("@data/assets/navy/book7/thumbnail/page19.jpg"),
      require("@data/assets/navy/book7/thumbnail/page20.jpg"),
      require("@data/assets/navy/book7/thumbnail/page21.jpg"),
      require("@data/assets/navy/book7/thumbnail/page22.jpg"),
      require("@data/assets/navy/book7/thumbnail/page23.jpg"),
      require("@data/assets/navy/book7/thumbnail/page24.jpg"),
      require("@data/assets/navy/book7/thumbnail/page25.jpg"),
      require("@data/assets/navy/book7/thumbnail/page26.jpg"),
      require("@data/assets/navy/book7/thumbnail/page27.jpg"),
    ],
  },
  //8
  {
    key: "c6-08",
    title: "뭘 고를래?",
    grade: "8권",
    cover: require("@data/assets/navy/book8/images/cover.jpg"),
    background: require("@data/assets/navy/book8/pages/page05.jpg"),
    song: {
      url: require("@data/assets/navy/book8/sounds/page23.mp3"),
      title: "Nǐ yào bǐnggān háishi miànbāo?",
      caption: [
        "nǐ yào bǐnggān háishi miànbāo wǒ yào bǐnggān",
        "wǒ yào miànbāo bǐnggān miànbāo wǒ gěi nǐ",
        "nǐ yào guǒzhī háishi niúnǎi wǒ yào guǒzhī",
        "wǒ yào niúnǎi guǒzhī niúnǎi wǒ gěi nǐ",
        "nǐ yào wánjù háishi qiú wǒ yào wánjù",
        "wǒ yào qiú wánjù qiú wǒ gěi nǐ",
        "nǐ yào màozi háishi shǒutào wǒ yào màozi",
        "wǒ yào shǒutào  màozi shǒutào  wǒ gěi nǐ",
      ],
    },
    mov: {
      cn: "8d481692b2470cb6eacd973e4b76e295_08",
      en: "e9221400ff3644f1b8f09ebf247223c8_08",
    },
    game: {
      resources: [
        {
          img: require("@data/assets/navy/book8/images/img_N8-02.png"),
          sound: require("@data/assets/navy/book8/sounds/KF08_W_01.mp3"),
          word: "饼干 面包|bǐnggān miànbāo",
        },
        {
          img: require("@data/assets/navy/book8/images/img_N8-01.png"),
          sound: require("@data/assets/navy/book8/sounds/KF08_W_02.mp3"),
          word: "果汁 牛奶|guǒzhī niúnǎi",
        },
        {
          img: require("@data/assets/navy/book8/images/img_N8-04.png"),
          sound: require("@data/assets/navy/book8/sounds/KF08_W_03.mp3"),
          word: "玩具 球|wánjù qiú",
        },
        {
          img: require("@data/assets/navy/book8/images/img_N8-03.png"),
          sound: require("@data/assets/navy/book8/sounds/KF08_W_04.mp3"),
          word: "帽子 手套|màozi shǒutào",
        },
        //

        {
          img: require("@data/assets/navy/book8/images/img_N8-05.png"),
          sound: require("@data/assets/navy/book8/sounds/KF08_W_05.mp3"),
          word: "你要饼干还是面包？|Nǐ yào bǐnggān háishi miànbāo?",
        },
        {
          img: require("@data/assets/navy/book8/images/img_N8-07.png"),
          sound: require("@data/assets/navy/book8/sounds/KF08_W_06.mp3"),
          word: "我要饼干。|Wǒ yào bǐnggān.",
        },
        {
          img: require("@data/assets/navy/book8/images/img_N8-06.png"),
          sound: require("@data/assets/navy/book8/sounds/KF08_W_07.mp3"),
          word: "你要果汁还是牛奶？|Nǐ yào guǒzhī háishi niúnǎi?",
        },
        {
          img: require("@data/assets/navy/book8/images/img_N8-09.png"),
          sound: require("@data/assets/navy/book8/sounds/KF08_W_08.mp3"),
          word: "我要果汁。|Wǒ yào guǒzhī.",
        },
        {
          img: require("@data/assets/navy/book8/images/img_N8-08.png"),
          sound: require("@data/assets/navy/book8/sounds/KF08_W_09.mp3"),
          word: "你要玩具还是球？|Nǐ yào wánjù háishi qiú?",
        },
        {
          img: require("@data/assets/navy/book8/images/img_N8-11.png"),
          sound: require("@data/assets/navy/book8/sounds/KF08_W_10.mp3"),
          word: "我要球。|Wǒ yào qiú.",
        },
        {
          img: require("@data/assets/navy/book8/images/img_N8-10.png"),
          sound: require("@data/assets/navy/book8/sounds/KF08_W_11.mp3"),
          word: "你要帽子还是手套？|Nǐ yào màozi háishi shǒutào?",
        },
        {
          img: require("@data/assets/navy/book8/images/img_N8-13.png"),
          sound: require("@data/assets/navy/book8/sounds/KF08_W_12.mp3"),
          word: "我要帽子。|Wǒ yào màozi.",
        },

        {
          img: require("@data/assets/navy/book8/images/img_N8-12.png"),
          sound: require("@data/assets/navy/book8/sounds/KF08_W_13.mp3"),
          word: "你放心吧!|Nǐ fàngxīn ba!",
        },
        {
          img: require("@data/assets/navy/book8/images/img_N8-15.png"),
          sound: require("@data/assets/navy/book8/sounds/KF08_W_14.mp3"),
          word: "我饿了!|Wǒ è le!",
        },
        {
          img: require("@data/assets/navy/book8/images/img_N8-14.png"),
          sound: require("@data/assets/navy/book8/sounds/KF08_W_15.mp3"),
          word: "我回来了!|Wǒ huílái le!",
        },
        {
          img: require("@data/assets/navy/book8/images/img_N8-17.png"),
          sound: require("@data/assets/navy/book8/sounds/KF08_W_16.mp3"),
          word: "你回来了?|Nǐ huílái le?",
        },
        {
          img: require("@data/assets/navy/book8/images/img_N8-16.png"),
          sound: require("@data/assets/navy/book8/sounds/KF08_W_17.mp3"),
          word: "站住!|Zhànzhù!",
        },
        {
          img: require("@data/assets/navy/book8/images/img_N8-19.png"),
          sound: require("@data/assets/navy/book8/sounds/KF08_W_18.mp3"),
          word: "我给你!|Wǒ gěi nǐ!",
        },
        {
          img: require("@data/assets/navy/book8/images/img_N8-18.png"),
          sound: require("@data/assets/navy/book8/sounds/KF08_W_19.mp3"),
          word: "茄子!|Qiézi!",
        },
      ],
    },
    word: [
      {
        img: require("@data/assets/navy/book8/images/img_N8-02.png"),
        sound: require("@data/assets/navy/book8/sounds/KF08_W_01.mp3"),
        buttons: [
          { ch2: "bǐnggān<br>miànbāo" },
          { ch: "饼干<br>面包" },
          { ko: "과자<br>빵" },
        ],
      },
      {
        img: require("@data/assets/navy/book8/images/img_N8-01.png"),
        sound: require("@data/assets/navy/book8/sounds/KF08_W_02.mp3"),
        buttons: [
          { ch2: "guǒzhī<br>niúnǎi" },
          { ch: "果汁<br>牛奶" },
          { ko: "과일 주스<br>우유" },
        ],
      },
      {
        img: require("@data/assets/navy/book8/images/img_N8-04.png"),
        sound: require("@data/assets/navy/book8/sounds/KF08_W_03.mp3"),
        buttons: [
          { ch2: "wánjù<br>qiú" },
          { ch: "玩具<br>球" },
          { ko: "장남감<br>공" },
        ],
      },
      {
        img: require("@data/assets/navy/book8/images/img_N8-03.png"),
        sound: require("@data/assets/navy/book8/sounds/KF08_W_04.mp3"),
        buttons: [
          { ch2: "màozi<br>shǒutào" },
          { ch: "帽子<br>手套" },
          { ko: "모자<br>장갑" },
        ],
      },
    ],
    idiom: [
      {
        img: require("@data/assets/navy/book8/images/img_N8-05.png"),
        sound: require("@data/assets/navy/book8/sounds/KF08_W_05.mp3"),
        buttons: [
          { ch2: "Nǐ yào bǐnggān háishi miànbāo?" },
          { ch: "你要饼干还是面包？" },
          { ko: "너는 과자를 원하니, 빵을 원하니?" },
        ],
      },
      {
        img: require("@data/assets/navy/book8/images/img_N8-07.png"),
        sound: require("@data/assets/navy/book8/sounds/KF08_W_06.mp3"),
        buttons: [
          { ch2: "Wǒ yào bǐnggān." },
          { ch: "我要饼干。" },
          { ko: "나는 과자를 원해요." },
        ],
      },
      {
        img: require("@data/assets/navy/book8/images/img_N8-06.png"),
        sound: require("@data/assets/navy/book8/sounds/KF08_W_07.mp3"),
        buttons: [
          { ch2: "Nǐ yào guǒzhī háishi niúnǎi?" },
          { ch: "你要果汁还是牛奶？" },
          { ko: "너는 과일 주스를 원하니, 우유를 원하니?" },
        ],
      },
      {
        img: require("@data/assets/navy/book8/images/img_N8-09.png"),
        sound: require("@data/assets/navy/book8/sounds/KF08_W_08.mp3"),
        buttons: [
          { ch2: "Wǒ yào guǒzhī." },
          { ch: "我要果汁。" },
          { ko: "나는 과일 주스를 원해요." },
        ],
      },
      {
        img: require("@data/assets/navy/book8/images/img_N8-08.png"),
        sound: require("@data/assets/navy/book8/sounds/KF08_W_09.mp3"),
        buttons: [
          { ch2: "Nǐ yào wánjù háishi qiú?" },
          { ch: "你要玩具还是球？" },
          { ko: "너는 장난감을 원하니, 공을 원하니?" },
        ],
      },
      {
        img: require("@data/assets/navy/book8/images/img_N8-11.png"),
        sound: require("@data/assets/navy/book8/sounds/KF08_W_10.mp3"),
        buttons: [
          { ch2: "Wǒ yào qiú." },
          { ch: "我要球。" },
          { ko: "나는 공을 원해요." },
        ],
      },
      {
        img: require("@data/assets/navy/book8/images/img_N8-10.png"),
        sound: require("@data/assets/navy/book8/sounds/KF08_W_11.mp3"),
        buttons: [
          { ch2: "Nǐ yào màozi háishi shǒutào?" },
          { ch: "你要帽子还是手套？" },
          { ko: "너는 모자를 원하니, 장갑을 원하니?" },
        ],
      },
      {
        img: require("@data/assets/navy/book8/images/img_N8-13.png"),
        sound: require("@data/assets/navy/book8/sounds/KF08_W_12.mp3"),
        buttons: [
          { ch2: "Wǒ yào màozi." },
          { ch: "我要帽子。" },
          { ko: "나는 모자를 원해요." },
        ],
      },

      {
        img: require("@data/assets/navy/book8/images/img_N8-12.png"),
        sound: require("@data/assets/navy/book8/sounds/KF08_W_13.mp3"),
        buttons: [
          { ch2: "Nǐ fàngxīn ba!" },
          { ch: "你放心吧!" },
          { ko: "안심해!" },
        ],
      },
      {
        img: require("@data/assets/navy/book8/images/img_N8-15.png"),
        sound: require("@data/assets/navy/book8/sounds/KF08_W_14.mp3"),
        buttons: [{ ch2: "Wǒ è le!" }, { ch: "我饿了!" }, { ko: "나 배고파!" }],
      },
      {
        img: require("@data/assets/navy/book8/images/img_N8-14.png"),
        sound: require("@data/assets/navy/book8/sounds/KF08_W_15.mp3"),
        buttons: [
          { ch2: "Wǒ huílái le!" },
          { ch: "我回来了!" },
          { ko: "저 왔어요!" },
        ],
      },
      {
        img: require("@data/assets/navy/book8/images/img_N8-17.png"),
        sound: require("@data/assets/navy/book8/sounds/KF08_W_16.mp3"),
        buttons: [
          { ch2: "Nǐ huílái le?" },
          { ch: "你回来了?" },
          { ko: "너 왔어?" },
        ],
      },
      {
        img: require("@data/assets/navy/book8/images/img_N8-16.png"),
        sound: require("@data/assets/navy/book8/sounds/KF08_W_17.mp3"),
        buttons: [{ ch2: "Zhànzhù!" }, { ch: "站住!" }, { ko: "멈춰!" }],
      },
      {
        img: require("@data/assets/navy/book8/images/img_N8-19.png"),
        sound: require("@data/assets/navy/book8/sounds/KF08_W_18.mp3"),
        buttons: [
          { ch2: "Wǒ gěi nǐ!" },
          { ch: "我给你!" },
          { ko: "내가 줄게!" },
        ],
      },
      {
        img: require("@data/assets/navy/book8/images/img_N8-18.png"),
        sound: require("@data/assets/navy/book8/sounds/KF08_W_19.mp3"),
        buttons: [{ ch2: "Qiézi!" }, { ch: "茄子!" }, { ko: "치즈!" }],
      },
    ],
    activity: {
      questions: [
        {
          type: "ty1",
          sound: require("@data/assets/navy/book8/sounds/KF08_W_01.mp3"),
          img: require("@data/assets/navy/book8/images/img_N8-01.png"),
          answer: {
            O: false,
            X: true,
          },
        },
        {
          type: "ty2",
          sound: require("@data/assets/navy/book8/sounds/KF08_W_08.mp3"),
          answer: [
            [require("@data/assets/navy/book8/images/img_N8-09.png"), true],
            [require("@data/assets/navy/book8/images/img_N8-11.png"), false],
          ],
        },
        {
          type: "ty3",
          sound: require("@data/assets/navy/book8/sounds/KF08_W_14.mp3"),
          answer: [
            ["我饿了!", true],
            ["我要帽子。", false],
          ],
        },
      ],
    },
    pages: [
      {
        book: require("@data/assets/navy/book8/pages/front.jpg"),
        sound: require("@data/assets/navy/book8/sounds/cover.mp3"),
      },

      {
        book: require("@data/assets/navy/book8/pages/page02.jpg"),
      },
      {
        book: require("@data/assets/navy/book8/pages/page03.jpg"),
      },
      {
        book: require("@data/assets/navy/book8/pages/page04.jpg"),
        sound: require("@data/assets/navy/book8/sounds/page04.mp3"),
      },
      {
        book: require("@data/assets/navy/book8/pages/page05.jpg"),
      },
      {
        book: require("@data/assets/navy/book8/pages/page06.jpg"),
        sound: require("@data/assets/navy/book8/sounds/page06.mp3"),
      },
      {
        book: require("@data/assets/navy/book8/pages/page07.jpg"),
      },
      {
        book: require("@data/assets/navy/book8/pages/page08.jpg"),
        sound: require("@data/assets/navy/book8/sounds/page08.mp3"),
      },
      {
        book: require("@data/assets/navy/book8/pages/page09.jpg"),
      },
      {
        book: require("@data/assets/navy/book8/pages/page10.jpg"),
        sound: require("@data/assets/navy/book8/sounds/page10.mp3"),
      },
      {
        book: require("@data/assets/navy/book8/pages/page11.jpg"),
      },
      {
        book: require("@data/assets/navy/book8/pages/page12.jpg"),
        sound: require("@data/assets/navy/book8/sounds/page12.mp3"),
      },
      {
        book: require("@data/assets/navy/book8/pages/page13.jpg"),
      },
      {
        book: require("@data/assets/navy/book8/pages/page14.jpg"),
        sound: require("@data/assets/navy/book8/sounds/page14.mp3"),
      },
      {
        book: require("@data/assets/navy/book8/pages/page15.jpg"),
      },
      {
        book: require("@data/assets/navy/book8/pages/page16.jpg"),
        sound: require("@data/assets/navy/book8/sounds/page16.mp3"),
      },
      {
        book: require("@data/assets/navy/book8/pages/page17.jpg"),
      },
      {
        book: require("@data/assets/navy/book8/pages/page18.jpg"),
        sound: require("@data/assets/navy/book8/sounds/page18.mp3"),
      },
      {
        book: require("@data/assets/navy/book8/pages/page19.jpg"),
      },
      {
        book: require("@data/assets/navy/book8/pages/page20.jpg"),
        sound: require("@data/assets/navy/book8/sounds/page20.mp3"),
      },
      {
        book: require("@data/assets/navy/book8/pages/page21.jpg"),
      },
      {
        book: require("@data/assets/navy/book8/pages/page22.jpg"),
        sound: require("@data/assets/navy/book8/sounds/page22.mp3"),
      },
      {
        book: require("@data/assets/navy/book8/pages/page23.jpg"),
        sound: require("@data/assets/navy/book8/sounds/page23.mp3"),
      },
      {
        book: require("@data/assets/navy/book8/pages/page24.jpg"),
      },
      {
        book: require("@data/assets/navy/book8/pages/page25.jpg"),
      },
      {
        book: require("@data/assets/navy/book8/pages/page26.jpg"),
      },
      {
        book: require("@data/assets/navy/book8/pages/page27.jpg"),
      },
    ],
    thumbnail: [
      require("@data/assets/navy/book8/thumbnail/front.jpg"),
      require("@data/assets/navy/book8/thumbnail/page02.jpg"),
      require("@data/assets/navy/book8/thumbnail/page03.jpg"),
      require("@data/assets/navy/book8/thumbnail/page04.jpg"),
      require("@data/assets/navy/book8/thumbnail/page05.jpg"),
      require("@data/assets/navy/book8/thumbnail/page06.jpg"),
      require("@data/assets/navy/book8/thumbnail/page07.jpg"),
      require("@data/assets/navy/book8/thumbnail/page08.jpg"),
      require("@data/assets/navy/book8/thumbnail/page09.jpg"),
      require("@data/assets/navy/book8/thumbnail/page10.jpg"),
      require("@data/assets/navy/book8/thumbnail/page11.jpg"),
      require("@data/assets/navy/book8/thumbnail/page12.jpg"),
      require("@data/assets/navy/book8/thumbnail/page13.jpg"),
      require("@data/assets/navy/book8/thumbnail/page14.jpg"),
      require("@data/assets/navy/book8/thumbnail/page15.jpg"),
      require("@data/assets/navy/book8/thumbnail/page16.jpg"),
      require("@data/assets/navy/book8/thumbnail/page17.jpg"),
      require("@data/assets/navy/book8/thumbnail/page18.jpg"),
      require("@data/assets/navy/book8/thumbnail/page19.jpg"),
      require("@data/assets/navy/book8/thumbnail/page20.jpg"),
      require("@data/assets/navy/book8/thumbnail/page21.jpg"),
      require("@data/assets/navy/book8/thumbnail/page22.jpg"),
      require("@data/assets/navy/book8/thumbnail/page23.jpg"),
      require("@data/assets/navy/book8/thumbnail/page24.jpg"),
      require("@data/assets/navy/book8/thumbnail/page25.jpg"),
      require("@data/assets/navy/book8/thumbnail/page26.jpg"),
      require("@data/assets/navy/book8/thumbnail/page27.jpg"),
    ],
  },
  //9
  {
    key: "c6-09",
    title: "다람쥐 할아버지의 생신",
    grade: "9권",
    cover: require("@data/assets/navy/book9/images/cover.jpg"),
    background: require("@data/assets/navy/book9/pages/page05.jpg"),
    song: {
      url: require("@data/assets/navy/book9/sounds/page23.mp3"),
      title: "Nǐ mǎi le shénme?",
      caption: [
        "nǐ mǎi le shénme nǐ mǎi le shénme",
        "wǒ mǎi le yí jiàn yīfu hěn piàoliang",
        "nǐ mǎi le shénme nǐ mǎi le shénme",
        "wǒ mǎi le yì shuāng xié hěn hǎokàn",
        "nǐ mǎi le shénme nǐ mǎi le shénme",
        "wǒ mǎi le yì běn shū hěn yǒu yìsi",
        "nǐ mǎi le shénme nǐ mǎi le shénme",
        "wǒ mǎi le yí shù huār hěn xiāng",
      ],
    },
    mov: {
      cn: "9f79b6dd395b822d38b58487ada913de_09",
      en: "f561ba9bab42dc164c2de464d8c6365e_09",
    },
    game: {
      resources: [
        {
          img: require("@data/assets/navy/book9/images/img_N9-02.png"),
          sound: require("@data/assets/navy/book9/sounds/KF09_W_01.mp3"),
          word: "一件衣服|yí jiàn yīfu",
        },
        {
          img: require("@data/assets/navy/book9/images/img_N9-01.png"),
          sound: require("@data/assets/navy/book9/sounds/KF09_W_02.mp3"),
          word: "一双鞋|yì shuāng xié",
        },
        {
          img: require("@data/assets/navy/book9/images/img_N9-04.png"),
          sound: require("@data/assets/navy/book9/sounds/KF09_W_03.mp3"),
          word: "一本书|yì běn shū",
        },
        {
          img: require("@data/assets/navy/book9/images/img_N9-03.png"),
          sound: require("@data/assets/navy/book9/sounds/KF09_W_04.mp3"),
          word: "一束花儿|yí shù huār",
        },
        //

        {
          img: require("@data/assets/navy/book9/images/img_N9-06.png"),
          sound: require("@data/assets/navy/book9/sounds/KF09_W_05.mp3"),
          word: "你买了什么？|Nǐ mǎi le shénme?",
        },
        {
          img: require("@data/assets/navy/book9/images/img_N9-05.png"),
          sound: require("@data/assets/navy/book9/sounds/KF09_W_06.mp3"),
          word: "我买了一件衣服。|Wǒ mǎi le yí jiàn yīfu.",
        },
        {
          img: require("@data/assets/navy/book9/images/img_N9-08.png"),
          sound: require("@data/assets/navy/book9/sounds/KF09_W_07.mp3"),
          word: "我买了一双鞋。|Wǒ mǎi le yì shuāng xié.",
        },
        {
          img: require("@data/assets/navy/book9/images/img_N9-07.png"),
          sound: require("@data/assets/navy/book9/sounds/KF09_W_08.mp3"),
          word: "我买了一本书。|Wǒ mǎi le yì běn shū.",
        },
        {
          img: require("@data/assets/navy/book9/images/img_N9-10.png"),
          sound: require("@data/assets/navy/book9/sounds/KF09_W_09.mp3"),
          word: "他买了一束花儿。|Tā mǎi le yí shù huār.",
        },
        {
          img: require("@data/assets/navy/book9/images/img_N9-09.png"),
          sound: require("@data/assets/navy/book9/sounds/KF09_W_10.mp3"),
          word: "明天是爷爷的生日。|Míngtiān shì yéye de shēngrì.",
        },
        {
          img: require("@data/assets/navy/book9/images/img_N9-12.png"),
          sound: require("@data/assets/navy/book9/sounds/KF09_W_11.mp3"),
          word: "明天见!|Míngtiān jiàn!",
        },
        {
          img: require("@data/assets/navy/book9/images/img_N9-11.png"),
          sound: require("@data/assets/navy/book9/sounds/KF09_W_12.mp3"),
          word: "我有办法了!|Wǒ yǒu bànfǎ le!",
        },
        {
          img: require("@data/assets/navy/book9/images/img_N9-14.png"),
          sound: require("@data/assets/navy/book9/sounds/KF09_W_13.mp3"),
          word: "开始!|Kāishǐ!",
        },
        {
          img: require("@data/assets/navy/book9/images/img_N9-13.png"),
          sound: require("@data/assets/navy/book9/sounds/KF09_W_14.mp3"),
          word: "请进!|Qǐng jìn!",
        },
        {
          img: require("@data/assets/navy/book9/images/img_N9-16.png"),
          sound: require("@data/assets/navy/book9/sounds/KF09_W_15.mp3"),
          word: "给您!|Gěi nín!",
        },
        {
          img: require("@data/assets/navy/book9/images/img_N9-15.png"),
          sound: require("@data/assets/navy/book9/sounds/KF09_W_16.mp3"),
          word: "祝您生日快乐!|Zhù nín shēngrì kuàilè!",
        },
      ],
    },
    word: [
      {
        img: require("@data/assets/navy/book9/images/img_N9-02.png"),
        sound: require("@data/assets/navy/book9/sounds/KF09_W_01.mp3"),
        buttons: [
          { ch2: "yí jiàn yīfu" },
          { ch: "一件衣服" },
          { ko: "옷 한 벌" },
        ],
      },
      {
        img: require("@data/assets/navy/book9/images/img_N9-01.png"),
        sound: require("@data/assets/navy/book9/sounds/KF09_W_02.mp3"),
        buttons: [
          { ch2: "yì shuāng xié" },
          { ch: "一双鞋" },
          { ko: "신발 한 쌍" },
        ],
      },
      {
        img: require("@data/assets/navy/book9/images/img_N9-04.png"),
        sound: require("@data/assets/navy/book9/sounds/KF09_W_03.mp3"),
        buttons: [{ ch2: "yì běn shū" }, { ch: "一本书" }, { ko: "책 한 권" }],
      },
      {
        img: require("@data/assets/navy/book9/images/img_N9-03.png"),
        sound: require("@data/assets/navy/book9/sounds/KF09_W_04.mp3"),
        buttons: [
          { ch2: "yí shù huār" },
          { ch: "一束花儿" },
          { ko: "꽃 한 송이" },
        ],
      },
    ],
    idiom: [
      {
        img: require("@data/assets/navy/book9/images/img_N9-06.png"),
        sound: require("@data/assets/navy/book9/sounds/KF09_W_05.mp3"),
        buttons: [
          { ch2: "Nǐ mǎi le shénme?" },
          { ch: "你买了什么？" },
          { ko: "너는 뭘 샀니?" },
        ],
      },
      {
        img: require("@data/assets/navy/book9/images/img_N9-05.png"),
        sound: require("@data/assets/navy/book9/sounds/KF09_W_06.mp3"),
        buttons: [
          { ch2: "Wǒ mǎi le yí jiàn yīfu." },
          { ch: "我买了一件衣服。" },
          { ko: "나는 옷 한 벌을 샀어." },
        ],
      },
      {
        img: require("@data/assets/navy/book9/images/img_N9-08.png"),
        sound: require("@data/assets/navy/book9/sounds/KF09_W_07.mp3"),
        buttons: [
          { ch2: "Wǒ mǎi le yì shuāng xié." },
          { ch: "我买了一双鞋。" },
          { ko: "나는 신발 한 쌍을 샀어." },
        ],
      },
      {
        img: require("@data/assets/navy/book9/images/img_N9-07.png"),
        sound: require("@data/assets/navy/book9/sounds/KF09_W_08.mp3"),
        buttons: [
          { ch2: "Wǒ mǎi le yì běn shū." },
          { ch: "我买了一本书。" },
          { ko: "나는 책 한 권을 샀어." },
        ],
      },
      {
        img: require("@data/assets/navy/book9/images/img_N9-10.png"),
        sound: require("@data/assets/navy/book9/sounds/KF09_W_09.mp3"),
        buttons: [
          { ch2: "Tā mǎi le yí shù huār." },
          { ch: "他买了一束花儿。" },
          { ko: "그는 꽃 한 송이를 샀어." },
        ],
      },
      {
        img: require("@data/assets/navy/book9/images/img_N9-09.png"),
        sound: require("@data/assets/navy/book9/sounds/KF09_W_10.mp3"),
        buttons: [
          { ch2: "Míngtiān shì yéye de shēngrì." },
          { ch: "明天是爷爷的生日。" },
          { ko: "내일은 할아버지 생신이야." },
        ],
      },
      {
        img: require("@data/assets/navy/book9/images/img_N9-12.png"),
        sound: require("@data/assets/navy/book9/sounds/KF09_W_11.mp3"),
        buttons: [
          { ch2: "Míngtiān jiàn!" },
          { ch: "明天见!" },
          { ko: "내일 봐!" },
        ],
      },
      {
        img: require("@data/assets/navy/book9/images/img_N9-11.png"),
        sound: require("@data/assets/navy/book9/sounds/KF09_W_12.mp3"),
        buttons: [
          { ch2: "Wǒ yǒu bànfǎ le!" },
          { ch: "我有办法了!" },
          { ko: "나는 방법이 있어!" },
        ],
      },
      {
        img: require("@data/assets/navy/book9/images/img_N9-14.png"),
        sound: require("@data/assets/navy/book9/sounds/KF09_W_13.mp3"),
        buttons: [{ ch2: "Kāishǐ!" }, { ch: "开始!" }, { ko: "시작!" }],
      },
      {
        img: require("@data/assets/navy/book9/images/img_N9-13.png"),
        sound: require("@data/assets/navy/book9/sounds/KF09_W_14.mp3"),
        buttons: [{ ch2: "Qǐng jìn!" }, { ch: "请进!" }, { ko: "들어오세요!" }],
      },
      {
        img: require("@data/assets/navy/book9/images/img_N9-16.png"),
        sound: require("@data/assets/navy/book9/sounds/KF09_W_15.mp3"),
        buttons: [{ ch2: "Gěi nín!" }, { ch: "给您!" }, { ko: "드릴게요!" }],
      },
      {
        img: require("@data/assets/navy/book9/images/img_N9-15.png"),
        sound: require("@data/assets/navy/book9/sounds/KF09_W_16.mp3"),
        buttons: [
          { ch2: "Zhù nín shēngrì kuàilè!" },
          { ch: "祝您生日快乐!" },
          { ko: "생일 축하해요!" },
        ],
      },
    ],
    activity: {
      questions: [
        {
          type: "ty1",
          sound: require("@data/assets/navy/book9/sounds/KF09_W_02.mp3"),
          img: require("@data/assets/navy/book9/images/img_N9-01.png"),
          answer: {
            O: true,
            X: false,
          },
        },
        {
          type: "ty2",
          sound: require("@data/assets/navy/book9/sounds/KF09_W_06.mp3"),
          answer: [
            [require("@data/assets/navy/book9/images/img_N9-05.png"), true],
            [require("@data/assets/navy/book9/images/img_N9-07.png"), false],
          ],
        },
        {
          type: "ty3",
          sound: require("@data/assets/navy/book9/sounds/KF09_W_11.mp3"),
          answer: [
            ["明天见!", true],
            ["给您!", false],
          ],
        },
      ],
    },
    pages: [
      {
        book: require("@data/assets/navy/book9/pages/front.jpg"),
        sound: require("@data/assets/navy/book9/sounds/cover.mp3"),
      },

      {
        book: require("@data/assets/navy/book9/pages/page02.jpg"),
      },
      {
        book: require("@data/assets/navy/book9/pages/page03.jpg"),
      },
      {
        book: require("@data/assets/navy/book9/pages/page04.jpg"),
        sound: require("@data/assets/navy/book9/sounds/page04.mp3"),
      },
      {
        book: require("@data/assets/navy/book9/pages/page05.jpg"),
      },
      {
        book: require("@data/assets/navy/book9/pages/page06.jpg"),
        sound: require("@data/assets/navy/book9/sounds/page06.mp3"),
      },
      {
        book: require("@data/assets/navy/book9/pages/page07.jpg"),
      },
      {
        book: require("@data/assets/navy/book9/pages/page08.jpg"),
        sound: require("@data/assets/navy/book9/sounds/page08.mp3"),
      },
      {
        book: require("@data/assets/navy/book9/pages/page09.jpg"),
      },
      {
        book: require("@data/assets/navy/book9/pages/page10.jpg"),
        sound: require("@data/assets/navy/book9/sounds/page10.mp3"),
      },
      {
        book: require("@data/assets/navy/book9/pages/page11.jpg"),
      },
      {
        book: require("@data/assets/navy/book9/pages/page12.jpg"),
        sound: require("@data/assets/navy/book9/sounds/page12.mp3"),
      },
      {
        book: require("@data/assets/navy/book9/pages/page13.jpg"),
      },
      {
        book: require("@data/assets/navy/book9/pages/page14.jpg"),
        sound: require("@data/assets/navy/book9/sounds/page14.mp3"),
      },
      {
        book: require("@data/assets/navy/book9/pages/page15.jpg"),
      },
      {
        book: require("@data/assets/navy/book9/pages/page16.jpg"),
        sound: require("@data/assets/navy/book9/sounds/page16.mp3"),
      },
      {
        book: require("@data/assets/navy/book9/pages/page17.jpg"),
      },
      {
        book: require("@data/assets/navy/book9/pages/page18.jpg"),
        sound: require("@data/assets/navy/book9/sounds/page18.mp3"),
      },
      {
        book: require("@data/assets/navy/book9/pages/page19.jpg"),
      },
      {
        book: require("@data/assets/navy/book9/pages/page20.jpg"),
        sound: require("@data/assets/navy/book9/sounds/page20.mp3"),
      },
      {
        book: require("@data/assets/navy/book9/pages/page21.jpg"),
      },
      {
        book: require("@data/assets/navy/book9/pages/page22.jpg"),
        sound: require("@data/assets/navy/book9/sounds/page22.mp3"),
      },
      {
        book: require("@data/assets/navy/book9/pages/page23.jpg"),
        sound: require("@data/assets/navy/book9/sounds/page23.mp3"),
      },
      {
        book: require("@data/assets/navy/book9/pages/page24.jpg"),
      },
      {
        book: require("@data/assets/navy/book9/pages/page25.jpg"),
      },
      {
        book: require("@data/assets/navy/book9/pages/page26.jpg"),
      },
      {
        book: require("@data/assets/navy/book9/pages/page27.jpg"),
      },
    ],
    thumbnail: [
      require("@data/assets/navy/book9/thumbnail/front.jpg"),
      require("@data/assets/navy/book9/thumbnail/page02.jpg"),
      require("@data/assets/navy/book9/thumbnail/page03.jpg"),
      require("@data/assets/navy/book9/thumbnail/page04.jpg"),
      require("@data/assets/navy/book9/thumbnail/page05.jpg"),
      require("@data/assets/navy/book9/thumbnail/page06.jpg"),
      require("@data/assets/navy/book9/thumbnail/page07.jpg"),
      require("@data/assets/navy/book9/thumbnail/page08.jpg"),
      require("@data/assets/navy/book9/thumbnail/page09.jpg"),
      require("@data/assets/navy/book9/thumbnail/page10.jpg"),
      require("@data/assets/navy/book9/thumbnail/page11.jpg"),
      require("@data/assets/navy/book9/thumbnail/page12.jpg"),
      require("@data/assets/navy/book9/thumbnail/page13.jpg"),
      require("@data/assets/navy/book9/thumbnail/page14.jpg"),
      require("@data/assets/navy/book9/thumbnail/page15.jpg"),
      require("@data/assets/navy/book9/thumbnail/page16.jpg"),
      require("@data/assets/navy/book9/thumbnail/page17.jpg"),
      require("@data/assets/navy/book9/thumbnail/page18.jpg"),
      require("@data/assets/navy/book9/thumbnail/page19.jpg"),
      require("@data/assets/navy/book9/thumbnail/page20.jpg"),
      require("@data/assets/navy/book9/thumbnail/page21.jpg"),
      require("@data/assets/navy/book9/thumbnail/page22.jpg"),
      require("@data/assets/navy/book9/thumbnail/page23.jpg"),
      require("@data/assets/navy/book9/thumbnail/page24.jpg"),
      require("@data/assets/navy/book9/thumbnail/page25.jpg"),
      require("@data/assets/navy/book9/thumbnail/page26.jpg"),
      require("@data/assets/navy/book9/thumbnail/page27.jpg"),
    ],
  },
  //10
  {
    key: "c6-10",
    title: "원숭이와 마법쿠키",
    grade: "10권",
    cover: require("@data/assets/navy/book10/images/cover.jpg"),
    background: require("@data/assets/navy/book10/pages/page05.jpg"),
    song: {
      url: require("@data/assets/navy/book10/sounds/page23.mp3"),
      title: "Nǐ zài nǎr?",
      caption: [
        "nǐ zài nǎr nǐ zài nǎr qiánbian qiánbian wǒ zài nǐ de qiánbian",
        "nǐ zài nǎr nǐ zài nǎr hòubian hòubian wǒ zài nǐ de hòubian",
        "nǐ zài nǎr nǐ zài nǎr zuǒbian zuǒbian wǒ zài nǐ de zuǒbian",
        "nǐ zài nǎr nǐ zài nǎr yòubian yòubian wǒ zài nǐ de yòubian",
      ],
    },
    mov: {
      cn: "57b2c27da5d1bc7de4d7e0662f8081c0_10",
      en: "6d70bf4e33804abe44dcb398229bca79_10",
    },
    game: {
      resources: [
        {
          img: require("@data/assets/navy/book10/images/img_N10-02.png"),
          sound: require("@data/assets/navy/book10/sounds/KF10_W_01.mp3"),
          word: "前边|qiánbian",
        },
        {
          img: require("@data/assets/navy/book10/images/img_N10-01.png"),
          sound: require("@data/assets/navy/book10/sounds/KF10_W_02.mp3"),
          word: "后边|hòubian",
        },
        {
          img: require("@data/assets/navy/book10/images/img_N10-03.png"),
          sound: require("@data/assets/navy/book10/sounds/KF10_W_03.mp3"),
          word: "左边|zuǒbian",
        },
        {
          img: require("@data/assets/navy/book10/images/img_N10-04.png"),
          sound: require("@data/assets/navy/book10/sounds/KF10_W_04.mp3"),
          word: "右边|yòubian",
        },
        //

        {
          img: require("@data/assets/navy/book10/images/img_N10-06.png"),
          sound: require("@data/assets/navy/book10/sounds/KF10_W_05.mp3"),
          word: "你在哪儿？|Nǐ zài nǎr?",
        },
        {
          img: require("@data/assets/navy/book10/images/img_N10-05.png"),
          sound: require("@data/assets/navy/book10/sounds/KF10_W_06.mp3"),
          word: "我在你的前边。|Wǒ zài nǐ de qiánbian.",
        },
        {
          img: require("@data/assets/navy/book10/images/img_N10-08.png"),
          sound: require("@data/assets/navy/book10/sounds/KF10_W_07.mp3"),
          word: "我在你的后边。|Wǒ zài nǐ de hòubian.",
        },
        {
          img: require("@data/assets/navy/book10/images/img_N10-10.png"),
          sound: require("@data/assets/navy/book10/sounds/KF10_W_08.mp3"),
          word: "我在你的左边。|Wǒ zài nǐ de zuǒbian.",
        },
        {
          img: require("@data/assets/navy/book10/images/img_N10-07.png"),
          sound: require("@data/assets/navy/book10/sounds/KF10_W_09.mp3"),
          word: "我在你的右边。|Wǒ zài nǐ de yòubian.",
        },
        {
          img: require("@data/assets/navy/book10/images/img_N10-09.png"),
          sound: require("@data/assets/navy/book10/sounds/KF10_W_10.mp3"),
          word: "太过分了!|Tài guòfèn le!",
        },
        {
          img: require("@data/assets/navy/book10/images/img_N10-12.png"),
          sound: require("@data/assets/navy/book10/sounds/KF10_W_11.mp3"),
          word: "这是我的!|Zhè shì wǒ de!",
        },
        {
          img: require("@data/assets/navy/book10/images/img_N10-11.png"),
          sound: require("@data/assets/navy/book10/sounds/KF10_W_12.mp3"),
          word: "他不见了!|Tā bú jiàn le!",
        },
        {
          img: require("@data/assets/navy/book10/images/img_N10-14.png"),
          sound: require("@data/assets/navy/book10/sounds/KF10_W_13.mp3"),
          word: "别这样!|Bié zhèyàng!",
        },
        {
          img: require("@data/assets/navy/book10/images/img_N10-13.png"),
          sound: require("@data/assets/navy/book10/sounds/KF10_W_14.mp3"),
          word: "我尝尝!|Wǒ chángchang!",
        },
        {
          img: require("@data/assets/navy/book10/images/img_N10-16.png"),
          sound: require("@data/assets/navy/book10/sounds/KF10_W_15.mp3"),
          word: "我错了。|Wǒ cuò le.",
        },
        {
          img: require("@data/assets/navy/book10/images/img_N10-15.png"),
          sound: require("@data/assets/navy/book10/sounds/KF10_W_16.mp3"),
          word: "我保证!|Wǒ bǎozhèng!",
        },
        {
          img: require("@data/assets/navy/book10/images/img_N10-18.png"),
          sound: require("@data/assets/navy/book10/sounds/KF10_W_17.mp3"),
          word: "真好玩儿!|Zhēn hǎowánr!",
        },
        {
          img: require("@data/assets/navy/book10/images/img_N10-17.png"),
          sound: require("@data/assets/navy/book10/sounds/KF10_W_18.mp3"),
          word: "当然看得见!|Dāngrán kàn de jiàn!",
        },
      ],
    },
    word: [
      {
        img: require("@data/assets/navy/book10/images/img_N10-02.png"),
        sound: require("@data/assets/navy/book10/sounds/KF10_W_01.mp3"),
        buttons: [{ ch2: "qiánbian" }, { ch: "前边" }, { ko: "앞쪽" }],
      },
      {
        img: require("@data/assets/navy/book10/images/img_N10-01.png"),
        sound: require("@data/assets/navy/book10/sounds/KF10_W_02.mp3"),
        buttons: [{ ch2: "hòubian" }, { ch: "后边" }, { ko: "뒤쪽" }],
      },
      {
        img: require("@data/assets/navy/book10/images/img_N10-03.png"),
        sound: require("@data/assets/navy/book10/sounds/KF10_W_03.mp3"),
        buttons: [{ ch2: "zuǒbian" }, { ch: "左边" }, { ko: "왼쪽" }],
      },
      {
        img: require("@data/assets/navy/book10/images/img_N10-04.png"),
        sound: require("@data/assets/navy/book10/sounds/KF10_W_04.mp3"),
        buttons: [{ ch2: "yòubian" }, { ch: "右边" }, { ko: "오른쪽" }],
      },
    ],
    idiom: [
      {
        img: require("@data/assets/navy/book10/images/img_N10-06.png"),
        sound: require("@data/assets/navy/book10/sounds/KF10_W_05.mp3"),
        buttons: [
          { ch2: "Nǐ zài nǎr?" },
          { ch: "你在哪儿？" },
          { ko: "너는 어디에 있어요?" },
        ],
      },
      {
        img: require("@data/assets/navy/book10/images/img_N10-05.png"),
        sound: require("@data/assets/navy/book10/sounds/KF10_W_06.mp3"),
        buttons: [
          { ch2: "Wǒ zài nǐ de qiánbian." },
          { ch: "我在你的前边。" },
          { ko: "나는 네 앞에 있어." },
        ],
      },
      {
        img: require("@data/assets/navy/book10/images/img_N10-08.png"),
        sound: require("@data/assets/navy/book10/sounds/KF10_W_07.mp3"),
        buttons: [
          { ch2: "Wǒ zài nǐ de hòubian." },
          { ch: "我在你的后边。" },
          { ko: "나는 네 뒤에 있어." },
        ],
      },
      {
        img: require("@data/assets/navy/book10/images/img_N10-10.png"),
        sound: require("@data/assets/navy/book10/sounds/KF10_W_08.mp3"),
        buttons: [
          { ch2: "Wǒ zài nǐ de zuǒbian." },
          { ch: "我在你的左边。" },
          { ko: "나는 네 왼쪽에 있어." },
        ],
      },
      {
        img: require("@data/assets/navy/book10/images/img_N10-07.png"),
        sound: require("@data/assets/navy/book10/sounds/KF10_W_09.mp3"),
        buttons: [
          { ch2: "Wǒ zài nǐ de yòubian." },
          { ch: "我在你的右边。" },
          { ko: "나는 네 오른쪽에 있어." },
        ],
      },
      {
        img: require("@data/assets/navy/book10/images/img_N10-09.png"),
        sound: require("@data/assets/navy/book10/sounds/KF10_W_10.mp3"),
        buttons: [
          { ch2: "Tài guòfèn le!" },
          { ch: "太过分了!" },
          { ko: "너무해!" },
        ],
      },
      {
        img: require("@data/assets/navy/book10/images/img_N10-12.png"),
        sound: require("@data/assets/navy/book10/sounds/KF10_W_11.mp3"),
        buttons: [
          { ch2: "Zhè shì wǒ de!" },
          { ch: "这是我的!" },
          { ko: "이것은 내 것이야!" },
        ],
      },
      {
        img: require("@data/assets/navy/book10/images/img_N10-11.png"),
        sound: require("@data/assets/navy/book10/sounds/KF10_W_12.mp3"),
        buttons: [
          { ch2: "Tā bú jiàn le!" },
          { ch: "他不见了!" },
          { ko: "그가 보이지 않아!" },
        ],
      },
      {
        img: require("@data/assets/navy/book10/images/img_N10-14.png"),
        sound: require("@data/assets/navy/book10/sounds/KF10_W_13.mp3"),
        buttons: [
          { ch2: "Bié zhèyàng!" },
          { ch: "别这样!" },
          { ko: "이렇게 하지 마!" },
        ],
      },
      {
        img: require("@data/assets/navy/book10/images/img_N10-13.png"),
        sound: require("@data/assets/navy/book10/sounds/KF10_W_14.mp3"),
        buttons: [
          { ch2: "Wǒ chángchang!" },
          { ch: "我尝尝!" },
          { ko: "내가 먹어 볼게!" },
        ],
      },
      {
        img: require("@data/assets/navy/book10/images/img_N10-16.png"),
        sound: require("@data/assets/navy/book10/sounds/KF10_W_15.mp3"),
        buttons: [
          { ch2: "Wǒ cuò le." },
          { ch: "我错了。" },
          { ko: "제가 잘못했어요." },
        ],
      },
      {
        img: require("@data/assets/navy/book10/images/img_N10-15.png"),
        sound: require("@data/assets/navy/book10/sounds/KF10_W_16.mp3"),
        buttons: [
          { ch2: "Wǒ bǎozhèng!" },
          { ch: "我保证!" },
          { ko: "약속할게!" },
        ],
      },
      {
        img: require("@data/assets/navy/book10/images/img_N10-18.png"),
        sound: require("@data/assets/navy/book10/sounds/KF10_W_17.mp3"),
        buttons: [
          { ch2: "Zhēn hǎowánr!" },
          { ch: "真好玩儿!" },
          { ko: "정말 재미있다!" },
        ],
      },
      {
        img: require("@data/assets/navy/book10/images/img_N10-17.png"),
        sound: require("@data/assets/navy/book10/sounds/KF10_W_18.mp3"),
        buttons: [
          { ch2: "Dāngrán kàn de jiàn!" },
          { ch: "当然看得见!" },
          { ko: "당연히 보여요!" },
        ],
      },
    ],
    activity: {
      questions: [
        {
          type: "ty1",
          sound: require("@data/assets/navy/book10/sounds/KF10_W_04.mp3"),
          img: require("@data/assets/navy/book10/images/img_N10-04.png"),
          answer: {
            O: true,
            X: false,
          },
        },
        {
          type: "ty2",
          sound: require("@data/assets/navy/book10/sounds/KF10_W_06.mp3"),
          answer: [
            [require("@data/assets/navy/book10/images/img_N10-05.png"), true],
            [require("@data/assets/navy/book10/images/img_N10-08.png"), false],
          ],
        },
        {
          type: "ty3",
          sound: require("@data/assets/navy/book10/sounds/KF10_W_17.mp3"),
          answer: [
            ["我错了。", false],
            ["真好玩儿!", true],
          ],
        },
      ],
    },
    pages: [
      {
        book: require("@data/assets/navy/book10/pages/front.jpg"),
        sound: require("@data/assets/navy/book10/sounds/cover.mp3"),
      },

      {
        book: require("@data/assets/navy/book10/pages/page02.jpg"),
      },
      {
        book: require("@data/assets/navy/book10/pages/page03.jpg"),
      },
      {
        book: require("@data/assets/navy/book10/pages/page04.jpg"),
        sound: require("@data/assets/navy/book10/sounds/page04.mp3"),
      },
      {
        book: require("@data/assets/navy/book10/pages/page05.jpg"),
      },
      {
        book: require("@data/assets/navy/book10/pages/page06.jpg"),
        sound: require("@data/assets/navy/book10/sounds/page06.mp3"),
      },
      {
        book: require("@data/assets/navy/book10/pages/page07.jpg"),
      },
      {
        book: require("@data/assets/navy/book10/pages/page08.jpg"),
        sound: require("@data/assets/navy/book10/sounds/page08.mp3"),
      },
      {
        book: require("@data/assets/navy/book10/pages/page09.jpg"),
      },
      {
        book: require("@data/assets/navy/book10/pages/page10.jpg"),
        sound: require("@data/assets/navy/book10/sounds/page10.mp3"),
      },
      {
        book: require("@data/assets/navy/book10/pages/page11.jpg"),
      },
      {
        book: require("@data/assets/navy/book10/pages/page12.jpg"),
        sound: require("@data/assets/navy/book10/sounds/page12.mp3"),
      },
      {
        book: require("@data/assets/navy/book10/pages/page13.jpg"),
      },
      {
        book: require("@data/assets/navy/book10/pages/page14.jpg"),
        sound: require("@data/assets/navy/book10/sounds/page14.mp3"),
      },
      {
        book: require("@data/assets/navy/book10/pages/page15.jpg"),
      },
      {
        book: require("@data/assets/navy/book10/pages/page16.jpg"),
        sound: require("@data/assets/navy/book10/sounds/page16.mp3"),
      },
      {
        book: require("@data/assets/navy/book10/pages/page17.jpg"),
      },
      {
        book: require("@data/assets/navy/book10/pages/page18.jpg"),
        sound: require("@data/assets/navy/book10/sounds/page18.mp3"),
      },
      {
        book: require("@data/assets/navy/book10/pages/page19.jpg"),
      },
      {
        book: require("@data/assets/navy/book10/pages/page20.jpg"),
        sound: require("@data/assets/navy/book10/sounds/page20.mp3"),
      },
      {
        book: require("@data/assets/navy/book10/pages/page21.jpg"),
      },
      {
        book: require("@data/assets/navy/book10/pages/page22.jpg"),
        sound: require("@data/assets/navy/book10/sounds/page22.mp3"),
      },
      {
        book: require("@data/assets/navy/book10/pages/page23.jpg"),
        sound: require("@data/assets/navy/book10/sounds/page23.mp3"),
      },
      {
        book: require("@data/assets/navy/book10/pages/page24.jpg"),
      },
      {
        book: require("@data/assets/navy/book10/pages/page25.jpg"),
      },
      {
        book: require("@data/assets/navy/book10/pages/page26.jpg"),
      },
      {
        book: require("@data/assets/navy/book10/pages/page27.jpg"),
      },
    ],
    thumbnail: [
      require("@data/assets/navy/book10/thumbnail/front.jpg"),
      require("@data/assets/navy/book10/thumbnail/page02.jpg"),
      require("@data/assets/navy/book10/thumbnail/page03.jpg"),
      require("@data/assets/navy/book10/thumbnail/page04.jpg"),
      require("@data/assets/navy/book10/thumbnail/page05.jpg"),
      require("@data/assets/navy/book10/thumbnail/page06.jpg"),
      require("@data/assets/navy/book10/thumbnail/page07.jpg"),
      require("@data/assets/navy/book10/thumbnail/page08.jpg"),
      require("@data/assets/navy/book10/thumbnail/page09.jpg"),
      require("@data/assets/navy/book10/thumbnail/page10.jpg"),
      require("@data/assets/navy/book10/thumbnail/page11.jpg"),
      require("@data/assets/navy/book10/thumbnail/page12.jpg"),
      require("@data/assets/navy/book10/thumbnail/page13.jpg"),
      require("@data/assets/navy/book10/thumbnail/page14.jpg"),
      require("@data/assets/navy/book10/thumbnail/page15.jpg"),
      require("@data/assets/navy/book10/thumbnail/page16.jpg"),
      require("@data/assets/navy/book10/thumbnail/page17.jpg"),
      require("@data/assets/navy/book10/thumbnail/page18.jpg"),
      require("@data/assets/navy/book10/thumbnail/page19.jpg"),
      require("@data/assets/navy/book10/thumbnail/page20.jpg"),
      require("@data/assets/navy/book10/thumbnail/page21.jpg"),
      require("@data/assets/navy/book10/thumbnail/page22.jpg"),
      require("@data/assets/navy/book10/thumbnail/page23.jpg"),
      require("@data/assets/navy/book10/thumbnail/page24.jpg"),
      require("@data/assets/navy/book10/thumbnail/page25.jpg"),
      require("@data/assets/navy/book10/thumbnail/page26.jpg"),
      require("@data/assets/navy/book10/thumbnail/page27.jpg"),
    ],
  },
  //11
  {
    key: "c6-11",
    title: "공주님은 칭찬을 좋아해",
    grade: "11권",
    cover: require("@data/assets/navy/book11/images/cover.jpg"),
    background: require("@data/assets/navy/book11/pages/page05.jpg"),
    song: {
      url: require("@data/assets/navy/book11/sounds/page23.mp3"),
      title: "Wǒ xiě Hànzì xiě de zěnmeyàng?",
      caption: [
        "xiě Hànzì wǒ xiě Hànzì xiě de zěnmeyàng",
        "nǐ xiě de hěn hǎo nǐ xiě de bù hǎo",
        "huà huàr wǒ huàhuàr huà de zěnmeyàng",
        "nǐ huà de hěn hǎo nǐ huà de bù hǎo",
        "chànggēr wǒ chànggēr chàng de zěnmeyàng",
        "nǐ chàng de hěn hǎo nǐ chàng de bù hǎo",
        "tiàowǔ wǒ tiàowǔ tiào de zěnmeyàng",
        "nǐ tiào de hěn hǎo nǐ tiào de bù hǎo",
      ],
    },
    mov: {
      cn: "4d6a47790cddd3be4ffee0bfc3e76df3_11",
      en: "0ea4b00ea07b0fe170dba7a735ed1778_11",
    },
    game: {
      resources: [
        {
          img: require("@data/assets/navy/book11/images/img_N11-02.png"),
          sound: require("@data/assets/navy/book11/sounds/KF11_W_01.mp3"),
          word: "写汉字|xiě Hànzì",
        },
        {
          img: require("@data/assets/navy/book11/images/img_N11-01.png"),
          sound: require("@data/assets/navy/book11/sounds/KF11_W_02.mp3"),
          word: "画画儿|huàhuàr",
        },
        {
          img: require("@data/assets/navy/book11/images/img_N11-04.png"),
          sound: require("@data/assets/navy/book11/sounds/KF11_W_03.mp3"),
          word: "唱歌儿|chànggēr",
        },
        {
          img: require("@data/assets/navy/book11/images/img_N11-03.png"),
          sound: require("@data/assets/navy/book11/sounds/KF11_W_04.mp3"),
          word: "跳舞|tiàowǔ",
        },
        {
          img: require("@data/assets/navy/book11/images/img_N11-06.png"),
          sound: require("@data/assets/navy/book11/sounds/KF11_W_05.mp3"),
          word: "我写汉字写得怎么样？|Wǒ xiě Hànzì xiě de zěnmeyàng?",
        },
        {
          img: require("@data/assets/navy/book11/images/img_N11-05.png"),
          sound: require("@data/assets/navy/book11/sounds/KF11_W_06.mp3"),
          word: "你写得很好。|Nǐ xiě de hěn hǎo.",
        },
        {
          img: require("@data/assets/navy/book11/images/img_N11-08.png"),
          sound: require("@data/assets/navy/book11/sounds/KF11_W_07.mp3"),
          word: "我画画儿画得怎么样？|Wǒ huàhuàr huà de zěnmeyàng?",
        },
        {
          img: require("@data/assets/navy/book11/images/img_N11-07.png"),
          sound: require("@data/assets/navy/book11/sounds/KF11_W_08.mp3"),
          word: "你画得很好。|Nǐ huà de hěn hǎo.",
        },
        {
          img: require("@data/assets/navy/book11/images/img_N11-10.png"),
          sound: require("@data/assets/navy/book11/sounds/KF11_W_09.mp3"),
          word: "我唱歌儿唱得怎么样？|Wǒ chànggēr chàng de zěnmeyàng?",
        },
        {
          img: require("@data/assets/navy/book11/images/img_N11-09.png"),
          sound: require("@data/assets/navy/book11/sounds/KF11_W_10.mp3"),
          word: "你唱得不好。|Nǐ chàng de bù hǎo.",
        },
        {
          img: require("@data/assets/navy/book11/images/img_N11-12.png"),
          sound: require("@data/assets/navy/book11/sounds/KF11_W_11.mp3"),
          word: "我跳舞跳得怎么样？|Wǒ tiàowǔ tiào de zěnmeyàng?",
        },
        {
          img: require("@data/assets/navy/book11/images/img_N11-11.png"),
          sound: require("@data/assets/navy/book11/sounds/KF11_W_12.mp3"),
          word: "你跳得不好。|Nǐ tiào de bù hǎo.",
        },
        {
          img: require("@data/assets/navy/book11/images/img_N11-14.png"),
          sound: require("@data/assets/navy/book11/sounds/KF11_W_13.mp3"),
          word: "真可爱!|Zhēn kě’ài!",
        },
        {
          img: require("@data/assets/navy/book11/images/img_N11-13.png"),
          sound: require("@data/assets/navy/book11/sounds/KF11_W_14.mp3"),
          word: "你唱得很好。|Nǐ chàng de hěn hǎo.",
        },
        {
          img: require("@data/assets/navy/book11/images/img_N11-16.png"),
          sound: require("@data/assets/navy/book11/sounds/KF11_W_15.mp3"),
          word: "不可能!|Bù kěnéng!",
        },
        {
          img: require("@data/assets/navy/book11/images/img_N11-15.png"),
          sound: require("@data/assets/navy/book11/sounds/KF11_W_16.mp3"),
          word: "你跳得很好。|Nǐ tiào de hěn hǎo.",
        },
        {
          img: require("@data/assets/navy/book11/images/img_N11-17.png"),
          sound: require("@data/assets/navy/book11/sounds/KF11_W_17.mp3"),
          word: "好多了!|Hǎo duō le!",
        },
        {
          img: require("@data/assets/navy/book11/images/img_N11-20.png"),
          sound: require("@data/assets/navy/book11/sounds/KF11_W_18.mp3"),
          word: "哇!真漂亮!|Wā! Zhēn piàoliang!",
        },
        {
          img: require("@data/assets/navy/book11/images/img_N11-18.png"),
          sound: require("@data/assets/navy/book11/sounds/KF11_W_19.mp3"),
          word: "真了不起!|Zhēn liǎobuqǐ!",
        },
        {
          img: require("@data/assets/navy/book11/images/img_N11-19.png"),
          sound: require("@data/assets/navy/book11/sounds/KF11_W_20.mp3"),
          word: "别撒谎!|Bié sā huǎng!",
        },
      ],
    },
    word: [
      {
        img: require("@data/assets/navy/book11/images/img_N11-02.png"),
        sound: require("@data/assets/navy/book11/sounds/KF11_W_01.mp3"),
        buttons: [
          { ch2: "xiě Hànzì" },
          { ch: "写汉字" },
          { ko: "한자를 쓰다" },
        ],
      },
      {
        img: require("@data/assets/navy/book11/images/img_N11-01.png"),
        sound: require("@data/assets/navy/book11/sounds/KF11_W_02.mp3"),
        buttons: [
          { ch2: "huàhuàr" },
          { ch: "画画儿" },
          { ko: "그림을 그리다" },
        ],
      },
      {
        img: require("@data/assets/navy/book11/images/img_N11-04.png"),
        sound: require("@data/assets/navy/book11/sounds/KF11_W_03.mp3"),
        buttons: [
          { ch2: "chànggēr" },
          { ch: "唱歌儿" },
          { ko: "노래를 부르다" },
        ],
      },
      {
        img: require("@data/assets/navy/book11/images/img_N11-03.png"),
        sound: require("@data/assets/navy/book11/sounds/KF11_W_04.mp3"),
        buttons: [{ ch2: "tiàowǔ" }, { ch: "跳舞" }, { ko: "춤을 추다" }],
      },
    ],
    idiom: [
      {
        img: require("@data/assets/navy/book11/images/img_N11-06.png"),
        sound: require("@data/assets/navy/book11/sounds/KF11_W_05.mp3"),
        buttons: [
          { ch2: "Wǒ xiě Hànzì xiě de zěnmeyàng?" },
          { ch: "我写汉字写得怎么样？" },
          { ko: "내가 쓴 한자 어때?" },
        ],
      },
      {
        img: require("@data/assets/navy/book11/images/img_N11-05.png"),
        sound: require("@data/assets/navy/book11/sounds/KF11_W_06.mp3"),
        buttons: [
          { ch2: "Nǐ xiě de hěn hǎo." },
          { ch: "你写得很好。" },
          { ko: "너 정말 잘 쓰는구나." },
        ],
      },
      {
        img: require("@data/assets/navy/book11/images/img_N11-08.png"),
        sound: require("@data/assets/navy/book11/sounds/KF11_W_07.mp3"),
        buttons: [
          { ch2: "Wǒ huàhuàr huà de zěnmeyàng?" },
          { ch: "我画画儿画得怎么样？" },
          { ko: "내가 그림 그림 어때?" },
        ],
      },
      {
        img: require("@data/assets/navy/book11/images/img_N11-07.png"),
        sound: require("@data/assets/navy/book11/sounds/KF11_W_08.mp3"),
        buttons: [
          { ch2: "Nǐ huà de hěn hǎo." },
          { ch: "你画得很好。" },
          { ko: "너 정말 잘 그렸구나." },
        ],
      },
      {
        img: require("@data/assets/navy/book11/images/img_N11-10.png"),
        sound: require("@data/assets/navy/book11/sounds/KF11_W_09.mp3"),
        buttons: [
          { ch2: "Wǒ chànggēr chàng de zěnmeyàng?" },
          { ch: "我唱歌儿唱得怎么样？" },
          { ko: "내가 부르는 노래 어때?" },
        ],
      },
      {
        img: require("@data/assets/navy/book11/images/img_N11-09.png"),
        sound: require("@data/assets/navy/book11/sounds/KF11_W_10.mp3"),
        buttons: [
          { ch2: "Nǐ chàng de bù hǎo." },
          { ch: "你唱得不好。" },
          { ko: "너 정말 잘 못 부르는구나." },
        ],
      },
      {
        img: require("@data/assets/navy/book11/images/img_N11-12.png"),
        sound: require("@data/assets/navy/book11/sounds/KF11_W_11.mp3"),
        buttons: [
          { ch2: "Wǒ tiàowǔ tiào de zěnmeyàng?" },
          { ch: "我跳舞跳得怎么样？" },
          { ko: "나 춤 추는 게 어때?" },
        ],
      },
      {
        img: require("@data/assets/navy/book11/images/img_N11-11.png"),
        sound: require("@data/assets/navy/book11/sounds/KF11_W_12.mp3"),
        buttons: [
          { ch2: "Nǐ tiào de bù hǎo." },
          { ch: "你跳得不好。" },
          { ko: "너 정말 춤을 잘 못 추는구나." },
        ],
      },
      {
        img: require("@data/assets/navy/book11/images/img_N11-14.png"),
        sound: require("@data/assets/navy/book11/sounds/KF11_W_13.mp3"),
        buttons: [
          { ch2: "Zhēn kě’ài!" },
          { ch: "真可爱!" },
          { ko: "정말 귀여워!" },
        ],
      },
      {
        img: require("@data/assets/navy/book11/images/img_N11-13.png"),
        sound: require("@data/assets/navy/book11/sounds/KF11_W_14.mp3"),
        buttons: [
          { ch2: "Nǐ chàng de hěn hǎo." },
          { ch: "你唱得很好。" },
          { ko: "너는 노래를 잘 불러." },
        ],
      },
      {
        img: require("@data/assets/navy/book11/images/img_N11-16.png"),
        sound: require("@data/assets/navy/book11/sounds/KF11_W_15.mp3"),
        buttons: [
          { ch2: "Bù kěnéng!" },
          { ch: "不可能!" },
          { ko: "할 수 없어!" },
        ],
      },
      {
        img: require("@data/assets/navy/book11/images/img_N11-15.png"),
        sound: require("@data/assets/navy/book11/sounds/KF11_W_16.mp3"),
        buttons: [
          { ch2: "Nǐ tiào de hěn hǎo." },
          { ch: "你跳得很好。" },
          { ko: "너는 춤을 잘 춰." },
        ],
      },
      {
        img: require("@data/assets/navy/book11/images/img_N11-17.png"),
        sound: require("@data/assets/navy/book11/sounds/KF11_W_17.mp3"),
        buttons: [
          { ch2: "Hǎo duō le!" },
          { ch: "好多了!" },
          { ko: "많이 좋아졌어!" },
        ],
      },
      {
        img: require("@data/assets/navy/book11/images/img_N11-20.png"),
        sound: require("@data/assets/navy/book11/sounds/KF11_W_18.mp3"),
        buttons: [
          { ch2: "Wā! Zhēn piàoliang!" },
          { ch: "哇!真漂亮!" },
          { ko: "와! 정말 예뻐!" },
        ],
      },
      {
        img: require("@data/assets/navy/book11/images/img_N11-18.png"),
        sound: require("@data/assets/navy/book11/sounds/KF11_W_19.mp3"),
        buttons: [
          { ch2: "Zhēn liǎobuqǐ!" },
          { ch: "真了不起!" },
          { ko: "정말 대단해!" },
        ],
      },
      {
        img: require("@data/assets/navy/book11/images/img_N11-19.png"),
        sound: require("@data/assets/navy/book11/sounds/KF11_W_20.mp3"),
        buttons: [
          { ch2: "Bié sā huǎng!" },
          { ch: "别撒谎!" },
          { ko: "거짓말 하지 마!" },
        ],
      },
    ],
    activity: {
      questions: [
        {
          type: "ty1",
          sound: require("@data/assets/navy/book11/sounds/KF11_W_03.mp3"),
          img: require("@data/assets/navy/book11/images/img_N11-01.png"),
          answer: {
            O: false,
            X: true,
          },
        },
        {
          type: "ty2",
          sound: require("@data/assets/navy/book11/sounds/KF11_W_10.mp3"),
          answer: [
            [require("@data/assets/navy/book11/images/img_N11-09.png"), true],
            [require("@data/assets/navy/book11/images/img_N11-11.png"), false],
          ],
        },
        {
          type: "ty3",
          sound: require("@data/assets/navy/book11/sounds/KF11_W_13.mp3"),
          answer: [
            ["真可爱!", true],
            ["不可能!", false],
          ],
        },
      ],
    },
    pages: [
      {
        book: require("@data/assets/navy/book11/pages/front.jpg"),
        sound: require("@data/assets/navy/book11/sounds/cover.mp3"),
      },

      {
        book: require("@data/assets/navy/book11/pages/page02.jpg"),
      },
      {
        book: require("@data/assets/navy/book11/pages/page03.jpg"),
      },
      {
        book: require("@data/assets/navy/book11/pages/page04.jpg"),
        sound: require("@data/assets/navy/book11/sounds/page04.mp3"),
      },
      {
        book: require("@data/assets/navy/book11/pages/page05.jpg"),
      },
      {
        book: require("@data/assets/navy/book11/pages/page06.jpg"),
        sound: require("@data/assets/navy/book11/sounds/page06.mp3"),
      },
      {
        book: require("@data/assets/navy/book11/pages/page07.jpg"),
      },
      {
        book: require("@data/assets/navy/book11/pages/page08.jpg"),
        sound: require("@data/assets/navy/book11/sounds/page08.mp3"),
      },
      {
        book: require("@data/assets/navy/book11/pages/page09.jpg"),
      },
      {
        book: require("@data/assets/navy/book11/pages/page10.jpg"),
        sound: require("@data/assets/navy/book11/sounds/page10.mp3"),
      },
      {
        book: require("@data/assets/navy/book11/pages/page11.jpg"),
      },
      {
        book: require("@data/assets/navy/book11/pages/page12.jpg"),
        sound: require("@data/assets/navy/book11/sounds/page12.mp3"),
      },
      {
        book: require("@data/assets/navy/book11/pages/page13.jpg"),
      },
      {
        book: require("@data/assets/navy/book11/pages/page14.jpg"),
        sound: require("@data/assets/navy/book11/sounds/page14.mp3"),
      },
      {
        book: require("@data/assets/navy/book11/pages/page15.jpg"),
      },
      {
        book: require("@data/assets/navy/book11/pages/page16.jpg"),
        sound: require("@data/assets/navy/book11/sounds/page16.mp3"),
      },
      {
        book: require("@data/assets/navy/book11/pages/page17.jpg"),
      },
      {
        book: require("@data/assets/navy/book11/pages/page18.jpg"),
        sound: require("@data/assets/navy/book11/sounds/page18.mp3"),
      },
      {
        book: require("@data/assets/navy/book11/pages/page19.jpg"),
      },
      {
        book: require("@data/assets/navy/book11/pages/page20.jpg"),
        sound: require("@data/assets/navy/book11/sounds/page20.mp3"),
      },
      {
        book: require("@data/assets/navy/book11/pages/page21.jpg"),
      },
      {
        book: require("@data/assets/navy/book11/pages/page22.jpg"),
        sound: require("@data/assets/navy/book11/sounds/page22.mp3"),
      },
      {
        book: require("@data/assets/navy/book11/pages/page23.jpg"),
        sound: require("@data/assets/navy/book11/sounds/page23.mp3"),
      },
      {
        book: require("@data/assets/navy/book11/pages/page24.jpg"),
      },
      {
        book: require("@data/assets/navy/book11/pages/page25.jpg"),
      },
      {
        book: require("@data/assets/navy/book11/pages/page26.jpg"),
      },
      {
        book: require("@data/assets/navy/book11/pages/page27.jpg"),
      },
    ],
    thumbnail: [
      require("@data/assets/navy/book11/thumbnail/front.jpg"),
      require("@data/assets/navy/book11/thumbnail/page02.jpg"),
      require("@data/assets/navy/book11/thumbnail/page03.jpg"),
      require("@data/assets/navy/book11/thumbnail/page04.jpg"),
      require("@data/assets/navy/book11/thumbnail/page05.jpg"),
      require("@data/assets/navy/book11/thumbnail/page06.jpg"),
      require("@data/assets/navy/book11/thumbnail/page07.jpg"),
      require("@data/assets/navy/book11/thumbnail/page08.jpg"),
      require("@data/assets/navy/book11/thumbnail/page09.jpg"),
      require("@data/assets/navy/book11/thumbnail/page10.jpg"),
      require("@data/assets/navy/book11/thumbnail/page11.jpg"),
      require("@data/assets/navy/book11/thumbnail/page12.jpg"),
      require("@data/assets/navy/book11/thumbnail/page13.jpg"),
      require("@data/assets/navy/book11/thumbnail/page14.jpg"),
      require("@data/assets/navy/book11/thumbnail/page15.jpg"),
      require("@data/assets/navy/book11/thumbnail/page16.jpg"),
      require("@data/assets/navy/book11/thumbnail/page17.jpg"),
      require("@data/assets/navy/book11/thumbnail/page18.jpg"),
      require("@data/assets/navy/book11/thumbnail/page19.jpg"),
      require("@data/assets/navy/book11/thumbnail/page20.jpg"),
      require("@data/assets/navy/book11/thumbnail/page21.jpg"),
      require("@data/assets/navy/book11/thumbnail/page22.jpg"),
      require("@data/assets/navy/book11/thumbnail/page23.jpg"),
      require("@data/assets/navy/book11/thumbnail/page24.jpg"),
      require("@data/assets/navy/book11/thumbnail/page25.jpg"),
      require("@data/assets/navy/book11/thumbnail/page26.jpg"),
      require("@data/assets/navy/book11/thumbnail/page27.jpg"),
    ],
  },
  //12
  {
    key: "c6-12",
    title: "왜냐하면…",
    grade: "12권",
    cover: require("@data/assets/navy/book12/images/cover.jpg"),
    background: require("@data/assets/navy/book12/pages/page05.jpg"),
    song: {
      url: require("@data/assets/navy/book12/sounds/page23.mp3"),
      title: "Wèishénme?",
      caption: [
        "wèishénme wèishénme",
        "liú bítì yīnwèi wǒ liú bítì",
        "wèishénme wèishénme",
        "fāshāo yīnwèi wǒ fāshāo kuài huí jiā ba",
        "wèishénme wèishénme",
        "késou yīnwèi wǒ késou",
        "wèishénme wèishénme",
        "gǎnmào yīnwèi wǒ gǎnmào le kuài chī yào ba",
      ],
    },
    mov: {
      cn: "9c32ce342bd1b4eda311ca255088e98a_12",
      en: "6691bb04ceddb6b3165a60212f2bab06_12",
    },
    game: {
      resources: [
        {
          img: require("@data/assets/navy/book12/images/img_N12-02.png"),
          sound: require("@data/assets/navy/book12/sounds/KF12_W_01.mp3"),
          word: "流鼻涕|liú bítì",
        },
        {
          img: require("@data/assets/navy/book12/images/img_N12-01.png"),
          sound: require("@data/assets/navy/book12/sounds/KF12_W_02.mp3"),
          word: "发烧|fāshāo",
        },
        {
          img: require("@data/assets/navy/book12/images/img_N12-04.png"),
          sound: require("@data/assets/navy/book12/sounds/KF12_W_03.mp3"),
          word: "咳嗽|késou",
        },
        {
          img: require("@data/assets/navy/book12/images/img_N12-03.png"),
          sound: require("@data/assets/navy/book12/sounds/KF12_W_04.mp3"),
          word: "感冒|gǎnmào",
        },
        {
          img: require("@data/assets/navy/book12/images/img_N12-06.png"),
          sound: require("@data/assets/navy/book12/sounds/KF12_W_05.mp3"),
          word: "为什么？|Wèishénme?",
        },
        {
          img: require("@data/assets/navy/book12/images/img_N12-05.png"),
          sound: require("@data/assets/navy/book12/sounds/KF12_W_06.mp3"),
          word: "因为我发烧。|Yīnwèi wǒ fāshāo.",
        },
        {
          img: require("@data/assets/navy/book12/images/img_N12-08.png"),
          sound: require("@data/assets/navy/book12/sounds/KF12_W_07.mp3"),
          word: "因为你感冒了。|Yīnwèi nǐ gǎnmào le.",
        },
        {
          img: require("@data/assets/navy/book12/images/img_N12-07.png"),
          sound: require("@data/assets/navy/book12/sounds/KF12_W_08.mp3"),
          word: "因为我流鼻涕。|Yīnwèi wǒ liú bítì.",
        },
        {
          img: require("@data/assets/navy/book12/images/img_N12-10.png"),
          sound: require("@data/assets/navy/book12/sounds/KF12_W_09.mp3"),
          word: "因为我咳嗽。|Yīnwèi wǒ késou.",
        },
        {
          img: require("@data/assets/navy/book12/images/img_N12-09.png"),
          sound: require("@data/assets/navy/book12/sounds/KF12_W_10.mp3"),
          word: "怎么回事儿？|Zěnme huí shìr?",
        },
        {
          img: require("@data/assets/navy/book12/images/img_N12-12.png"),
          sound: require("@data/assets/navy/book12/sounds/KF12_W_11.mp3"),
          word: "再见!|Zàijiàn!",
        },
        {
          img: require("@data/assets/navy/book12/images/img_N12-11.png"),
          sound: require("@data/assets/navy/book12/sounds/KF12_W_12.mp3"),
          word: "知道了。|Zhīdào le.",
        },
        {
          img: require("@data/assets/navy/book12/images/img_N12-14.png"),
          sound: require("@data/assets/navy/book12/sounds/KF12_W_13.mp3"),
          word: "我来吧!|Wǒ lái ba!",
        },
        {
          img: require("@data/assets/navy/book12/images/img_N12-13.png"),
          sound: require("@data/assets/navy/book12/sounds/KF12_W_14.mp3"),
          word: "你回家吧!|Nǐ huí jiā ba!",
        },
      ],
    },
    word: [
      {
        img: require("@data/assets/navy/book12/images/img_N12-02.png"),
        sound: require("@data/assets/navy/book12/sounds/KF12_W_01.mp3"),
        buttons: [
          { ch2: "liú bítì" },
          { ch: "流鼻涕" },
          { ko: "콧물이 흐르다" },
        ],
      },
      {
        img: require("@data/assets/navy/book12/images/img_N12-01.png"),
        sound: require("@data/assets/navy/book12/sounds/KF12_W_02.mp3"),
        buttons: [{ ch2: "fāshāo" }, { ch: "发烧" }, { ko: "열이 나다" }],
      },
      {
        img: require("@data/assets/navy/book12/images/img_N12-04.png"),
        sound: require("@data/assets/navy/book12/sounds/KF12_W_03.mp3"),
        buttons: [{ ch2: "késou" }, { ch: "咳嗽" }, { ko: "기침이 나다" }],
      },
      {
        img: require("@data/assets/navy/book12/images/img_N12-03.png"),
        sound: require("@data/assets/navy/book12/sounds/KF12_W_04.mp3"),
        buttons: [{ ch2: "gǎnmào" }, { ch: "感冒" }, { ko: "감기에 걸리다" }],
      },
    ],
    idiom: [
      {
        img: require("@data/assets/navy/book12/images/img_N12-06.png"),
        sound: require("@data/assets/navy/book12/sounds/KF12_W_05.mp3"),
        buttons: [{ ch2: "Wèishénme?" }, { ch: "为什么？" }, { ko: "왜?" }],
      },
      {
        img: require("@data/assets/navy/book12/images/img_N12-05.png"),
        sound: require("@data/assets/navy/book12/sounds/KF12_W_06.mp3"),
        buttons: [
          { ch2: "Yīnwèi wǒ fāshāo." },
          { ch: "因为我发烧。" },
          { ko: "내가 열이 나기 때문이야." },
        ],
      },
      {
        img: require("@data/assets/navy/book12/images/img_N12-08.png"),
        sound: require("@data/assets/navy/book12/sounds/KF12_W_07.mp3"),
        buttons: [
          { ch2: "Yīnwèi nǐ gǎnmào le." },
          { ch: "因为你感冒了。" },
          { ko: "네가 감기에 걸렸기 때문이야." },
        ],
      },
      {
        img: require("@data/assets/navy/book12/images/img_N12-07.png"),
        sound: require("@data/assets/navy/book12/sounds/KF12_W_08.mp3"),
        buttons: [
          { ch2: "Yīnwèi wǒ liú bítì." },
          { ch: "因为我流鼻涕。" },
          { ko: "내가 콧물이 흐르기 때문이야." },
        ],
      },
      {
        img: require("@data/assets/navy/book12/images/img_N12-10.png"),
        sound: require("@data/assets/navy/book12/sounds/KF12_W_09.mp3"),
        buttons: [
          { ch2: "Yīnwèi wǒ késou." },
          { ch: "因为我咳嗽。" },
          { ko: "내가 기침이 나기 때문이야." },
        ],
      },
      {
        img: require("@data/assets/navy/book12/images/img_N12-09.png"),
        sound: require("@data/assets/navy/book12/sounds/KF12_W_10.mp3"),
        buttons: [
          { ch2: "Zěnme huí shìr?" },
          { ch: "怎么回事儿？" },
          { ko: "어떻게 된 일이야?" },
        ],
      },
      {
        img: require("@data/assets/navy/book12/images/img_N12-12.png"),
        sound: require("@data/assets/navy/book12/sounds/KF12_W_11.mp3"),
        buttons: [{ ch2: "Zàijiàn!" }, { ch: "再见!" }, { ko: "잘 가!" }],
      },
      {
        img: require("@data/assets/navy/book12/images/img_N12-11.png"),
        sound: require("@data/assets/navy/book12/sounds/KF12_W_12.mp3"),
        buttons: [{ ch2: "Zhīdào le." }, { ch: "知道了。" }, { ko: "알겠어." }],
      },
      {
        img: require("@data/assets/navy/book12/images/img_N12-14.png"),
        sound: require("@data/assets/navy/book12/sounds/KF12_W_13.mp3"),
        buttons: [
          { ch2: "Wǒ lái ba!" },
          { ch: "我来吧!" },
          { ko: "내가 할게!" },
        ],
      },
      {
        img: require("@data/assets/navy/book12/images/img_N12-13.png"),
        sound: require("@data/assets/navy/book12/sounds/KF12_W_14.mp3"),
        buttons: [
          { ch2: "Nǐ huí jiā ba!" },
          { ch: "你回家吧!" },
          { ko: "넌 집에 가!" },
        ],
      },
    ],
    activity: {
      questions: [
        {
          type: "ty1",
          sound: require("@data/assets/navy/book12/sounds/KF12_W_02.mp3"),
          img: require("@data/assets/navy/book12/images/img_N12-02.png"),
          answer: {
            O: false,
            X: true,
          },
        },
        {
          type: "ty2",
          sound: require("@data/assets/navy/book12/sounds/KF12_W_09.mp3"),
          answer: [
            [require("@data/assets/navy/book12/images/img_N12-05.png"), false],
            [require("@data/assets/navy/book12/images/img_N12-10.png"), true],
          ],
        },
        {
          type: "ty3",
          sound: require("@data/assets/navy/book12/sounds/KF12_W_12.mp3"),
          answer: [
            ["知道了。", true],
            ["我来吧!", false],
          ],
        },
      ],
    },
    pages: [
      {
        book: require("@data/assets/navy/book12/pages/front.jpg"),
        sound: require("@data/assets/navy/book12/sounds/cover.mp3"),
      },

      {
        book: require("@data/assets/navy/book12/pages/page02.jpg"),
      },
      {
        book: require("@data/assets/navy/book12/pages/page03.jpg"),
      },
      {
        book: require("@data/assets/navy/book12/pages/page04.jpg"),
        sound: require("@data/assets/navy/book12/sounds/page04.mp3"),
      },
      {
        book: require("@data/assets/navy/book12/pages/page05.jpg"),
      },
      {
        book: require("@data/assets/navy/book12/pages/page06.jpg"),
        sound: require("@data/assets/navy/book12/sounds/page06.mp3"),
      },
      {
        book: require("@data/assets/navy/book12/pages/page07.jpg"),
      },
      {
        book: require("@data/assets/navy/book12/pages/page08.jpg"),
        sound: require("@data/assets/navy/book12/sounds/page08.mp3"),
      },
      {
        book: require("@data/assets/navy/book12/pages/page09.jpg"),
      },
      {
        book: require("@data/assets/navy/book12/pages/page10.jpg"),
        sound: require("@data/assets/navy/book12/sounds/page10.mp3"),
      },
      {
        book: require("@data/assets/navy/book12/pages/page11.jpg"),
      },
      {
        book: require("@data/assets/navy/book12/pages/page12.jpg"),
        sound: require("@data/assets/navy/book12/sounds/page12.mp3"),
      },
      {
        book: require("@data/assets/navy/book12/pages/page13.jpg"),
      },
      {
        book: require("@data/assets/navy/book12/pages/page14.jpg"),
        sound: require("@data/assets/navy/book12/sounds/page14.mp3"),
      },
      {
        book: require("@data/assets/navy/book12/pages/page15.jpg"),
      },
      {
        book: require("@data/assets/navy/book12/pages/page16.jpg"),
        sound: require("@data/assets/navy/book12/sounds/page16.mp3"),
      },
      {
        book: require("@data/assets/navy/book12/pages/page17.jpg"),
      },
      {
        book: require("@data/assets/navy/book12/pages/page18.jpg"),
        sound: require("@data/assets/navy/book12/sounds/page18.mp3"),
      },
      {
        book: require("@data/assets/navy/book12/pages/page19.jpg"),
      },
      {
        book: require("@data/assets/navy/book12/pages/page20.jpg"),
        sound: require("@data/assets/navy/book12/sounds/page20.mp3"),
      },
      {
        book: require("@data/assets/navy/book12/pages/page21.jpg"),
      },
      {
        book: require("@data/assets/navy/book12/pages/page22.jpg"),
        sound: require("@data/assets/navy/book12/sounds/page22.mp3"),
      },
      {
        book: require("@data/assets/navy/book12/pages/page23.jpg"),
        sound: require("@data/assets/navy/book12/sounds/page23.mp3"),
      },
      {
        book: require("@data/assets/navy/book12/pages/page24.jpg"),
      },
      {
        book: require("@data/assets/navy/book12/pages/page25.jpg"),
      },
      {
        book: require("@data/assets/navy/book12/pages/page26.jpg"),
      },
      {
        book: require("@data/assets/navy/book12/pages/page27.jpg"),
      },
    ],
    thumbnail: [
      require("@data/assets/navy/book12/thumbnail/front.jpg"),
      require("@data/assets/navy/book12/thumbnail/page02.jpg"),
      require("@data/assets/navy/book12/thumbnail/page03.jpg"),
      require("@data/assets/navy/book12/thumbnail/page04.jpg"),
      require("@data/assets/navy/book12/thumbnail/page05.jpg"),
      require("@data/assets/navy/book12/thumbnail/page06.jpg"),
      require("@data/assets/navy/book12/thumbnail/page07.jpg"),
      require("@data/assets/navy/book12/thumbnail/page08.jpg"),
      require("@data/assets/navy/book12/thumbnail/page09.jpg"),
      require("@data/assets/navy/book12/thumbnail/page10.jpg"),
      require("@data/assets/navy/book12/thumbnail/page11.jpg"),
      require("@data/assets/navy/book12/thumbnail/page12.jpg"),
      require("@data/assets/navy/book12/thumbnail/page13.jpg"),
      require("@data/assets/navy/book12/thumbnail/page14.jpg"),
      require("@data/assets/navy/book12/thumbnail/page15.jpg"),
      require("@data/assets/navy/book12/thumbnail/page16.jpg"),
      require("@data/assets/navy/book12/thumbnail/page17.jpg"),
      require("@data/assets/navy/book12/thumbnail/page18.jpg"),
      require("@data/assets/navy/book12/thumbnail/page19.jpg"),
      require("@data/assets/navy/book12/thumbnail/page20.jpg"),
      require("@data/assets/navy/book12/thumbnail/page21.jpg"),
      require("@data/assets/navy/book12/thumbnail/page22.jpg"),
      require("@data/assets/navy/book12/thumbnail/page23.jpg"),
      require("@data/assets/navy/book12/thumbnail/page24.jpg"),
      require("@data/assets/navy/book12/thumbnail/page25.jpg"),
      require("@data/assets/navy/book12/thumbnail/page26.jpg"),
      require("@data/assets/navy/book12/thumbnail/page27.jpg"),
    ],
  },
];
